import { getPathPropsInterface } from '../../../interfaces/commonInterfaces';

const getPath = (name: string, props: getPathPropsInterface) => {
  const { fill, stroke, iconprimary } = props;
  switch (name) {
    case 'time-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M14.715 6.633a6.186 6.186 0 1 0-11.43 4.734 6.186 6.186 0 0 0 11.43-4.734ZM6.203 2.246a7.31 7.31 0 1 0 5.595 13.51 7.31 7.31 0 0 0-5.595-13.51Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M8.788 5.427c.31 0 .563.252.563.562v3.173l2.472 1.507a.562.562 0 1 1-.586.96L8.495 9.959a.562.562 0 0 1-.27-.48V5.989c0-.31.252-.562.563-.562Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'settings-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M8.356 1.713c-.448.066-.908.414-1.112.844-.084.177-.114.29-.147.56-.048.39-.069.423-.314.515-.243.092-.345.069-.589-.132a2.096 2.096 0 0 0-.334-.23 1.613 1.613 0 0 0-1.403.022c-.206.109-1.056.959-1.165 1.165a1.59 1.59 0 0 0-.008 1.42c.041.082.144.23.228.333.188.225.21.333.12.573-.092.245-.125.266-.515.314-.269.033-.383.063-.56.147-.443.21-.777.66-.846 1.14a6.65 6.65 0 0 0 0 1.23c.07.48.403.932.846 1.142.177.084.291.114.56.147.388.048.423.069.512.307.102.273.091.317-.173.65-.07.09-.16.229-.198.309-.196.407-.182.963.034 1.374.11.206.96 1.056 1.165 1.165a1.59 1.59 0 0 0 1.418.009c.08-.04.228-.143.33-.228.227-.19.336-.212.578-.121.237.089.27.134.3.428.054.506.17.772.463 1.066.347.346.686.455 1.424.457.79 0 1.126-.104 1.487-.465.271-.271.392-.536.438-.958.042-.38.075-.436.312-.524.272-.102.33-.09.611.14.505.41 1.173.486 1.725.196.206-.11 1.056-.96 1.165-1.165a1.59 1.59 0 0 0 .008-1.421 2.284 2.284 0 0 0-.228-.332c-.188-.225-.21-.333-.12-.573.092-.245.125-.266.515-.314.445-.055.701-.172.975-.445.356-.356.46-.687.46-1.458 0-.766-.106-1.103-.46-1.457-.272-.272-.54-.394-.969-.443-.389-.044-.428-.068-.518-.31-.102-.273-.09-.317.173-.65a1.54 1.54 0 0 0 .29-1.354c-.082-.315-.182-.456-.673-.947-.5-.5-.637-.596-.964-.673-.516-.122-.98-.008-1.402.345-.23.192-.349.217-.587.12-.239-.097-.257-.128-.305-.514-.033-.27-.063-.383-.147-.56a1.545 1.545 0 0 0-1.14-.846 7.352 7.352 0 0 0-1.26.002ZM9.57 2.858c.14.07.196.2.235.534.07.583.338.963.86 1.212.328.157.484.196.772.196.386-.001.712-.124 1.03-.388.334-.278.424-.258.891.202.482.475.512.59.235.918-.254.29-.394.662-.392 1.048 0 .25.065.493.213.794.236.484.625.753 1.182.819.551.066.585.112.585.8 0 .7-.026.739-.545.806-.424.055-.694.177-.94.423-.185.184-.375.537-.45.832a1.57 1.57 0 0 0 .343 1.409c.281.332.253.446-.23.923-.468.46-.565.482-.896.2-.587-.497-1.362-.516-2.059-.05-.338.227-.545.598-.605 1.088-.042.342-.073.415-.207.497-.085.052-.154.059-.59.059-.439 0-.507-.007-.592-.06-.14-.084-.18-.17-.203-.42-.057-.643-.324-1.044-.87-1.304-.328-.157-.484-.196-.772-.196-.386 0-.712.124-1.029.388-.198.166-.319.205-.473.154-.129-.042-.789-.704-.818-.82-.036-.143.011-.274.162-.452.343-.406.472-.93.35-1.416-.076-.295-.266-.648-.45-.832-.247-.247-.517-.368-.943-.423-.315-.041-.35-.052-.435-.137l-.093-.093V8.43l.093-.093c.085-.085.12-.096.435-.137.426-.055.696-.176.943-.423.184-.184.374-.537.45-.832a1.57 1.57 0 0 0-.344-1.41c-.157-.184-.204-.314-.168-.458.03-.116.69-.778.818-.82.156-.052.28-.012.475.154a1.57 1.57 0 0 0 1.41.343c.294-.075.647-.265.831-.45.247-.246.368-.516.423-.94.046-.355.092-.454.244-.516.1-.042 1.04-.034 1.124.009ZM8.805 6.2c-.994.089-1.81.614-2.265 1.459-.24.443-.337.83-.337 1.34 0 .512.097.899.338 1.345.267.495.621.848 1.118 1.116.443.24.831.337 1.341.337.512 0 .897-.097 1.347-.34a2.824 2.824 0 0 0 1.4-1.88c.058-.276.065-.813.014-1.087-.102-.55-.424-1.15-.816-1.517-.392-.368-.935-.647-1.42-.728a3.638 3.638 0 0 0-.72-.045Zm.63 1.166c.276.072.521.218.751.448.345.345.494.703.494 1.186s-.149.84-.494 1.186c-.345.345-.703.494-1.186.494s-.84-.15-1.186-.494C7.47 9.84 7.32 9.483 7.32 9s.15-.841.494-1.186c.226-.225.473-.375.74-.447.215-.058.66-.058.88-.001Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'new-three-dots-vertical-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M7.504 14.258a1.496 1.496 0 0 1 1.495-1.504c.829 0 1.505.67 1.505 1.5 0 .827-.673 1.5-1.5 1.5a1.502 1.502 0 0 1-1.5-1.496ZM7.504 9.008a1.495 1.495 0 0 1 1.495-1.504c.829 0 1.505.67 1.505 1.5 0 .827-.673 1.5-1.5 1.5a1.502 1.502 0 0 1-1.5-1.496ZM7.504 3.758a1.495 1.495 0 0 1 1.495-1.504c.829 0 1.505.67 1.505 1.5 0 .827-.673 1.5-1.5 1.5a1.502 1.502 0 0 1-1.5-1.496Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'three-dots-horizontal-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M7.5 9a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM12.75 9a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM2.25 9a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'plus-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M9 3.43c.312 0 .565.254.565.566v10.008a.565.565 0 0 1-1.13 0V3.996c0-.312.253-.565.565-.565Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M14.569 9a.565.565 0 0 1-.566.565H3.997a.565.565 0 0 1 0-1.13h10.008c.312 0 .565.253.565.565Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'mobile-home-plus-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M2 11.914c0-.505.41-.914.914-.914h17.672a.914.914 0 1 1 0 1.828H2.914A.914.914 0 0 1 2 11.914Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M12 2.25c.505 0 .914.41.914.914v17.672a.914.914 0 1 1-1.828 0V3.164c0-.505.41-.914.914-.914Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'updated-file-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M3.594 2.234a1.873 1.873 0 0 1 1.325-.548h5.442c.136 0 .266.054.362.15l4.082 4.081c.096.096.15.227.15.363v8.163a1.873 1.873 0 0 1-1.873 1.873H4.919a1.873 1.873 0 0 1-1.873-1.873V3.559c0-.497.197-.974.548-1.325Zm1.325.476a.848.848 0 0 0-.848.849v10.884a.848.848 0 0 0 .848.848h8.163a.848.848 0 0 0 .848-.848V6.492L10.149 2.71h-5.23Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M10.36 1.686c.284 0 .513.229.513.512v3.57h3.57a.512.512 0 1 1 0 1.024H10.36a.512.512 0 0 1-.513-.512V2.198c0-.283.23-.512.513-.512Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'google-drive-icon':
      return (
        <>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M10.594 8.98 5.48 0h5.038l5.112 8.98h-5.037Zm-4.297.75-2.519 4.492h9.703L16 9.73H6.297ZM0 9.73l4.816-8.606 2.59 4.489-4.887 8.61L0 9.73Z'
            fill={fill}
          />
        </>
      );
    case 'dropbox-icon':
      return (
        <>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='m9.014 4.823-4.5 2.822 4.5 2.823-4.5 2.822L0 10.44l4.51-2.822L0 4.823 4.51 2l4.504 2.823Zm-4.528 9.354 4.5-2.822 4.5 2.822L8.986 17l-4.5-2.822Zm9.028-6.559-4.5 2.823 4.476 2.846L18 10.464l-4.51-2.819L18 4.823 13.49 2 9.014 4.82l4.5 2.798Z'
            fill={fill}
          />
        </>
      );
    case 'onedrive-icon':
      return (
        <>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M8.243 4.344C8.727 4.137 9.2 4 9.823 4c1.73 0 3.188 1.104 3.742 2.686.138.343.138.61 0 .472-.07 0-.333.08-.54.15l-.434.13-.346-.344c-1.038-1.032-2.764-1.225-4.218-.537A3.364 3.364 0 0 0 6.642 7.78c-.208.344-.541 1.04-.541 1.246 0 .137-.146.207-.562.344-1.385.48-2.142 1.445-2.142 2.75 0 .48.143 1.031.281 1.375.07.137.065.28.065.28-.07.07-1.739.07-1.947 0-.622-.207-1.233-.758-1.58-1.376C.008 12.057 0 11.987 0 11.37v-.088c0-.48 0-.62.13-.88.276-.687.909-1.103 1.6-1.31.21 0 .347-.06.347-.13.066 0 .065-.193.065-.387v-.042c.07-1.238.9-2.406 2.077-2.75.622-.207 1.39-.12 2.012.086.094.047.148.076.198.07.096-.012.175-.157.494-.564.276-.344.836-.824 1.32-1.031Zm-.065 3.029c.554-.274.887-.344 1.58-.344.968 0 1.535.21 2.228.967l.41.408.347-.215c1.73-.55 3.388.414 3.526 2.063l.065.494.346.129c.968.344 1.393 1.031 1.255 2.063-.07.687-.424 1.251-.909 1.525l-.194.129h-6.16c-3.445 0-4.596 0-4.852-.065-1.039-.206-1.666-1.103-1.666-2.341v-.066c0-.37 0-.555.13-.75.276-.618.917-1.105 1.817-1.311.417-.07.54-.202.54-.409 0-.056.054-.209.111-.375l.041-.119c.276-.824.83-1.509 1.385-1.783Z'
            fill={fill}
          />
        </>
      );
    case 'up-arrow-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M8.602 6.602c.22-.22.576-.22.796 0l4 4a.562.562 0 1 1-.796.796L9 7.795l-3.602 3.603a.562.562 0 1 1-.796-.796l4-4Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'down-arrow-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M4.18 6.426a.622.622 0 0 1 .866 0L9 10.3l3.954-3.874a.622.622 0 0 1 .866 0c.24.234.24.615 0 .85l-4.387 4.298a.622.622 0 0 1-.866 0L4.18 7.275a.592.592 0 0 1 0-.85Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'updated-right-arrow-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M6.602 4.602c.22-.22.576-.22.796 0l4 4c.22.22.22.576 0 .796l-4 4a.562.562 0 1 1-.796-.796L10.204 9 6.602 5.398a.563.563 0 0 1 0-.796Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'updated-large-right-arrow-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M5.227 1.857c.22-.22.578-.22.798 0l6.75 6.75c.221.22.221.578 0 .798l-6.75 6.751a.564.564 0 0 1-.798-.798l6.351-6.352-6.351-6.351a.564.564 0 0 1 0-.798Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'new-close-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M3.6 3.6c.22-.22.578-.22.8 0l10 10a.565.565 0 0 1-.8.8l-10-10a.565.565 0 0 1 0-.8Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M14.4 3.6c.22.22.22.578 0 .8l-10 10a.565.565 0 0 1-.8-.8l10-10c.22-.22.578-.22.8 0Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'invoice-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M5.356 11.907c0-.312.253-.565.565-.565h4.17a.565.565 0 0 1 0 1.13h-4.17a.565.565 0 0 1-.565-.565ZM5.356 8.83c0-.312.253-.565.565-.565h6.594a.565.565 0 0 1 0 1.13H5.92a.565.565 0 0 1-.565-.565Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M14.366 1.726A1.334 1.334 0 0 1 15.72 3.06V14.6a1.334 1.334 0 0 1-1.931 1.193l-.594-.297a.205.205 0 0 0-.183 0l-1.362.681a1.335 1.335 0 0 1-1.194 0l-1.364-.681a.204.204 0 0 0-.182 0l-1.364.68a1.333 1.333 0 0 1-1.194.001l-1.364-.681a.204.204 0 0 0-.182 0l-.593.296A1.334 1.334 0 0 1 2.281 14.6V3.06a1.334 1.334 0 0 1 1.317-1.333h10.767Zm.127 1.16a.204.204 0 0 0-.111-.03H3.61a.204.204 0 0 0-.2.204V14.6a.204.204 0 0 0 .296.182l.593-.297a1.332 1.332 0 0 1 1.194 0l1.363.681a.204.204 0 0 0 .182 0l1.364-.68s0-.001 0 0a1.333 1.333 0 0 1 1.194-.001l1.364.681a.205.205 0 0 0 .183 0l1.362-.681a1.334 1.334 0 0 1 1.194 0l.594.297a.205.205 0 0 0 .296-.183V3.06a.204.204 0 0 0-.097-.173Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M5.433 6c0-.312.253-.565.565-.565h6.431a.565.565 0 0 1 0 1.13H5.998A.565.565 0 0 1 5.433 6Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'time-stop-icon':
      return (
        <>
          <g fillRule='evenodd' clipPath='url(#clip0_2196_88189)' clipRule='evenodd'>
            <path
              fill='var(--accent-success)'
              d='M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z'
            />
            <path
              fill='var(--text-white)'
              d='M11.616 16.748c-.983.784-2.435.084-2.435-1.173V8.117c0-1.268 1.474-1.964 2.453-1.158l4.603 3.789a1.5 1.5 0 0 1-.019 2.33l-4.602 3.67Z'
            />
          </g>
          <defs>
            <clipPath id='clip0_2196_88189'>
              <path fill='var(--text-white)' d='M0 0h24v24H0z' />
            </clipPath>
          </defs>
        </>
      );
    case 'time-start-icon':
      return (
        <>
          <g clipPath='url(#clip0_51947_31183)'>
            <path
              fill={fill}
              fillRule='evenodd'
              d='M12 24.5c6.627 0 12-5.373 12-12S18.627.5 12 .5 0 5.873 0 12.5s5.373 12 12 12Z'
              clipRule='evenodd'
            />
            <path
              fill='var(--text-white)'
              d='M8 10.786A2.286 2.286 0 0 1 10.286 8.5h3.428A2.286 2.286 0 0 1 16 10.786v3.428a2.286 2.286 0 0 1-2.286 2.286h-3.428A2.286 2.286 0 0 1 8 14.214v-3.428Z'
            />
          </g>
          <defs>
            <clipPath id='clip0_51947_31183'>
              <path fill='var(--text-white)' d='M0 .5h24v24H0z' />
            </clipPath>
          </defs>
        </>
      );
    case 'edit-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M10.726 2.111a1.314 1.314 0 0 1 1.86 0l1.052 1.052a1.315 1.315 0 0 1 0 1.86L5.513 13.15a.565.565 0 0 1-.4.166H3a.565.565 0 0 1-.565-.566v-2.113c0-.15.06-.294.165-.4l8.126-8.124Zm1.06.799a.184.184 0 0 0-.26 0l-7.961 7.96v1.315h1.314l7.96-7.96a.185.185 0 0 0 0-.263L11.787 2.91ZM1.685 15.75c0-.313.253-.565.565-.565h13.5a.565.565 0 1 1 0 1.13H2.25a.565.565 0 0 1-.565-.565Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M9.387 3.448c.22-.22.579-.22.8 0L12.3 5.563a.565.565 0 0 1-.799.799L9.387 4.247a.565.565 0 0 1 0-.8Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'lock-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M5.25 8.063A.937.937 0 0 0 4.312 9v5.25c0 .518.42.938.938.938h7.5c.518 0 .938-.42.938-.938V9a.937.937 0 0 0-.938-.938h-7.5ZM3.187 9c0-1.14.924-2.063 2.063-2.063h7.5c1.14 0 2.063.924 2.063 2.063v5.25c0 1.14-.924 2.063-2.063 2.063h-7.5a2.062 2.062 0 0 1-2.063-2.063V9Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M9 2.813A2.438 2.438 0 0 0 6.562 5.25V7.5a.563.563 0 0 1-1.125 0V5.25a3.563 3.563 0 0 1 7.125 0V7.5a.562.562 0 1 1-1.124 0V5.25A2.438 2.438 0 0 0 9 2.812Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'calendar-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M12 .938c.31 0 .563.251.563.562v3a.562.562 0 1 1-1.126 0v-3c0-.31.252-.563.563-.563ZM6 .938c.31 0 .563.251.563.562v3a.563.563 0 0 1-1.125 0v-3c0-.31.251-.563.562-.563ZM1.688 6.75c0-.31.251-.563.562-.563h13.5a.562.562 0 1 1 0 1.125H2.25a.563.563 0 0 1-.563-.562Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M1.688 4.5c0-1.14.923-2.063 2.062-2.063h10.5c1.14 0 2.063.924 2.063 2.063v9.75c0 1.14-.924 2.063-2.063 2.063H3.75a2.062 2.062 0 0 1-2.063-2.063V4.5Zm2.062-.938a.937.937 0 0 0-.938.938v9.75c0 .518.42.938.938.938h10.5c.518 0 .938-.42.938-.938V4.5a.937.937 0 0 0-.938-.938H3.75Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M4.688 9.75c0-.31.251-.563.562-.563h7.5a.562.562 0 1 1 0 1.126h-7.5a.562.562 0 0 1-.563-.563ZM4.688 12.75c0-.31.251-.563.562-.563h7.5a.562.562 0 1 1 0 1.126h-7.5a.562.562 0 0 1-.563-.563Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'globe-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M8.438 2.25c0-.31.251-.563.562-.563A7.302 7.302 0 0 1 16.313 9 7.301 7.301 0 0 1 9 16.313a.562.562 0 1 1 0-1.125A6.177 6.177 0 0 0 15.188 9 6.177 6.177 0 0 0 9 2.812a.563.563 0 0 1-.563-.562Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M9 2.813A6.177 6.177 0 0 0 2.812 9 6.177 6.177 0 0 0 9 15.188a.562.562 0 1 1 0 1.124A7.302 7.302 0 0 1 1.687 9 7.302 7.302 0 0 1 9 1.687a.563.563 0 0 1 0 1.125Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M7.143 2.756a2.148 2.148 0 0 1 3.714 0c2.274 3.796 2.274 8.692 0 12.489M7.143 2.755c-2.274 3.798-2.274 8.693 0 12.49a2.148 2.148 0 0 0 3.714 0M9.892 3.334a1.023 1.023 0 0 0-1.784 0c-2.06 3.44-2.06 7.892 0 11.332a1.023 1.023 0 0 0 1.784 0c2.06-3.44 2.06-7.891 0-11.332Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M15.244 7.143a2.148 2.148 0 0 1 0 3.714c-3.797 2.274-8.692 2.274-12.49 0m12.49-3.714c-3.797-2.274-8.692-2.274-12.49 0a2.148 2.148 0 0 0 0 3.714m11.912-.965a1.023 1.023 0 0 0 0-1.784c-3.441-2.06-7.892-2.06-11.333 0a1.023 1.023 0 0 0 0 1.784c3.44 2.06 7.892 2.06 11.332 0Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'invoice-details-header-print-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M6 2.813A.188.188 0 0 0 5.812 3v3a.563.563 0 0 1-1.125 0V3c0-.725.588-1.313 1.313-1.313h6c.725 0 1.313.588 1.313 1.313v3a.562.562 0 1 1-1.126 0V3A.188.188 0 0 0 12 2.812H6Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M3.75 6.563a.937.937 0 0 0-.938.937v3.75c0 .518.42.938.938.938h1.5a.562.562 0 1 1 0 1.124h-1.5a2.062 2.062 0 0 1-2.063-2.062V7.5c0-1.14.924-2.063 2.063-2.063h10.5c1.14 0 2.063.924 2.063 2.063v3.75c0 1.14-.924 2.063-2.063 2.063h-1.5a.562.562 0 1 1 0-1.126h1.5c.518 0 .938-.419.938-.937V7.5a.937.937 0 0 0-.938-.938H3.75Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M4.688 10.35c0-.311.251-.563.562-.563h7.5c.31 0 .563.252.563.563V15c0 .724-.588 1.312-1.313 1.312H6A1.313 1.313 0 0 1 4.687 15v-4.65Zm1.125.562V15c0 .103.084.187.187.187h6a.188.188 0 0 0 .188-.187v-4.088H5.811ZM4.688 8.25c0-.31.251-.563.562-.563H6a.563.563 0 0 1 0 1.125h-.75a.563.563 0 0 1-.563-.562Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'updated-delete-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M5.593 3.935h-2.22a.563.563 0 0 0 0 1.125h11.254a.562.562 0 1 0 0-1.125h-2.22M4.499 6.186c.31 0 .562.252.562.563v7.503c0 .518.42.938.938.938h6.003c.518 0 .938-.42.938-.938V6.749a.562.562 0 1 1 1.125 0v7.503c0 1.14-.924 2.063-2.063 2.063H5.999a2.063 2.063 0 0 1-2.063-2.063V6.749c0-.311.252-.563.563-.563Zm3 .75c.311 0 .563.252.563.563v5.252a.563.563 0 0 1-1.125 0V7.5c0-.31.252-.563.563-.563Zm3.002 0c.31 0 .563.252.563.563v5.252a.563.563 0 0 1-1.125 0V7.5c0-.31.252-.563.562-.563ZM6.942 3.452a.936.936 0 0 1 .889-.64h2.339c.402 0 .76.257.888.64l.16.483h1.189l-.277-.84a2.066 2.066 0 0 0-1.96-1.413H7.832'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M11.06 3.452a.937.937 0 0 0-.89-.64H7.83a.935.935 0 0 0-.886.64l-.161.483h-1.19l.279-.84a2.066 2.066 0 0 1 1.96-1.413h2.338'
            clipRule='evenodd'
          />
        </>
      );
    case 'today-icon':
      return (
        <>
          <path
            d='M6 4h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Zm0 1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H6Zm10 12a1 1 0 1 1 0-2 1 1 0 0 1 0 2ZM7 8h10a.5.5 0 0 1 0 1H7a.5.5 0 1 1 0-1Z'
            fill={fill}
          />
        </>
      );
    case 'tomorrow-icon':
      return (
        <>
          <path opacity={0.1} d='M12 15.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z' fill={fill} />
          <path
            d='M9.704 17.543a.5.5 0 0 1 .27.654l-.956 2.31a.5.5 0 1 1-.924-.383l.957-2.31a.5.5 0 0 1 .653-.27v-.001Zm5.245.27.957 2.31a.5.5 0 0 1-.924.383l-.956-2.31a.5.5 0 0 1 .923-.382v-.001ZM12 7.5a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9Zm-5.543 6.796a.5.5 0 0 1-.27.653l-2.31.957a.499.499 0 0 1-.653-.653.5.5 0 0 1 .27-.271l2.31-.956a.5.5 0 0 1 .653.27Zm11.74-.27 2.31.956a.5.5 0 0 1-.383.924l-2.31-.957a.5.5 0 0 1 .383-.923ZM12 8.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Zm-8.124-.406 2.31.957a.5.5 0 0 1-.383.923l-2.31-.956a.5.5 0 1 1 .383-.924Zm16.9.27a.501.501 0 0 1-.27.654l-2.31.956a.5.5 0 0 1-.382-.923l2.31-.957a.5.5 0 0 1 .653.27ZM9.02 3.495l.956 2.31a.5.5 0 0 1-.923.382l-.957-2.31a.5.5 0 1 1 .924-.382Zm6.617-.27a.5.5 0 0 1 .271.652l-.957 2.31a.5.5 0 0 1-.923-.383l.956-2.31a.5.5 0 0 1 .653-.27v.001Z'
            fill={fill}
          />
        </>
      );
    case 'next-week-icon':
      return (
        <>
          <path opacity={0.1} d='M6 4.5h12A1.5 1.5 0 0 1 19.5 6v2.5h-15V6A1.5 1.5 0 0 1 6 4.5Z' fill={fill} />
          <path
            d='M18 4a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h12Zm0 1H6a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1Zm-2.109 8.188.007.01-.004-.005-.003-.005ZM17 8a.5.5 0 0 1 0 1H7a.5.5 0 1 1 0-1h10Zm-1 5.52a.503.503 0 0 1-.023.131l-.015.04a.496.496 0 0 1-.05.093l-.014.018a.504.504 0 0 1-.033.04l-2.511 2.512a.5.5 0 0 1-.765-.638l.057-.07L14.292 14H8.5a.5.5 0 0 1-.492-.41L8 13.5a.5.5 0 0 1 .41-.492L8.5 13h5.792l-1.646-1.646a.5.5 0 0 1 .638-.765l.07.057 2.511 2.513.017.019.009.01-.027-.03.03.035.029.04a.52.52 0 0 1 .066.162l.008.052v.007l-.002-.026.005.072v.02Z'
            fill={fill}
          />
        </>
      );
    case 'no-date-icon':
      return (
        <>
          <path
            d='M12 3a9 9 0 1 1 0 18.001A9 9 0 0 1 12 3Zm0 1a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm3.854 4.146a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708-.708l7-7a.499.499 0 0 1 .708 0Z'
            fill={fill}
          />
        </>
      );
    case 'filescreen-dropdown-folder-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M.842 3.563a1.98 1.98 0 0 1 1.981-1.981h3.306c.412 0 .795.204 1.026.542l1.04 1.528a.238.238 0 0 0 .196.104h4.785c1.095 0 1.981.887 1.981 1.981v6.7a1.98 1.98 0 0 1-1.98 1.981H2.822a1.98 1.98 0 0 1-1.981-1.981V3.563Zm1.981-.977a.976.976 0 0 0-.977.977v8.874c0 .54.437.977.977.977h10.353c.54 0 .977-.437.977-.977v-6.7a.977.977 0 0 0-.977-.977H8.391c-.411 0-.796-.203-1.027-.544L6.325 2.69a.238.238 0 0 0-.196-.104H2.823Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'upload-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M2 9.498c.277 0 .502.225.502.502v2.667a.831.831 0 0 0 .831.83h9.334a.831.831 0 0 0 .83-.83V10a.502.502 0 0 1 1.005 0v2.667a1.835 1.835 0 0 1-1.835 1.835H3.333a1.835 1.835 0 0 1-1.835-1.835V10c0-.277.225-.502.502-.502ZM7.644 1.645a.502.502 0 0 1 .71 0l3.334 3.333a.502.502 0 1 1-.71.71L7.999 2.71 5.021 5.688a.502.502 0 0 1-.71-.71l3.333-3.333Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M8 1.498c.277 0 .502.225.502.502v8a.502.502 0 1 1-1.004 0V2c0-.277.225-.502.502-.502Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'modal-dropbox-icon':
      return (
        <>
          <path
            d='M9.552 11.063 4.828 7.986a.42.42 0 0 0-.494.026l-3.176 2.582a.43.43 0 0 0 .036.692l4.723 3.077c.154.1.353.089.495-.027l3.176-2.58a.43.43 0 0 0-.036-.693ZM10.841 11.755l3.176 2.581a.42.42 0 0 0 .495.027l4.723-3.077a.43.43 0 0 0 .037-.692l-3.176-2.582a.42.42 0 0 0-.495-.026l-4.724 3.077a.43.43 0 0 0-.036.692ZM9.588 3.676 6.412 1.094a.42.42 0 0 0-.495-.026L1.194 4.145a.43.43 0 0 0-.036.692l3.176 2.581a.42.42 0 0 0 .494.027l4.724-3.077a.43.43 0 0 0 .036-.692ZM19.235 4.145l-4.723-3.077a.42.42 0 0 0-.495.026l-3.175 2.582a.43.43 0 0 0 .035.692l4.724 3.077c.153.1.353.089.495-.027l3.175-2.58a.43.43 0 0 0-.036-.693Z'
            fill='#1587EA'
          />
          <path
            d='m9.983 12.208-3.556 2.866a.38.38 0 0 1-.448.022l-.876-.57a.384.384 0 0 0-.592.325v.309c0 .136.07.261.185.332l5.294 3.241a.38.38 0 0 0 .398 0l5.295-3.241a.389.389 0 0 0 .185-.332v-.276a.384.384 0 0 0-.592-.325l-.825.537a.38.38 0 0 1-.449-.023l-3.54-2.864a.381.381 0 0 0-.479 0Z'
            fill='#1587EA'
          />
        </>
      );
    case 'modal-onedrive-icon':
      return (
        <>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M8.243 4.344C8.727 4.137 9.2 4 9.823 4c1.73 0 3.188 1.104 3.742 2.686.138.343.138.61 0 .472-.07 0-.333.08-.54.15l-.434.13-.346-.344c-1.038-1.032-2.764-1.225-4.218-.537A3.364 3.364 0 0 0 6.642 7.78c-.208.344-.541 1.04-.541 1.246 0 .137-.146.207-.562.344-1.385.48-2.142 1.445-2.142 2.75 0 .48.143 1.031.281 1.375.07.137.065.28.065.28-.07.07-1.739.07-1.947 0-.622-.207-1.233-.758-1.58-1.376C.008 12.057 0 11.987 0 11.37v-.088c0-.48 0-.62.13-.88.276-.687.909-1.103 1.6-1.31.21 0 .347-.06.347-.13.066 0 .065-.193.065-.387v-.042c.07-1.238.9-2.406 2.077-2.75.622-.207 1.39-.12 2.012.086.094.047.148.076.198.07.096-.012.175-.157.494-.564.276-.344.836-.824 1.32-1.031Zm-.065 3.029c.554-.274.887-.344 1.58-.344.968 0 1.535.21 2.228.967l.41.408.347-.215c1.73-.55 3.388.414 3.526 2.063l.065.494.346.129c.968.344 1.393 1.031 1.255 2.063-.07.687-.424 1.251-.909 1.525l-.194.129h-6.16c-3.445 0-4.596 0-4.852-.065-1.039-.206-1.666-1.103-1.666-2.341v-.066c0-.37 0-.555.13-.75.276-.618.917-1.105 1.817-1.311.417-.07.54-.202.54-.409 0-.056.054-.209.111-.375l.041-.119c.276-.824.83-1.509 1.385-1.783Z'
            fill='#1587EA'
          />
        </>
      );
    case 'modal-googledrive-icon':
      return (
        <>
          <path
            fill='#0066DA'
            d='m1.512 16.224.882 1.523c.183.321.447.573.756.757L6.3 13.05H0c0 .355.092.71.275 1.031l1.237 2.142Z'
          />
          <path
            fill='#00AC47'
            d='M10 6.636 6.85 1.184a2.08 2.08 0 0 0-.756.756L.274 12.02c-.179.314-.274.67-.274 1.031h6.3L10 6.636Z'
          />
          <path
            fill='#EA4335'
            d='M16.85 18.504a2.08 2.08 0 0 0 .756-.757l.366-.63 1.753-3.035c.183-.32.275-.676.275-1.03h-6.3l1.34 2.634 1.81 2.818Z'
          />
          <path
            fill='#00832D'
            d='m10 6.636 3.15-5.452a2.014 2.014 0 0 0-1.031-.275H7.881c-.367 0-.722.103-1.031.275L10 6.636Z'
          />
          <path
            fill='#2684FC'
            d='M13.7 13.051H6.3l-3.15 5.452c.31.184.665.276 1.031.276H15.82c.367 0 .722-.104 1.031-.276l-3.15-5.452Z'
          />
          <path
            fill='#FFBA00'
            d='m16.816 6.98-2.91-5.04a2.081 2.081 0 0 0-.756-.756L10 6.636l3.7 6.415h6.288c0-.355-.091-.71-.274-1.03l-2.898-5.04Z'
          />
        </>
      );
    case 'modal-figma-icon':
      return (
        <>
          <g>
            <path fill='#1ABCFE' d='M10 10a3.067 3.067 0 1 1 6.133 0A3.067 3.067 0 0 1 10 10Z' />
            <path fill='#0ACF83' d='M3.867 16.133a3.067 3.067 0 0 1 3.066-3.066H10v3.066a3.067 3.067 0 1 1-6.133 0Z' />
            <path fill='#FF7262' d='M10 .8v6.133h3.066a3.067 3.067 0 1 0 0-6.133H10Z' />
            <path
              fill='#F24E1E'
              d='M3.867 3.867a3.067 3.067 0 0 0 3.066 3.066H10V.8H6.933a3.067 3.067 0 0 0-3.066 3.067Z'
            />
            <path
              fill='#A259FF'
              d='M3.867 10a3.067 3.067 0 0 0 3.066 3.067H10V6.933H6.933A3.067 3.067 0 0 0 3.867 10Z'
            />
          </g>
          <defs>
            <clipPath id='a'>
              <path fill='#fff' d='M3.867.8h12.267v18.4H3.867z' />
            </clipPath>
          </defs>
        </>
      );
    case 'navbar-MyTask-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M7.688 9c0-.31.251-.563.562-.563h3.752a.563.563 0 0 1 0 1.126H8.25A.563.563 0 0 1 7.687 9ZM7.688 12.001c0-.31.251-.563.562-.563h3.752a.563.563 0 0 1 0 1.125H8.25a.563.563 0 0 1-.563-.562ZM5.436 9a.656.656 0 1 1 1.312 0 .656.656 0 0 1-1.312 0ZM5.436 12.001a.656.656 0 1 1 1.312 0 .656.656 0 0 1-1.312 0ZM5.436 2.997c0-.725.587-1.312 1.312-1.312h4.503c.724 0 1.312.587 1.312 1.312v1.501c0 .725-.588 1.313-1.313 1.313H6.749a1.312 1.312 0 0 1-1.312-1.313v-1.5Zm1.312-.187a.187.187 0 0 0-.187.187v1.501c0 .104.083.188.187.188h4.503a.187.187 0 0 0 .187-.188v-1.5a.187.187 0 0 0-.188-.188H6.749Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M4.499 4.31a.938.938 0 0 0-.938.939v9.003c0 .518.42.938.938.938h9.003c.518 0 .938-.42.938-.938V5.25a.938.938 0 0 0-.938-.938h-1.5a.562.562 0 1 1 0-1.125h1.5c1.14 0 2.063.923 2.063 2.063v9.003c0 1.14-.923 2.063-2.063 2.063H4.5a2.063 2.063 0 0 1-2.063-2.063V5.25c0-1.14.923-2.063 2.063-2.063h1.5A.563.563 0 0 1 6 4.31H4.5Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'navbar-TimeTracking-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M14.715 6.633a6.186 6.186 0 1 0-11.43 4.734 6.186 6.186 0 0 0 11.43-4.734ZM6.203 2.246a7.31 7.31 0 1 0 5.595 13.51 7.31 7.31 0 0 0-5.595-13.51Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M8.788 5.427c.31 0 .563.252.563.562v3.173l2.472 1.507a.562.562 0 1 1-.586.96L8.495 9.959a.562.562 0 0 1-.27-.48V5.989c0-.31.252-.562.563-.562Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'customer-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M1.313 13.875A3.188 3.188 0 0 1 4.5 10.687h3.75a3.188 3.188 0 0 1 3.188 3.188v.375a.562.562 0 1 1-1.126 0v-.375c0-1.14-.923-2.063-2.062-2.063H4.5c-1.14 0-2.063.924-2.063 2.063v.375a.562.562 0 1 1-1.124 0v-.375ZM6.375 3.563a2.062 2.062 0 1 0 0 4.124 2.062 2.062 0 0 0 0-4.125ZM3.187 5.624a3.187 3.187 0 1 1 6.375 0 3.187 3.187 0 0 1-6.374 0ZM12.563 11.25c0-.31.251-.563.562-.563h.375a3.188 3.188 0 0 1 3.188 3.188v.375a.562.562 0 1 1-1.125 0v-.375c0-1.14-.924-2.063-2.063-2.063h-.375a.562.562 0 0 1-.563-.562ZM11.063 3c0-.31.251-.563.562-.563a3.188 3.188 0 0 1 0 6.376.562.562 0 1 1 0-1.126 2.062 2.062 0 1 0 0-4.125.562.562 0 0 1-.563-.562Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'project-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M3.748 6.187a.938.938 0 0 0-.938.938v6.752c0 .519.42.939.938.939h10.504c.518 0 .938-.42.938-.939V7.125a.938.938 0 0 0-.938-.938H3.748Zm-2.063.938c0-1.14.923-2.063 2.063-2.063h10.504c1.14 0 2.063.923 2.063 2.063v6.752c0 1.14-.924 2.064-2.063 2.064H3.748a2.063 2.063 0 0 1-2.063-2.064V7.125Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M5.437 4.124c0-1.14.923-2.063 2.063-2.063h3c1.14 0 2.064.923 2.064 2.063v11.254a.563.563 0 0 1-1.125 0V4.124a.938.938 0 0 0-.938-.938H7.5a.938.938 0 0 0-.938.938v11.254a.563.563 0 0 1-1.125 0V4.124Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'navbar-Report-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M16.148 4.852c.22.22.22.576 0 .796l-4.47 4.469a1.312 1.312 0 0 1-1.856 0L8.216 8.511a.187.187 0 0 0-.265 0l-3.803 3.804a.562.562 0 1 1-.796-.796l3.804-3.803a1.312 1.312 0 0 1 1.856 0l1.605 1.606a.187.187 0 0 0 .265 0l4.47-4.47c.22-.22.576-.22.796 0Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M13.188 5.25c0-.31.251-.563.562-.563h2c.31 0 .563.252.563.563v2a.563.563 0 0 1-1.125 0V5.812H13.75a.562.562 0 0 1-.563-.562ZM1.443 1.854c.311 0 .563.251.563.562v12.718H15.75a.563.563 0 0 1 0 1.125H1.443a.562.562 0 0 1-.562-.562V2.416c0-.31.252-.562.562-.562Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'search-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M12.171 4.42a5.46 5.46 0 0 0-7.734 0 5.491 5.491 0 0 0 0 7.755 5.46 5.46 0 0 0 7.734 0 5.491 5.491 0 0 0 0-7.754Zm.8-.797a6.59 6.59 0 0 0-9.333 0 6.621 6.621 0 0 0 0 9.35 6.59 6.59 0 0 0 9.333 0 6.621 6.621 0 0 0 0-9.35Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M12.169 12.17c.22-.22.579-.22.799 0l3.163 3.17a.565.565 0 0 1-.8.799l-3.163-3.17a.565.565 0 0 1 0-.8Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'inbox-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M3.608 4.526A2.063 2.063 0 0 1 5.54 3.188h6.92c.86 0 1.63.533 1.932 1.338l1.79 4.772c.086.232.13.477.13.724v2.728c0 1.14-.923 2.063-2.062 2.063H3.75a2.062 2.062 0 0 1-2.063-2.063v-2.728c0-.247.045-.492.131-.724l1.79-4.772Zm1.053.395-1.789 4.77a.947.947 0 0 0-.06.331v2.728c0 .518.42.938.938.938h10.5c.518 0 .938-.42.938-.938v-2.728a.937.937 0 0 0-.06-.329l-1.79-4.772a.938.938 0 0 0-.877-.609H5.54a.938.938 0 0 0-.879.61Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M1.713 9.75c0-.31.252-.563.562-.563h3.261c.498 0 .952.281 1.174.727l.335.67c0-.001 0 0 0 0a.189.189 0 0 0 .168.104h3.573c.072 0 .136-.04.168-.104l.335-.67a1.314 1.314 0 0 1 1.174-.726h3.261a.562.562 0 1 1 0 1.124h-3.26c-.072 0-.137.04-.169.105l-.335.67a1.312 1.312 0 0 1-1.174.726H7.213c-.497 0-.951-.282-1.174-.726l-.335-.67a.187.187 0 0 0-.168-.104h-3.26a.562.562 0 0 1-.563-.563Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'file-googledrive-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M11.918 10.104 6.166 0h5.668l5.751 10.104h-5.667Zm-4.834.842L4.25 16h10.916L18 10.946H7.084Zm-7.084 0 5.418-9.682 2.914 5.05L2.834 16 0 10.946Z'
            clipRule='evenodd'
            opacity={0.5}
          />
        </>
      );
    case 'file-onedrive-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M8.243 4.344C8.727 4.137 9.2 4 9.823 4c1.73 0 3.188 1.104 3.742 2.686.138.343.138.61 0 .472-.07 0-.333.08-.54.15l-.434.13-.346-.344c-1.038-1.032-2.764-1.225-4.218-.537A3.364 3.364 0 0 0 6.642 7.78c-.208.344-.541 1.04-.541 1.246 0 .137-.146.207-.562.344-1.385.48-2.142 1.445-2.142 2.75 0 .48.143 1.031.281 1.375.07.137.065.28.065.28-.07.07-1.739.07-1.947 0-.622-.207-1.233-.758-1.58-1.376C.008 12.057 0 11.987 0 11.37v-.088c0-.48 0-.62.13-.88.276-.687.909-1.103 1.6-1.31.21 0 .347-.06.347-.13.066 0 .065-.193.065-.387v-.042c.07-1.238.9-2.406 2.077-2.75.622-.207 1.39-.12 2.012.086.094.047.148.076.198.07.096-.012.175-.157.494-.564.276-.344.836-.824 1.32-1.031Zm-.065 3.029c.554-.274.887-.344 1.58-.344.968 0 1.535.21 2.228.967l.41.408.347-.215c1.73-.55 3.388.414 3.526 2.063l.065.494.346.129c.968.344 1.393 1.031 1.255 2.063-.07.687-.424 1.251-.909 1.525l-.194.129h-6.16c-3.445 0-4.596 0-4.852-.065-1.039-.206-1.666-1.103-1.666-2.341v-.066c0-.37 0-.555.13-.75.276-.618.917-1.105 1.817-1.311.417-.07.54-.202.54-.409 0-.056.054-.209.111-.375l.041-.119c.276-.824.83-1.509 1.385-1.783Z'
            clipRule='evenodd'
            opacity={0.5}
          />
        </>
      );
    case 'file-dropbox-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='m9.014 4.823-4.5 2.822 4.5 2.823-4.5 2.822L0 10.44l4.51-2.822L0 4.823 4.51 2l4.504 2.823Zm-4.528 9.354 4.5-2.822 4.5 2.822L8.986 17l-4.5-2.822Zm9.028-6.559-4.5 2.823 4.476 2.846L18 10.464l-4.51-2.819L18 4.823 13.49 2 9.014 4.82l4.5 2.798Z'
            clipRule='evenodd'
            opacity={0.5}
          />
        </>
      );
    case 'Priority-No-priority-icon':
      return (
        <>
          <path
            fill='var(--text-placeholder)'
            d='M3 8H2a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1ZM8 5H7a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1ZM13 2h-1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1Z'
          />
        </>
      );
    case 'Priority-Urgent-icon':
      return (
        <>
          <path
            fill='var(--text-secondary)'
            d='M8 0C3.584 0 0 3.584 0 8s3.584 8 8 8 8-3.584 8-8-3.584-8-8-8Zm0 12.8a1.07 1.07 0 0 1-1.067-1.067c0-.586.48-1.066 1.067-1.066s1.067.48 1.067 1.066A1.07 1.07 0 0 1 8 12.8Zm1.221-8.272-.357 4.277a.866.866 0 0 1-1.728 0l-.357-4.277a1.225 1.225 0 0 1 2.354-.57c.062.148.094.308.094.469 0 .032 0 .069-.006.101Z'
          />
        </>
      );
    case 'Priority-High-icon':
      return (
        <>
          <path
            fill='var(--text-secondary)'
            d='M3 8H2a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1ZM8 5H7a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1ZM13 2h-1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1Z'
          />
        </>
      );
    case 'round-plus-icon':
      return (
        <>
          <g stroke={iconprimary} strokeLinecap='round' strokeLinejoin='round' strokeWidth={1.5} clipPath='url(#a)'>
            <path d='M9 16.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15ZM9 6v6M6 9h6' fill='none' />
          </g>
          <defs>
            <clipPath id='a'>
              <path fill='var(--text-white)' d='M0 0h18v18H0z' />
            </clipPath>
          </defs>
        </>
      );
    case 'round-close-icon':
      return (
        <>
          <path
            stroke={stroke}
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={1.5}
            d='m11.122 6.877-4.245 4.245M11.122 11.122 6.877 6.877'
          />
          <path
            stroke={stroke}
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={1.5}
            d='M9 15.75v0A6.75 6.75 0 0 1 2.25 9v0A6.75 6.75 0 0 1 9 2.25v0A6.75 6.75 0 0 1 15.75 9v0A6.75 6.75 0 0 1 9 15.75Z'
            clipRule='evenodd'
            fill='none'
          />
        </>
      );
    case 'Priority-Medium-icon':
      return (
        <>
          <path
            d='M3 8H2C1.44772 8 1 8.44772 1 9V13C1 13.5523 1.44772 14 2 14H3C3.55228 14 4 13.5523 4 13V9C4 8.44772 3.55228 8 3 8Z'
            fill='var(--text-secondary)'
          />
          <path
            d='M8 5H7C6.44772 5 6 5.44772 6 6V13C6 13.5523 6.44772 14 7 14H8C8.55228 14 9 13.5523 9 13V6C9 5.44772 8.55228 5 8 5Z'
            fill='var(--text-secondary)'
          />
          <path
            d='M13 2H12C11.4477 2 11 2.44772 11 3V13C11 13.5523 11.4477 14 12 14H13C13.5523 14 14 13.5523 14 13V3C14 2.44772 13.5523 2 13 2Z'
            fill='var(--text-placeholder)'
          />
        </>
      );
    case 'Priority-low-icon':
      return (
        <>
          <path
            fill='var(--text-secondary)'
            d='M3 8H2a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1Z'
          />
          <path
            fill='var(--text-placeholder)'
            d='M8 5H7a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1ZM13 2h-1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1Z'
          />
        </>
      );
    case 'active-point-icon':
      return (
        <>
          <circle cx={2.5} cy={3} r={2.5} fill={iconprimary} />
        </>
      );
    case 'updated-group-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M7.749 9.104c0-.312.253-.565.565-.565h6.855a.565.565 0 1 1 0 1.13H8.314a.565.565 0 0 1-.565-.565ZM4.771 8.535a.806.806 0 1 0-1.14 1.14.806.806 0 0 0 1.14-1.14Zm.8-.8a1.936 1.936 0 1 0-2.738 2.738A1.936 1.936 0 0 0 5.57 7.736ZM7.749 4.306c0-.312.253-.565.565-.565h6.855a.565.565 0 1 1 0 1.13H8.314a.565.565 0 0 1-.565-.565ZM6.677 2.557c.209.232.19.59-.042.798l-2.28 2.054a.565.565 0 0 1-.757 0l-1.133-1.02a.565.565 0 1 1 .756-.84l.755.68L5.88 2.515a.565.565 0 0 1 .798.042ZM7.749 13.903c0-.312.253-.565.565-.565h6.855a.565.565 0 1 1 0 1.13H8.314a.565.565 0 0 1-.565-.565ZM4.771 13.333a.806.806 0 1 0-1.14 1.14.806.806 0 0 0 1.14-1.14Zm.8-.8a1.936 1.936 0 1 0-2.738 2.738 1.936 1.936 0 0 0 2.737-2.737Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'responsive-back-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M17.034 2.476a.753.753 0 0 0-1.065 0l-9 9a.753.753 0 0 0 0 1.065l9 9a.752.752 0 1 0 1.065-1.064l-8.47-8.468 8.47-8.47a.752.752 0 0 0 0-1.063Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'datepicker-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M6.123 2.185c.31 0 .563.251.563.562v2.251a.563.563 0 0 1-1.125 0v-2.25c0-.312.251-.563.562-.563ZM12.877 2.185c.31 0 .563.251.563.562v2.251a.563.563 0 0 1-1.125 0v-2.25c0-.312.251-.563.562-.563ZM2.184 7.624c0-.31.251-.562.562-.562h13.506a.562.562 0 1 1 0 1.125H2.746a.563.563 0 0 1-.562-.563Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M2.184 6.123A2.813 2.813 0 0 1 4.996 3.31h9.006a2.813 2.813 0 0 1 2.812 2.813v7.88a2.813 2.813 0 0 1-2.812 2.812H4.996a2.813 2.813 0 0 1-2.812-2.812v-7.88Zm2.812-1.688c-.932 0-1.687.756-1.687 1.688v7.88c0 .932.755 1.687 1.687 1.687h9.006c.932 0 1.687-.755 1.687-1.687v-7.88c0-.932-.755-1.688-1.687-1.688H4.996Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'filepath-folder-icon':
      return (
        <>
          <path
            fill='#FFB125'
            d='M20.437 4.938H9.625a.313.313 0 0 0-.244.507l1.375 1.72a1.553 1.553 0 0 0 1.219.585h9.712A.313.313 0 0 0 22 7.437V6.5a1.564 1.564 0 0 0-1.563-1.563Z'
          />
          <path
            fill='#FCD354'
            d='M22 7.125H11.975a.936.936 0 0 1-.73-.351L9.68 4.82A2.178 2.178 0 0 0 7.975 4H3.563A1.562 1.562 0 0 0 2 5.563v12.5a1.563 1.563 0 0 0 1.563 1.562h16.875A1.563 1.563 0 0 0 22 18.062V7.126Z'
          />
        </>
      );
    case 'updated-minus-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M3.42 9c0-.312.254-.565.566-.565h9.99a.565.565 0 1 1 0 1.13h-9.99A.565.565 0 0 1 3.42 9Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'gray-icon':
      return (
        <>
          <circle cx='2' cy='2' r='2' fill={fill} />
        </>
      );
    case 'true-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M9 2.698a6.239 6.239 0 1 0 0 12.478A6.239 6.239 0 0 0 9 2.698Zm-7.368 6.24a7.369 7.369 0 1 1 14.737 0 7.369 7.369 0 0 1-14.737 0Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M12.63 6.964c.221.22.222.578.002.799L8.69 11.717a.665.665 0 0 1-.934.009l-2.42-2.341a.565.565 0 0 1 .786-.812l2.09 2.022 3.618-3.63a.565.565 0 0 1 .8-.001Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'bin-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M1.306 3.798c0-.754.61-1.365 1.365-1.365h12.66c.753 0 1.365.61 1.365 1.365v1.4c0 .753-.612 1.365-1.365 1.365H2.67a1.365 1.365 0 0 1-1.365-1.365v-1.4Zm1.365-.235a.235.235 0 0 0-.235.235v1.4c0 .13.105.235.235.235h12.66c.13 0 .235-.106.235-.235v-1.4a.235.235 0 0 0-.235-.235H2.67Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M2.559 5.618a.562.562 0 0 1 .414-.181h12.005a.562.562 0 0 1 .56.609l-.635 7.627a2.063 2.063 0 0 1-2.056 1.892H5.104a2.063 2.063 0 0 1-2.056-1.892l-.636-7.627a.563.563 0 0 1 .147-.428Zm1.025.944.585 7.018c.04.486.447.86.935.86h7.743a.938.938 0 0 0 .935-.86l.584-7.018H3.584Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M7.332 9.417c0-.31.252-.563.563-.563h2.161a.562.562 0 1 1 0 1.125H7.895a.563.563 0 0 1-.563-.562Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'updated-emoji-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M9 2.813A6.187 6.187 0 0 0 2.812 9a.563.563 0 0 1-1.124 0A7.312 7.312 0 0 1 9 1.687 7.312 7.312 0 0 1 16.313 9a.562.562 0 1 1-1.125 0A6.187 6.187 0 0 0 9 2.812Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M2.25 8.438c.31 0 .563.251.563.562a6.187 6.187 0 1 0 12.374 0 .562.562 0 1 1 1.126 0A7.312 7.312 0 0 1 9 16.313 7.312 7.312 0 0 1 1.687 9c0-.31.252-.563.563-.563ZM6.375 6.188c.31 0 .563.251.563.562v.75a.563.563 0 0 1-1.125 0v-.75c0-.31.251-.563.562-.563ZM11.625 6.188c.31 0 .563.251.563.562v.75a.562.562 0 1 1-1.126 0v-.75c0-.31.252-.563.563-.563Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='m6.375 11.016-.398.398h.002l.001.003.005.004.014.014.047.042a4.357 4.357 0 0 0 .757.524 4.579 4.579 0 0 0 5.151-.524 2.33 2.33 0 0 0 .046-.042l.014-.013.005-.005.002-.002c0-.001.001-.001-.396-.4l.397.4a.563.563 0 0 0-.793-.8l-.002.003a3.231 3.231 0 0 1-.568.396 3.454 3.454 0 0 1-3.864-.375 1.04 1.04 0 0 1-.022-.02l-.003-.003a.563.563 0 0 0-.793.798l.398-.398Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'file-attachment-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M9.45 2.703a3.472 3.472 0 1 1 4.91 4.91l-5.423 5.424a2.15 2.15 0 0 1-3.04-3.039l4.115-4.115a.563.563 0 0 1 .795.796l-4.114 4.114a1.025 1.025 0 0 0 1.448 1.449l5.424-5.424a2.347 2.347 0 1 0-3.319-3.319L4.822 8.923a3.67 3.67 0 1 0 5.19 5.19l3.291-3.292a.562.562 0 1 1 .796.795l-3.292 3.292a4.794 4.794 0 1 1-6.78-6.78L9.45 2.702Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'filters-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M2.14 3.161c0-.746.606-1.351 1.352-1.351h11.015c.746 0 1.352.605 1.352 1.351v2.035c0 .358-.142.702-.396.956l-4.097 4.096a.565.565 0 0 1-.799-.799l4.097-4.096a.22.22 0 0 0 .065-.157V3.16c0-.122-.1-.221-.222-.221H3.492c-.122 0-.221.1-.221.221v2.035c0 .06.023.115.064.156L7.433 9.45a.565.565 0 0 1-.799.8L2.538 6.152a1.35 1.35 0 0 1-.397-.957V3.16Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M7.033 9.284c.312 0 .565.253.565.565v4.917c0 .272.256.472.52.406l1.966-.492a.419.419 0 0 0 .318-.406V9.849a.565.565 0 0 1 1.13 0v4.425c0 .711-.485 1.33-1.173 1.502l-1.967.492a1.549 1.549 0 0 1-1.924-1.502V9.849c0-.312.253-.565.565-.565Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'time-loding-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M16.932 32c8.846 0 16.016-7.163 16.016-16S25.778 0 16.932 0C8.087 0 .917 7.163.917 16s7.17 16 16.015 16Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M16.418 22.333c-1.31 1.044-3.248.111-3.248-1.563v-9.95c0-1.689 1.967-2.616 3.273-1.543l6.145 5.054c.982.808.97 2.314-.024 3.107l-6.146 4.895Z'
            clipRule='evenodd'
            className='fill1'
          />
        </>
      );
    case 'file-loading-icon':
      return (
        <>
          <g fill={fill} clipPath='url(#a)'>
            <path d='M27.898 19.077h20.85c.332 0 .651.133.886.372s.367.563.366.9v24.956C50 46.24 49.253 47 48.332 47H11.668c-.443 0-.867-.179-1.18-.496A1.707 1.707 0 0 1 10 45.305V16.111c0-.933.746-1.688 1.665-1.688H22.5c.694 0 1.527.493 1.87 1.102l1.392 2.474s.534 1.076 2.134 1.076l.002.002Z' />
            <path d='M27.898 18.654h20.85c.332 0 .651.134.886.372.235.239.367.563.366.9v24.957c0 .935-.747 1.693-1.668 1.694H11.668c-.443 0-.867-.178-1.18-.496A1.707 1.707 0 0 1 10 44.882V15.689c0-.933.746-1.688 1.665-1.688H22.5c.694 0 1.527.493 1.87 1.102l1.392 2.474s.534 1.077 2.134 1.077h.002Z' />
          </g>
          <defs>
            <clipPath id='a'>
              <path fill='var(--text-white)' d='M0 0h60v60H0z' />
            </clipPath>
          </defs>
        </>
      );
    case 'document-loading-icon':
      return (
        <>
          <g clipPath='url(#a)'>
            <path
              fill={fill}
              fillRule='evenodd'
              d='M7 13.99c0-.546.455-.99 1.004-.99h43.992c.555 0 1.004.451 1.004.99v4.02c0 .546-.455.99-1.004.99H8.004c-.55.001-.997-.44-1.004-.99v-4.02Zm0 14c0-.546.455-.99 1.004-.99h43.992c.555 0 1.004.451 1.004.99v4.02c0 .546-.455.99-1.004.99H8.004c-.55.001-.997-.44-1.004-.99v-4.02ZM7.998 41a.995.995 0 0 0-.998.99v4.02a1 1 0 0 0 .998.99h28.004a.995.995 0 0 0 .998-.99v-4.02a1 1 0 0 0-.998-.99H7.998Z'
              clipRule='evenodd'
            />
          </g>
          <defs>
            <clipPath id='a'>
              <path fill='var(--text-white)' d='M0 0h60v60H0z' />
            </clipPath>
          </defs>
        </>
      );
    case 'image-loading-icon':
      return (
        <>
          <g clipPath='url(#a)'>
            <path
              fill={fill}
              fillRule='evenodd'
              d='M36 20a6 6 0 1 0 12 0 6 6 0 0 0-12 0Zm-11.22 8.315c-.353-.435-.92-.438-1.27-.015l-.001-.001-13.336 16.004c-.346.414-.193.764.354.764h38.928c.545 0 .72-.359.388-.803l-7.561-10.082c-.331-.441-.898-.465-1.263-.047l-5.312 6.082c-.367.419-.944.405-1.294-.025L24.78 28.315Z'
              clipRule='evenodd'
            />
          </g>
          <defs>
            <clipPath id='a'>
              <path fill='var(--text-white)' d='M0 0h60v60H0z' />
            </clipPath>
          </defs>
        </>
      );
    case 'font-loading-icon':
      return (
        <>
          <g clipPath='url(#a)'>
            <path
              fill={fill}
              d='M21 41V20a1 1 0 0 0-1-1h-3v-3h25l.863 6H40l-1.703-2.555a1 1 0 0 0-.832-.445H29a1 1 0 0 0-1 1v9h10v3H28v9a1 1 0 0 0 1 1h3v3H17v-3h3a1 1 0 0 0 1-1Z'
            />
          </g>
          <defs>
            <clipPath id='a'>
              <path fill='var(--text-white)' d='M0 0h60v60H0z' />
            </clipPath>
          </defs>
        </>
      );

    case 'pdf-loading-icon':
      return (
        <>
          <g clipPath='url(#a)'>
            <path
              fill={fill}
              d='m30.608 25.982 2.165-1.25-2.166-3.75-2.165 3.75 2.166 1.25Zm7.17 12.419v2.5h4.33l-2.165-3.75-2.165 1.25Zm-14.34 0-2.166-1.25-2.165 3.75h4.33v-2.5Zm7.165-14.282-2.166 1.25 2.166 3.75 2.165-3.75-2.166-1.25Zm3.17-5.494-2.165-1.25 2.165 1.25ZM30.603 12l.14-2.496-.14-.008-.142.008.142 2.496Zm-3.173 6.625 2.166-1.25-2.166 1.25ZM49.072 45.38l-2.228-1.133-.822 1.617 1.282 1.283 1.768-1.767Zm-10.54-6.085v-2.5h-4.33l2.164 3.75 2.166-1.25Zm3.202 5.546 2.165-1.25-2.166 1.25Zm7.34.54 2.094 1.365 1.107-1.699-1.433-1.433-1.768 1.767Zm-26.73-6.086 2.164 1.25 2.166-3.75h-4.33v2.5Zm-3.204 5.548-2.166-1.25 2.166 1.25Zm9.302-17.611 7.17 12.419 4.33-2.5-7.17-12.419-4.33 2.5Zm9.336 8.669h-14.34v5h14.34v-5Zm-12.175 3.75 7.17-12.419-4.33-2.5-7.17 12.419 4.33 2.5Zm7.165-14.282 3.17-5.494-4.33-2.5-3.17 5.494 4.33 2.5Zm3.17-5.494c1.254-2.172 2.004-4.735.906-7.013-1.14-2.366-3.665-3.22-6.101-3.358l-.281 4.992c.82.046 1.326.197 1.605.335a.932.932 0 0 1 .233.152.17.17 0 0 1 .04.05c.004.007.252.639-.732 2.342l4.33 2.5ZM30.462 9.504c-2.435.138-4.96.993-6.101 3.358-1.099 2.278-.349 4.841.906 7.013l4.33-2.5c-.984-1.704-.736-2.334-.733-2.341a.172.172 0 0 1 .04-.05c.032-.03.1-.086.234-.152.28-.138.786-.29 1.607-.336l-.283-4.992Zm-5.196 10.371 3.172 5.494 4.33-2.5-3.172-5.494-4.33 2.5Zm26.036 26.638c1.109-2.182 1.643-4.802.17-6.981-1.42-2.101-4.023-2.737-6.535-2.737v5c1.971 0 2.39.533 2.393.537a.172.172 0 0 1 .024.06c.01.043.024.133.013.283-.022.315-.147.834-.522 1.572l4.457 2.266Zm-6.366-9.718h-6.404v5h6.404v-5Zm-8.569 3.75 3.202 5.546 4.33-2.5-3.202-5.546-4.33 2.5Zm3.202 5.546c1.257 2.176 3.108 4.112 5.639 4.291 2.623.186 4.626-1.586 5.961-3.636l-4.19-2.73c-.452.695-.838 1.063-1.1 1.24a.952.952 0 0 1-.253.129.174.174 0 0 1-.065.01c-.005 0-.676-.097-1.661-1.804l-4.33 2.5Zm11.274-2.477-.001-.001-3.537 3.534.001.001 3.537-3.534Zm-36.816.637c-.375-.74-.5-1.258-.522-1.574a.952.952 0 0 1 .014-.283c.009-.039.019-.054.023-.061.004-.005.423-.538 2.396-.538v-5c-2.514 0-5.117.636-6.538 2.737-1.473 2.18-.94 4.8.17 6.983l4.457-2.264Zm1.91-2.456h6.407v-5h-6.406v5Zm4.242-3.75-3.204 5.548 4.33 2.5 3.204-5.548-4.33-2.5Zm-3.204 5.548c-.986 1.709-1.657 1.805-1.663 1.805a.173.173 0 0 1-.065-.01.95.95 0 0 1-.252-.13c-.262-.176-.65-.544-1.101-1.239l-4.19 2.728c1.335 2.051 3.338 3.825 5.962 3.639 2.53-.18 4.383-2.116 5.64-4.293l-4.33-2.5Z'
            />
          </g>
          <defs>
            <clipPath id='a'>
              <path fill='var(--text-white)' d='M0 0h60v60H0z' />
            </clipPath>
          </defs>
        </>
      );
    case 'stripeLogo':
      return (
        <>
          <g clipPath='url(#clip0_13120_165573)'>
            <path
              fillRule='evenodd'
              clipRule='evenodd'
              d='M51.9733 5.42056L45.28 6.86248V1.41522L51.9733 0V5.42056ZM24.7733 3.09746L18.2667 4.48598L18.24 25.8745C18.24 29.8264 21.2 32.737 25.1467 32.737C27.3333 32.737 28.9333 32.3365 29.8133 31.8558V26.4352C28.96 26.7824 24.7467 28.0107 24.7467 24.0587V14.5794H29.8133V8.89186H24.7467L24.7733 3.09746ZM6.74667 15.6738C6.74667 14.6324 7.6 14.2319 9.01333 14.2319C11.04 14.2319 13.6 14.846 15.6267 15.9408V9.6658C13.4133 8.78463 11.2267 8.4375 9.01333 8.4375C3.6 8.4375 0 11.2679 0 15.9942C0 20.4429 3.69235 21.7781 6.61938 22.8366C8.54134 23.5316 10.1333 24.1073 10.1333 25.3667C10.1333 26.595 9.06667 26.9956 7.57333 26.9956C5.36 26.9956 2.53333 26.0877 0.293333 24.8594V31.2145C2.77333 32.2826 5.28 32.7366 7.57333 32.7366C13.12 32.7366 16.9333 29.9862 16.9333 25.2065C16.9168 20.2746 13.0075 18.9431 10.0372 17.9315C8.21527 17.311 6.74667 16.8108 6.74667 15.6738ZM37.6799 8.89222L38.1066 10.8682C39.6799 7.98434 42.7999 8.57179 43.6533 8.89222V15.0337C42.8266 14.74 40.1599 14.3662 38.5866 16.4223V32.2567H31.9199V8.89222H37.6799ZM45.2803 8.8916H51.9736V32.2561H45.2803V8.8916ZM65.8931 8.4375C63.2798 8.4375 61.5998 9.6658 60.6665 10.5203L60.3198 8.86474H54.4531V39.9996L61.1198 38.5844L61.1465 31.0276C62.1065 31.7219 63.5198 32.7099 65.8665 32.7099C70.6398 32.7099 74.9865 28.8647 74.9865 20.4001C74.9598 12.6565 70.5598 8.4375 65.8931 8.4375ZM61.1468 25.5812C61.7868 26.2754 62.7201 26.8362 64.2934 26.8362C66.7468 26.8362 68.4001 24.1659 68.4001 20.5878C68.4001 17.0898 66.7201 14.3662 64.2934 14.3662C62.7734 14.3662 61.8134 14.9003 61.1201 15.6746L61.1468 25.5812ZM95.9999 20.6671C95.9999 13.8314 92.6932 8.4375 86.3732 8.4375C80.0265 8.4375 76.1865 13.8314 76.1865 20.6137C76.1865 28.6511 80.7199 32.7099 87.2265 32.7099C90.3999 32.7099 92.7999 31.9889 94.6132 30.9742V25.6338C92.7999 26.5416 90.7199 27.1024 88.0799 27.1024C85.4932 27.1024 83.1999 26.1945 82.9065 23.0436H95.9465C95.9465 22.8965 95.9561 22.5621 95.9671 22.1769V22.1767C95.9822 21.6534 95.9999 21.0362 95.9999 20.6671ZM86.3467 13.8585C84.6667 13.8585 82.8267 15.1135 82.8267 18.1308H89.7067C89.7067 15.1135 87.9733 13.8585 86.3467 13.8585Z'
              fill={fill}
            />
          </g>
          <defs>
            <clipPath id='clip0_13120_165573'>
              <rect width='96' height='40' fill={fill} />
            </clipPath>
          </defs>
        </>
      );
    case 'copy-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M4.686 6.748c0-1.139.923-2.062 2.062-2.062h7.504c1.14 0 2.063.923 2.063 2.062v7.504c0 1.14-.924 2.063-2.063 2.063H6.748a2.062 2.062 0 0 1-2.062-2.063V6.748Zm2.062-.937a.937.937 0 0 0-.937.937v7.504c0 .518.42.938.937.938h7.504c.518 0 .938-.42.938-.938V6.748a.937.937 0 0 0-.938-.937H6.748Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M3.748 2.81a.938.938 0 0 0-.938.938v7.503c0 .518.42.938.938.938h1.5a.563.563 0 0 1 0 1.125h-1.5a2.063 2.063 0 0 1-2.063-2.063V3.748c0-1.14.923-2.063 2.063-2.063h7.503c1.14 0 2.063.923 2.063 2.063v1.5a.562.562 0 1 1-1.125 0v-1.5a.938.938 0 0 0-.938-.938H3.748Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'filescreen-figma-icon': {
      return (
        <>
          <path
            d='M8.00002 0.640137V5.12014H5.76002C4.52642 5.12014 3.52002 4.11374 3.52002 2.88014C3.52002 1.64654 4.52642 0.640137 5.76002 0.640137H8.00002ZM8.00002 5.76014V10.2401H5.76002C4.52642 10.2401 3.52002 9.23374 3.52002 8.00014C3.52002 6.76654 4.52642 5.76014 5.76002 5.76014H8.00002ZM8.00002 10.8801V13.1201C8.00002 14.3537 6.99362 15.3601 5.76002 15.3601C4.52642 15.3601 3.52002 14.3537 3.52002 13.1201C3.52002 11.8865 4.52642 10.8801 5.76002 10.8801H8.00002ZM13.12 2.88014C13.12 4.11374 12.1136 5.12014 10.88 5.12014H8.64002V0.640137H10.88C12.1136 0.640137 13.12 1.64654 13.12 2.88014ZM10.88 5.76014C10.2859 5.76014 9.71618 5.99614 9.2961 6.41622C8.87602 6.8363 8.64002 7.40605 8.64002 8.00014C8.64002 8.59422 8.87602 9.16397 9.2961 9.58406C9.71618 10.0041 10.2859 10.2401 10.88 10.2401C11.4741 10.2401 12.0439 10.0041 12.4639 9.58406C12.884 9.16397 13.12 8.59422 13.12 8.00014C13.12 7.40605 12.884 6.8363 12.4639 6.41622C12.0439 5.99614 11.4741 5.76014 10.88 5.76014Z'
            fill={fill}
          />
        </>
      );
    }
    case 'overdue-icon': {
      return (
        <>
          <path
            fill='var(--accent-warning)'
            d='M0 14C0 6.268 6.268 0 14 0s14 6.268 14 14-6.268 14-14 14S0 21.732 0 14Z'
          />
          <path
            fill='var(--text-white)'
            fillRule='evenodd'
            d='M12.832 14a.5.5 0 0 1 .5-.5h3.335a.5.5 0 1 1 0 1h-3.335a.5.5 0 0 1-.5-.5ZM12.832 16.667a.5.5 0 0 1 .5-.5h3.335a.5.5 0 1 1 0 1h-3.335a.5.5 0 0 1-.5-.5ZM10.832 14a.583.583 0 1 1 1.166 0 .583.583 0 0 1-1.166 0ZM10.832 16.667a.583.583 0 1 1 1.166 0 .583.583 0 0 1-1.166 0ZM10.832 8.664c0-.645.522-1.167 1.166-1.167H16c.645 0 1.167.522 1.167 1.167v1.334c0 .645-.522 1.167-1.167 1.167h-4.002a1.167 1.167 0 0 1-1.166-1.167V8.664Zm1.166-.167a.167.167 0 0 0-.166.167v1.334c0 .092.074.167.166.167H16a.167.167 0 0 0 .167-.167V8.664A.167.167 0 0 0 16 8.497h-4.002Z'
            clipRule='evenodd'
          />
          <path
            fill='var(--text-white)'
            fillRule='evenodd'
            d='M9.998 9.831a.834.834 0 0 0-.834.834v8.003c0 .46.373.834.834.834H18c.46 0 .834-.373.834-.834v-8.003a.834.834 0 0 0-.834-.834h-1.334a.5.5 0 0 1 0-1h1.334c1.013 0 1.834.821 1.834 1.834v8.003a1.834 1.834 0 0 1-1.834 1.834H9.998a1.834 1.834 0 0 1-1.834-1.834v-8.003c0-1.013.821-1.834 1.834-1.834h1.334a.5.5 0 1 1 0 1H9.998Z'
            clipRule='evenodd'
          />
        </>
      );
    }
    case 'line': {
      return (
        <>
          <path d='M0.5 20.5V1.39503' stroke={stroke} strokeLinecap='square' />
        </>
      );
    }
    case 'no-icon': {
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M14.171 3.829c.22.22.22.576 0 .795L4.625 14.17a.562.562 0 1 1-.795-.795l9.546-9.546c.22-.22.576-.22.795 0Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M1.688 9A7.312 7.312 0 0 1 9 1.687 7.312 7.312 0 0 1 16.313 9 7.312 7.312 0 0 1 9 16.313 7.312 7.312 0 0 1 1.687 9ZM9 2.812a6.187 6.187 0 1 0 0 12.376A6.187 6.187 0 1 0 9 2.812Z'
            clipRule='evenodd'
          />
        </>
      );
    }
    case 'access-icon': {
      return (
        <>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M7.76468 1.77051C5.85548 1.77051 4.30304 3.15864 3.87074 4.96786C3.79503 5.28471 3.99051 5.60294 4.30736 5.67865C4.62421 5.75435 4.94244 5.55887 5.01814 5.24203C5.33818 3.90265 6.46185 2.95021 7.76468 2.95021C9.30561 2.95021 10.6101 4.28087 10.6101 5.99196L10.6101 6.93952H4.04446C3.08717 6.93952 2.31113 7.71556 2.31113 8.67286V12.7173C2.31113 13.6746 3.08717 14.4506 4.04446 14.4506H12.1333C13.0906 14.4506 13.8667 13.6746 13.8667 12.7173V8.67286C13.8667 7.71556 13.0906 6.93952 12.1333 6.93952H11.7898L11.7898 5.99196C11.7898 3.69195 10.0181 1.77051 7.76468 1.77051ZM4.0445 8.09561C3.7254 8.09561 3.46672 8.35429 3.46672 8.67339V12.7178C3.46672 13.0369 3.7254 13.2956 4.0445 13.2956H12.1334C12.4525 13.2956 12.7112 13.0369 12.7112 12.7178V8.67339C12.7112 8.35429 12.4525 8.09561 12.1334 8.09561H4.0445Z'
            fill={fill}
          />
        </>
      );
    }
    case 'dot-icon': {
      return (
        <>
          <circle cx={7.5} cy={8} r={2.5} fill={fill} />
        </>
      );
    }
    case 'record-start-icon': {
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M9.018 15.203a6.185 6.185 0 1 0 0-12.37 6.185 6.185 0 0 0 0 12.37Zm0 1.13a7.315 7.315 0 1 0 0-14.63 7.315 7.315 0 0 0 0 14.63Z'
            clipRule='evenodd'
          />
          <circle cx={9.018} cy={9} r={3.008} fill={fill} />
        </>
      );
    }
    case 'checkbox-icon': {
      return (
        <>
          <rect width='16' height='16' rx='8' fill={iconprimary} />
          <path
            d='M11.3327 5.69995L6.74935 10.2833L4.66602 8.19995'
            stroke='white'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
            fill='none'
          />
        </>
      );
    }
    case 'assign-task-icon': {
      return (
        <>
          <path
            fill='var(--text-primary)'
            fillRule='evenodd'
            d='M7.05 12.256A2.725 2.725 0 0 0 4.306 15a.556.556 0 0 1-1.112 0 3.837 3.837 0 0 1 3.856-3.855h3.825A3.837 3.837 0 0 1 14.731 15a.556.556 0 0 1-1.112 0 2.725 2.725 0 0 0-2.744-2.744H7.05ZM10.859 4.304a2.7 2.7 0 0 0-3.723.006c-1.017.957-.994 2.623.024 3.704.958 1.018 2.623.994 3.705-.024 1.03-.97 1.05-2.624-.006-3.686Zm.775-.815a3.825 3.825 0 0 0-5.269.001C4.832 4.933 4.96 7.317 6.341 8.786c1.443 1.532 3.827 1.405 5.295.024 1.518-1.428 1.5-3.818.014-5.306a.397.397 0 0 0-.008-.008l-.008-.007Z'
            clipRule='evenodd'
          />
        </>
      );
    }
    case 'project-invited-icon': {
      return (
        <>
          <path
            fill='var(--text-primary)'
            fillRule='evenodd'
            d='M1.093 14.813a3.75 3.75 0 0 1 3.75-3.75h5.625a3.75 3.75 0 0 1 3.75 3.75v.562a.563.563 0 0 1-1.125 0v-.563a2.625 2.625 0 0 0-2.625-2.624H4.843a2.625 2.625 0 0 0-2.625 2.624v.563a.562.562 0 1 1-1.125 0v-.563ZM7.655 3.188a2.438 2.438 0 1 0 0 4.875 2.438 2.438 0 0 0 0-4.876ZM4.093 5.624a3.563 3.563 0 1 1 7.125 0 3.563 3.563 0 0 1-7.125 0ZM14.405 5.572c.31 0 .563.252.563.563v3.881a.563.563 0 0 1-1.125 0V6.135c0-.31.252-.563.562-.563Z'
            clipRule='evenodd'
          />
          <path
            fill='var(--text-primary)'
            fillRule='evenodd'
            d='M11.902 8.075c0-.31.252-.562.563-.562h3.88a.562.562 0 1 1 0 1.125h-3.88a.563.563 0 0 1-.563-.563Z'
            clipRule='evenodd'
          />
        </>
      );
    }
    case 'mention-task-icon': {
      return (
        <>
          <path
            fill='var(--text-primary)'
            fillRule='evenodd'
            d='M1.688 9A7.312 7.312 0 0 1 9 1.687 7.312 7.312 0 0 1 16.313 9v1.125a2.437 2.437 0 0 1-4.581 1.162A3.563 3.563 0 1 1 12.562 9v1.125a1.31 1.31 0 0 0 1.313 1.313c.725 0 1.313-.588 1.313-1.313V9A6.187 6.187 0 1 0 2.812 9 6.187 6.187 0 0 0 9 15.188a6.199 6.199 0 0 0 3.529-1.11.562.562 0 1 1 .642.923A7.324 7.324 0 0 1 9 16.313 7.312 7.312 0 0 1 1.687 9Zm9.75 0a2.438 2.438 0 1 0-4.876 0 2.438 2.438 0 0 0 4.875 0Z'
            clipRule='evenodd'
          />
        </>
      );
    }
    case 'complate-task-icon': {
      return (
        <>
          <path
            fill='var(--text-primary)'
            fillRule='evenodd'
            d='M15.398 4.477c.22.22.22.576 0 .796l-8.25 8.25a.562.562 0 0 1-.796 0l-3.75-3.75a.563.563 0 0 1 .796-.796L6.75 12.33l7.852-7.852c.22-.22.576-.22.796 0Z'
            clipRule='evenodd'
          />
        </>
      );
    }
    case 'reopen-task-icon': {
      return (
        <>
          <path
            fill='var(--text-primary)'
            fillRule='evenodd'
            d='M7.688 9c0-.31.251-.563.562-.563h3.752a.563.563 0 0 1 0 1.126H8.25A.563.563 0 0 1 7.687 9ZM7.688 12.001c0-.31.251-.563.562-.563h3.752a.563.563 0 0 1 0 1.125H8.25a.563.563 0 0 1-.563-.562ZM5.436 9a.656.656 0 1 1 1.312 0 .656.656 0 0 1-1.312 0ZM5.436 12.001a.656.656 0 1 1 1.312 0 .656.656 0 0 1-1.312 0ZM5.436 2.997c0-.725.587-1.312 1.312-1.312h4.503c.724 0 1.312.587 1.312 1.312v1.501c0 .725-.588 1.313-1.313 1.313H6.749a1.312 1.312 0 0 1-1.312-1.313v-1.5Zm1.312-.187a.187.187 0 0 0-.187.187v1.501c0 .104.083.188.187.188h4.503a.187.187 0 0 0 .187-.188v-1.5a.187.187 0 0 0-.188-.188H6.749Z'
            clipRule='evenodd'
          />
          <path
            fill='var(--text-primary)'
            fillRule='evenodd'
            d='M4.499 4.31a.938.938 0 0 0-.938.939v9.003c0 .518.42.938.938.938h9.003c.518 0 .938-.42.938-.938V5.25a.938.938 0 0 0-.938-.938h-1.5a.562.562 0 1 1 0-1.125h1.5c1.14 0 2.063.923 2.063 2.063v9.003c0 1.14-.923 2.063-2.063 2.063H4.5a2.063 2.063 0 0 1-2.063-2.063V5.25c0-1.14.923-2.063 2.063-2.063h1.5A.563.563 0 0 1 6 4.31H4.5Z'
            clipRule='evenodd'
          />
        </>
      );
    }
    case 'notification-inbox': {
      return (
        <>
          <path
            fill='var(--accent-caution)'
            d='M0 14C0 6.268 6.268 0 14 0s14 6.268 14 14-6.268 14-14 14S0 21.732 0 14Z'
          />
          <path
            fill='var(--text-white)'
            fillRule='evenodd'
            d='M14 8.5a3.502 3.502 0 0 0-3.504 3.5v2.667c0 .809-.366 1.574-.998 2.08l-.206.166a.33.33 0 0 0 .207.587h9.003a.33.33 0 0 0 .207-.587l-.206-.165a2.67 2.67 0 0 1-.999-2.081V12c0-1.933-1.568-3.5-3.504-3.5ZM9.496 12c0-2.486 2.017-4.5 4.504-4.5a4.502 4.502 0 0 1 4.504 4.5v2.667c0 .505.23.984.625 1.301l.206.165c.98.787.422 2.367-.833 2.367H9.499c-1.255 0-1.813-1.58-.833-2.367l.206-.165c.395-.317.624-.796.624-1.301V12ZM12.5 20a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5Z'
            clipRule='evenodd'
          />
        </>
      );
    }
    case 'message-unread-icon': {
      return (
        <>
          <path
            fill='var(--accent-caution)'
            d='M0 14C0 6.268 6.268 0 14 0s14 6.268 14 14-6.268 14-14 14S0 21.732 0 14Z'
          />
          <path
            fill='var(--text-white)'
            fillRule='evenodd'
            d='M9.207 10.023a1.833 1.833 0 0 1 1.717-1.19h6.152c.764 0 1.448.474 1.717 1.19l1.59 4.242c.078.205.117.424.117.643v2.425c0 1.013-.82 1.833-1.833 1.833H9.333A1.833 1.833 0 0 1 7.5 17.333v-2.425c0-.22.04-.437.116-.643l1.591-4.242Zm.936.351-1.59 4.24a.84.84 0 0 0-.053.294v2.425c0 .46.373.833.833.833h9.334c.46 0 .833-.372.833-.833v-2.425c0-.1-.018-.2-.053-.292l-1.59-4.242a.833.833 0 0 0-.781-.541h-6.152a.833.833 0 0 0-.78.541Z'
            clipRule='evenodd'
          />
          <path
            fill='var(--text-white)'
            fillRule='evenodd'
            d='M7.523 14.667a.5.5 0 0 1 .5-.5h2.9c.441 0 .845.25 1.043.646l.297.595a.168.168 0 0 0 .15.092h3.176c.063 0 .12-.035.148-.091l.299-.597a1.168 1.168 0 0 1 1.043-.645h2.9a.5.5 0 1 1 0 1h-2.9a.167.167 0 0 0-.15.093l-.297.595a1.166 1.166 0 0 1-1.043.645h-3.176c-.443 0-.846-.25-1.044-.644l-.298-.597a.167.167 0 0 0-.149-.092H8.023a.5.5 0 0 1-.5-.5Z'
            clipRule='evenodd'
          />
          <circle
            cx={18}
            cy={10}
            r={2.571}
            fill='var(--text-white)'
            stroke='var(--accent-caution)'
            strokeWidth={0.857}
          />
        </>
      );
    }
    case 'message-icon': {
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M1.685 9A7.315 7.315 0 0 1 9 1.685a7.315 7.315 0 0 1 6.488 10.687l.81 3.24a.565.565 0 0 1-.685.686l-3.24-.81A7.315 7.315 0 0 1 1.684 9ZM9 2.815a6.185 6.185 0 1 0 3.02 11.579.565.565 0 0 1 .414-.056l2.54.635-.636-2.54a.565.565 0 0 1 .056-.413A6.185 6.185 0 0 0 9 2.815Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M8.468 8.843a.752.752 0 1 1 0 1.064l-.002-.002a.754.754 0 0 1 0-1.06M5.468 8.843a.752.752 0 1 1 0 1.064l-.002-.002a.754.754 0 0 1 0-1.06M11.468 8.843a.752.752 0 1 1 0 1.064l-.002-.002a.754.754 0 0 1 0-1.06'
            clipRule='evenodd'
          />
        </>
      );
    }
    // project icon for create new message dropdown
    case 'teamcamp-mobile-icon': {
      return (
        <>
          <rect width={29} height={29} x={0.5} y={0.5} fill={fill} rx={14.5} />
          <rect width={29} height={29} x={0.5} y={0.5} stroke={stroke} rx={14.5} />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M10.076 12.714a.88.88 0 0 0-.88.88v6.33c0 .486.394.88.88.88h9.848a.88.88 0 0 0 .88-.88v-6.33a.88.88 0 0 0-.88-.88h-9.848Zm-1.934.88c0-1.07.866-1.935 1.934-1.935h9.848c1.068 0 1.934.866 1.934 1.934v6.33a1.934 1.934 0 0 1-1.934 1.935h-9.848a1.934 1.934 0 0 1-1.934-1.934v-6.33Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M11.659 10.78c0-1.069.866-1.935 1.934-1.935h2.814c1.068 0 1.934.866 1.934 1.934v10.552a.527.527 0 0 1-1.055 0V10.78a.88.88 0 0 0-.88-.88h-2.813a.88.88 0 0 0-.88.88v10.55a.527.527 0 0 1-1.054 0V10.78Z'
            clipRule='evenodd'
          />
        </>
      );
    }
    case 'small-filters-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M6.95 13.36c0-.312.253-.565.565-.565h2.93a.565.565 0 0 1 0 1.13h-2.93a.565.565 0 0 1-.565-.565ZM3.88 9.029c0-.312.253-.565.565-.565h9.06a.565.565 0 0 1 0 1.13h-9.06a.565.565 0 0 1-.565-.565ZM1.611 4.64c0-.312.253-.565.565-.565h13.648a.565.565 0 1 1 0 1.13H2.176a.565.565 0 0 1-.565-.565Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'new-chat-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M1.685 9A7.315 7.315 0 0 1 9 1.685a7.315 7.315 0 0 1 6.488 10.687l.81 3.24a.565.565 0 0 1-.685.686l-3.24-.81A7.315 7.315 0 0 1 1.684 9ZM9 2.815a6.185 6.185 0 1 0 3.02 11.579.565.565 0 0 1 .414-.056l2.54.635-.636-2.54a.565.565 0 0 1 .056-.413A6.185 6.185 0 0 0 9 2.815Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M5.81 9c0-.312.253-.565.565-.565h5.25a.565.565 0 0 1 0 1.13h-5.25A.565.565 0 0 1 5.81 9Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M9 5.81c.312 0 .565.253.565.565v5.25a.565.565 0 0 1-1.13 0v-5.25c0-.312.253-.565.565-.565Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'expand-chat-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M16.105 1.816a.557.557 0 0 1 .218.446v5.257a.563.563 0 1 1-1.126 0V3.62L9.399 9.42a.563.563 0 0 1-.797-.796L14.4 2.825h-3.897a.563.563 0 1 1 0-1.127h5.257a.57.57 0 0 1 .345.118Zm0 0A.56.56 0 0 0 15.8 1.7l.304.116Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M1.678 3.764c0-1.141.924-2.066 2.065-2.066h3.004a.563.563 0 0 1 0 1.127H3.743a.938.938 0 0 0-.939.939v10.514c0 .519.42.939.94.939h10.514c.518 0 .938-.42.938-.939v-3.004a.563.563 0 0 1 1.127 0v3.004a2.065 2.065 0 0 1-2.066 2.065H3.744a2.065 2.065 0 0 1-2.065-2.065V3.764Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'complete-icon':
      return (
        <>
          <g clipPath='url(#clip0_26851_232042)'>
            <path fill={fill} d='M16 8A8 8 0 1 0 0 8a8 8 0 0 0 16 0Z' className='complete-fill' />
            <path
              fill='var(--text-white)'
              fillRule='evenodd'
              d='M12.338 5.161a.548.548 0 0 1 0 .78l-4.932 4.898a.557.557 0 0 1-.785 0l-2.959-2.94a.548.548 0 0 1 0-.778.557.557 0 0 1 .785 0L7.014 9.67l4.539-4.509a.557.557 0 0 1 .784 0Z'
              clipRule='evenodd'
            />
          </g>
          <defs>
            <clipPath id='clip0_26851_232042'>
              <path fill='var(--text-white)' d='M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Z' />
            </clipPath>
          </defs>
        </>
      );
    case 'open-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M8 16a8 8 0 0 1-8-8 8 8 0 0 1 8-8 8 8 0 0 1 8 8 8 8 0 0 1-8 8Z'
            clipRule='evenodd'
            className='first-path'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M1 8a7 7 0 0 0 7 7 7 7 0 0 0 7-7 7 7 0 0 0-7-7 7 7 0 0 0-7 7ZM0 8a8 8 0 0 0 8 8 8 8 0 0 0 8-8 8 8 0 0 0-8-8 8 8 0 0 0-8 8Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M12.338 5.161a.548.548 0 0 1 0 .78l-4.932 4.898a.557.557 0 0 1-.785 0l-2.959-2.94a.548.548 0 0 1 0-.778.557.557 0 0 1 .785 0L7.014 9.67l4.539-4.509a.557.557 0 0 1 .784 0Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'social-twitter-icon': {
      return (
        <>
          <circle cx={11.999} cy={12} r={12} fill={fill} />
          <path
            fill={fill}
            d='m11.805 9.743.03.486-.488-.06C9.57 9.942 8.02 9.168 6.703 7.867L6.06 7.22l-.166.477c-.351 1.063-.127 2.185.605 2.94.39.416.302.476-.371.228-.234-.08-.439-.14-.459-.11-.068.07.166.974.352 1.331.253.497.77.983 1.336 1.271l.478.229-.566.01c-.546 0-.566.01-.507.218.195.646.966 1.33 1.824 1.629l.605.208-.527.318a5.458 5.458 0 0 1-2.614.735c-.44.01-.8.05-.8.08 0 .099 1.19.655 1.883.873 2.077.646 4.545.368 6.399-.735 1.316-.784 2.633-2.343 3.248-3.853.331-.804.663-2.274.663-2.979 0-.457.03-.516.576-1.062.322-.318.624-.666.682-.765.098-.189.088-.189-.41-.02-.828.298-.945.258-.536-.189.303-.317.664-.893.664-1.062 0-.03-.147.02-.313.11-.175.098-.565.247-.858.337l-.527.169-.478-.328c-.263-.179-.634-.377-.829-.437-.497-.14-1.258-.12-1.707.04-1.22.447-1.99 1.599-1.902 2.86Z'
          />
        </>
      );
    }
    case 'social-email-icon': {
      return (
        <>
          <circle cx={11.999} cy={12} r={12} fill={fill} />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M6 8.784s5.024 2.782 6 2.782c1.022 0 5.992-2.728 5.992-2.728L18 8.35a.988.988 0 0 0-1-.975H7c-.553 0-1 .437-1 .975v.434ZM17.992 10.3S13.07 12.906 12 12.906c-.975 0-5.992-2.606-5.992-2.606L6 16.15c0 .538.448.975 1 .975h10c.553 0 1-.437 1-.975l-.008-5.85Z'
            clipRule='evenodd'
          />
        </>
      );
    }
    case 'social-facebook-icon': {
      return (
        <>
          <circle cx={11.999} cy={12} r={12} fill={fill} />
          <path
            fill={fill}
            d='M13.904 7.992h1.095V6.085A14.146 14.146 0 0 0 13.403 6c-1.579 0-2.661.994-2.661 2.82v1.68H8.999v2.133h1.743V18h2.137v-5.367h1.673l.265-2.132h-1.938V9.03c0-.617.166-1.039 1.025-1.039Z'
          />
        </>
      );
    }
    case 'app-loading': {
      return (
        <>
          <g fill='none' fillRule='evenodd' strokeWidth={2} transform='translate(1 1)'>
            <circle cx={18} cy={18} r={18} strokeOpacity={0.5} />
            <path d='M36 18c0-9.94-8.06-18-18-18'>
              <animateTransform
                attributeName='transform'
                dur='1s'
                from='0 18 18'
                repeatCount='indefinite'
                to='360 18 18'
                type='rotate'
              />
            </path>
          </g>
        </>
      );
    }
    case 'view-icon': {
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M5.562 5.66c-1.093.845-2.054 2.008-2.729 3.257l-.495-.268.495.267a.178.178 0 0 0 0 .167l-.495.267.495-.267c.675 1.25 1.636 2.412 2.73 3.256 1.095.848 2.288 1.348 3.437 1.348s2.341-.5 3.437-1.348c1.094-.844 2.054-2.006 2.73-3.255a.178.178 0 0 0 0-.167l.494-.267-.495.267c-.675-1.25-1.635-2.412-2.729-3.256C11.341 4.813 10.15 4.313 9 4.313s-2.342.5-3.438 1.347Zm10.1 3.69v.001H2.337m2.536-4.58C6.1 3.823 7.527 3.187 9 3.187c1.472 0 2.9.636 4.125 1.582 1.228.95 2.287 2.237 3.031 3.612.208.386.208.851 0 1.236-.744 1.376-1.803 2.663-3.03 3.612-1.225.946-2.654 1.582-4.126 1.582-1.473 0-2.901-.636-4.126-1.582-1.227-.95-2.287-2.237-3.03-3.612a1.303 1.303 0 0 1 0-1.236c.743-1.376 1.803-2.663 3.03-3.612Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M10.191 7.808a1.685 1.685 0 1 0-2.383 2.383 1.685 1.685 0 0 0 2.383-2.383Zm.8-.799a2.815 2.815 0 1 0-3.982 3.981 2.815 2.815 0 0 0 3.981-3.98Z'
            clipRule='evenodd'
          />
        </>
      );
    }
    case 'remove-parent-task-icon': {
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='m16.827 10.813-2.738-3.467a1.078 1.078 0 0 0-1.692 0l-2.74 3.468a1.097 1.097 0 0 0 .861 1.775h.789a4.385 4.385 0 0 1-1.537 2.727.565.565 0 0 0 .361 1h.266a4.766 4.766 0 0 0 4.647-3.727h.924m.859-1.776a1.096 1.096 0 0 1-.86 1.776m-.07-1.13h-1.33a.565.565 0 0 0-.562.501 3.636 3.636 0 0 1-2.44 3.032c.576-.869.902-1.894.92-2.959a.565.565 0 0 0-.566-.574h-1.33l2.654-3.361 2.654 3.36Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M15.75 7.315a.565.565 0 0 0 .565-.565V6A4.315 4.315 0 0 0 12 1.685H6A4.315 4.315 0 0 0 1.685 6v6A4.315 4.315 0 0 0 6 16.315h1.5a.565.565 0 1 0 0-1.13H6A3.185 3.185 0 0 1 2.815 12V6A3.185 3.185 0 0 1 6 2.815h6A3.185 3.185 0 0 1 15.185 6v.75c0 .312.253.565.565.565Z'
            clipRule='evenodd'
          />
        </>
      );
    }
    case 'create-sub-task-icon': {
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M3.667 13.688a.855.855 0 0 1-.854-.855V2.917c0-.472.382-.854.854-.854h9.916c.472 0 .854.382.854.854v4.25a.562.562 0 1 0 1.126 0v-4.25a1.98 1.98 0 0 0-1.98-1.98H3.667a1.98 1.98 0 0 0-1.98 1.98v9.916a1.98 1.98 0 0 0 1.98 1.98h4.25a.562.562 0 1 0 0-1.126h-4.25Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M13.665 16.313c.31 0 .563-.252.563-.563v-5.67a.562.562 0 1 0-1.126 0v5.67c0 .31.252.563.563.563Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M10.268 12.915c0 .31.251.563.562.563h5.67a.563.563 0 0 0 0-1.126h-5.67a.563.563 0 0 0-.562.563Z'
            clipRule='evenodd'
          />
        </>
      );
    }
    case 'milestone-icon': {
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M9.303 2.966a.38.38 0 0 0-.607 0L4.05 8.683a.512.512 0 0 0 0 .633l4.647 5.717a.38.38 0 0 0 .607 0l4.647-5.717.389.316-.389-.316a.512.512 0 0 0 0-.633l.406-.33-.406.33-4.647-5.717Zm.877-.713a1.51 1.51 0 0 0-2.36 0h2.36Zm-2.36 0L3.171 7.97a1.642 1.642 0 0 0 0 2.059l4.647 5.717a1.509 1.509 0 0 0 2.36 0l4.648-5.717a1.642 1.642 0 0 0 0-2.059L10.18 2.253'
            clipRule='evenodd'
          />
        </>
      );
    }
    case 'updated-label-icon': {
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M12.416 5.584a.893.893 0 1 0-1.262 1.262.893.893 0 0 0 1.262-1.262Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M14.86 2.813c.18 0 .328.146.328.327v4.97c0 .086-.035.17-.097.232l-6.49 6.49a1.217 1.217 0 0 1-1.72 0l-3.712-3.713a1.217 1.217 0 0 1 0-1.72l6.49-6.49-.398-.398.398.397a.323.323 0 0 1 .23-.095h4.97Zm-5.998-.7a1.448 1.448 0 0 1 1.027-.425h4.97c.803 0 1.454.65 1.454 1.452v4.97c0 .386-.155.756-.426 1.027l-6.49 6.49a2.342 2.342 0 0 1-3.312 0l-3.712-3.712a2.342 2.342 0 0 1 0-3.312l6.489-6.489Z'
            clipRule='evenodd'
          />
        </>
      );
    }
    case 'activity-reopentask-icon': {
      return (
        <>
          <g fillRule='evenodd' clipPath='url(#a)' clipRule='evenodd'>
            <path fill='#fff' d='M8 16a8 8 0 0 1-8-8 8 8 0 0 1 8-8 8 8 0 0 1 8 8 8 8 0 0 1-8 8Z' />
            <path
              fill={fill}
              d='M1 8a7 7 0 0 0 7 7 7 7 0 0 0 7-7 7 7 0 0 0-7-7 7 7 0 0 0-7 7ZM0 8a8 8 0 0 0 8 8 8 8 0 0 0 8-8 8 8 0 0 0-8-8 8 8 0 0 0-8 8Z'
            />
            <path
              fill={fill}
              d='M12.338 5.161a.548.548 0 0 1 0 .78l-4.932 4.898a.557.557 0 0 1-.785 0l-2.959-2.94a.548.548 0 0 1 0-.778.557.557 0 0 1 .785 0L7.014 9.67l4.539-4.509a.557.557 0 0 1 .784 0Z'
            />
          </g>
          <defs>
            <clipPath id='a'>
              <path fill='#fff' d='M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Z' />
            </clipPath>
          </defs>
        </>
      );
    }
    case 'activity-completedtask-icon': {
      return (
        <>
          <g clipPath='url(#clip0_445_3613)'>
            <path fill={fill} d='M16 8A8 8 0 1 0 0 8a8 8 0 0 0 16 0Z' />
            <path
              fill='#fff'
              fillRule='evenodd'
              d='M12.338 5.161a.548.548 0 0 1 0 .78l-4.932 4.898a.557.557 0 0 1-.785 0l-2.959-2.94a.548.548 0 0 1 0-.778.557.557 0 0 1 .785 0L7.014 9.67l4.539-4.509a.557.557 0 0 1 .784 0Z'
              clipRule='evenodd'
            />
          </g>
          <defs>
            <clipPath id='clip0_445_3613'>
              <path fill='#fff' d='M0 8a8 8 0 1 1 16 0A8 8 0 1 1 0 8Z' />
            </clipPath>
          </defs>
        </>
      );
    }
    case 'member-plus-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M1.093 14.813a3.75 3.75 0 0 1 3.75-3.75h5.625a3.75 3.75 0 0 1 3.75 3.75v.562a.563.563 0 0 1-1.125 0v-.563a2.625 2.625 0 0 0-2.625-2.624H4.843a2.625 2.625 0 0 0-2.625 2.624v.563a.562.562 0 1 1-1.125 0v-.563ZM7.655 3.188a2.438 2.438 0 1 0 0 4.875 2.438 2.438 0 0 0 0-4.876ZM4.093 5.624a3.563 3.563 0 1 1 7.125 0 3.563 3.563 0 0 1-7.125 0ZM14.405 5.572c.31 0 .563.252.563.563v3.881a.563.563 0 0 1-1.125 0V6.135c0-.31.252-.563.562-.563Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M11.902 8.075c0-.31.252-.562.563-.562h3.88a.562.562 0 1 1 0 1.125h-3.88a.563.563 0 0 1-.563-.563Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'overview-incompletetask-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M2.438 5.25c0-1.14.923-2.063 2.062-2.063H6a.563.563 0 0 1 0 1.126H4.5a.937.937 0 0 0-.938.937v9c0 .518.42.938.938.938h3a.562.562 0 1 1 0 1.124h-3a2.062 2.062 0 0 1-2.063-2.062v-9Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M5.438 3c0-.725.587-1.313 1.312-1.313h4.5c.725 0 1.313.588 1.313 1.313v1.5c0 .725-.588 1.313-1.313 1.313h-4.5A1.313 1.313 0 0 1 5.437 4.5V3Zm1.312-.188A.188.188 0 0 0 6.562 3v1.5c0 .104.084.188.188.188h4.5a.187.187 0 0 0 .188-.188V3a.187.187 0 0 0-.188-.188h-4.5Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M11.438 3.75c0-.31.251-.563.562-.563h1.5c1.14 0 2.063.924 2.063 2.063V7.5a.562.562 0 1 1-1.126 0V5.25a.937.937 0 0 0-.937-.938H12a.562.562 0 0 1-.563-.562ZM11.182 11.181c.22-.22.576-.22.796 0l1.59 1.591a.562.562 0 1 1-.795.796l-1.59-1.591a.563.563 0 0 1 0-.796Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M13.569 11.181c.22.22.22.576 0 .796l-1.591 1.59a.562.562 0 1 1-.796-.795l1.591-1.59c.22-.22.576-.22.796 0Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M12.375 9.563a2.813 2.813 0 1 0 0 5.625 2.813 2.813 0 0 0 0-5.626Zm0 6.75a3.938 3.938 0 1 1 0-7.876 3.938 3.938 0 0 1 0 7.876Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'overview-overduetask-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M9 2.815a6.185 6.185 0 1 0 0 12.37 6.185 6.185 0 1 0 0-12.37Zm0 13.5A7.315 7.315 0 0 1 1.685 9 7.315 7.315 0 0 1 9 1.685 7.315 7.315 0 0 1 16.315 9 7.315 7.315 0 0 1 9 16.315Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M9 5.06c.312 0 .565.253.565.565v3.75a.565.565 0 0 1-1.13 0v-3.75c0-.312.253-.565.565-.565ZM8.247 12.19a.751.751 0 1 1 1.505-.003.753.753 0 0 1-1.505.002Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'reply-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M8.47 2.103a.574.574 0 0 1 .355.531v3.002c4.246.561 7.49 4.386 7.49 8.976v.754a.575.575 0 0 1-1.098.238c-.953-2.101-3.392-3.71-6.392-3.893v2.906a.575.575 0 0 1-.98.406L1.852 9.032a.574.574 0 0 1 0-.813l5.991-5.991a.574.574 0 0 1 .626-.125Zm-.794 9.017v-.001c0-.317.257-.575.575-.575 2.756 0 5.244 1.08 6.82 2.797-.549-3.622-3.402-6.384-6.858-6.612a.574.574 0 0 1-.537-.573V4.02L3.071 8.626l4.605 4.604v-2.11Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'tasklist-calendar-icon':
      return (
        <>
          <path
            fill={fill}
            d='M15 5a4 4 0 0 1 4 4v6a4 4 0 0 1-4 4H9a4 4 0 0 1-4-4V9a4 4 0 0 1 4-4h6Zm2.5 5h-11v5A2.5 2.5 0 0 0 9 17.5h6a2.5 2.5 0 0 0 2.5-2.5v-5Z'
          />
        </>
      );
    case 'tasklist-calendar-duedate-icon':
      return (
        <>
          <path
            fill={fill}
            d='M14.889 4.889a4 4 0 0 1 4 4v1.25a.75.75 0 0 1-1.5 0v-.25h-11v5a2.5 2.5 0 0 0 2.5 2.5h1.25a.75.75 0 0 1 0 1.5h-1.25a4 4 0 0 1-4-4v-6a4 4 0 0 1 4-4h6Zm-1.47 7.47 1.97 1.97 1.97-1.97a.75.75 0 1 1 1.06 1.06l-1.97 1.97 1.97 1.97a.75.75 0 1 1-1.06 1.06l-1.97-1.97-1.97 1.97a.75.75 0 1 1-1.06-1.06l1.97-1.97-1.97-1.97a.75.75 0 1 1 1.06-1.06Z'
          />
        </>
      );
    case 'microphone-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M6.374 8.438c.31 0 .563.251.563.562 0 1.14.923 2.064 2.063 2.064a.562.562 0 1 1 0 1.125A3.189 3.189 0 0 1 5.812 9c0-.31.251-.563.562-.563ZM6.375 6.563a.563.563 0 1 1-.563.563v-.001c0-.31.252-.563.563-.563Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M6.375 5.812c.31 0 .563.251.563.562v2.625a.563.563 0 0 1-1.125 0V6.374c0-.31.251-.562.562-.562Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M3.374 8.063c.31 0 .562.252.562.563a5.058 5.058 0 0 0 8.468 3.741.562.562 0 0 1 .758.831A6.183 6.183 0 0 1 2.811 8.624c0-.31.252-.562.563-.562Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M8.994 13.688c.31 0 .563.251.563.562v2.25a.562.562 0 1 1-1.125 0v-2.25c0-.31.251-.563.562-.563ZM2.6 2.6c.219-.22.575-.22.795 0L15.4 14.603a.562.562 0 1 1-.796.796L2.6 3.395a.563.563 0 0 1 0-.796ZM6.178 2.703a3.177 3.177 0 0 1 6.01 1.45v.001l-.562-.002h.563v4.097a.562.562 0 1 1-1.125 0v-4.1a2.052 2.052 0 0 0-3.883-.937.562.562 0 1 1-1.003-.509ZM14.629 8.063c.31 0 .562.253.56.564a6.12 6.12 0 0 1-.625 2.678.563.563 0 0 1-1.01-.495c.334-.68.509-1.428.51-2.187.002-.31.254-.561.565-.56Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M11.254 10.46c.22.219.22.575 0 .795A3.18 3.18 0 0 1 9 12.189a.563.563 0 0 1 .002-1.125c.547 0 1.071-.217 1.457-.604.22-.22.576-.22.796 0Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'subscripton-successful-icon': {
      return (
        <>
          <path
            fill={fill}
            d='M56 28.003C56 43.465 43.465 56 28.003 56 12.535 56 0 43.465 0 28.003 0 12.535 12.535 0 28.003 0 43.465 0 56 12.535 56 28.003Z'
          />
          <path
            fill='#00A16F'
            d='m12.412 26.004 10.238 6.17L48.95 5.97c.745-.737 1.95.179 1.409 1.069L25.54 44.01c-1.044 1.564-3.395 1.501-4.358-.105l-10.04-16.764c-.391-.79.508-1.595 1.269-1.137Z'
          />
        </>
      );
    }
    case 'invitation-link-icon': {
      return (
        <>
          <path
            stroke={iconprimary}
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={2.5}
            fill='none'
            d='m26.036 18.018 2.308-2.308a5.696 5.696 0 1 0-8.054-8.054l-4.936 4.936a5.693 5.693 0 0 0-.002 8.051l.002.003-.014.015c.46.45.993.82 1.578 1.09'
          />
          <path
            stroke={iconprimary}
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={2.5}
            fill='none'
            d='M19.083 14.248c.585.271 1.118.64 1.578 1.092a5.693 5.693 0 0 1 .003 8.05l-.003.004-4.935 4.935a5.696 5.696 0 0 1-8.054-8.054l2.307-2.308M24.003 31.506v-3.001M28.505 24.003h3.001M4.495 11.998h3M11.998 4.495v3'
          />
        </>
      );
    }
    case 'storage-info-icon': {
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M9 2.815a6.185 6.185 0 1 0 0 12.37 6.185 6.185 0 1 0 0-12.37Zm0 13.5A7.315 7.315 0 0 1 1.685 9 7.315 7.315 0 0 1 9 1.685 7.315 7.315 0 0 1 16.315 9 7.315 7.315 0 0 1 9 16.315Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M9 13.128a.565.565 0 0 0 .565-.565v-3.75a.565.565 0 0 0-1.13 0v3.75c0 .312.253.565.565.565ZM8.247 6.19a.751.751 0 1 1 1.505-.002.753.753 0 0 1-1.505.002Z'
            clipRule='evenodd'
          />
        </>
      );
    }
    case 'task-todo-icon': {
      return (
        <>
          <g fillRule='evenodd' clipRule='evenodd'>
            <path
              fill='var(--background-primary)'
              d='M8 16a8 8 0 0 1-8-8 8 8 0 0 1 8-8 8 8 0 0 1 8 8 8 8 0 0 1-8 8Z'
              className='desktop-fill'
            />
            <path
              fill='var(--border-secondary)'
              d='M1 8a7 7 0 0 0 7 7 7 7 0 0 0 7-7 7 7 0 0 0-7-7 7 7 0 0 0-7 7ZM0 8a8 8 0 0 0 8 8 8 8 0 0 0 8-8 8 8 0 0 0-8-8 8 8 0 0 0-8 8Z'
              className='fill-path'
            />
          </g>
          <defs>
            <clipPath id='a'>
              <path fill='var(--background-primary)' d='M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Z' />
            </clipPath>
          </defs>
        </>
      );
    }
    case 'task-cancelled-icon': {
      return (
        <>
          <path fill='var(--text-tertiary)' d='M16 8A8 8 0 1 0 0 8a8 8 0 0 0 16 0Z' className='fill-path' />
          <path
            fill='var(--text-white)'
            fillRule='evenodd'
            d='M4.171 4.171a.585.585 0 0 1 .828 0l6.83 6.83a.585.585 0 0 1-.828.828l-6.83-6.83a.585.585 0 0 1 0-.828Z'
            clipRule='evenodd'
          />
          <path
            fill='var(--text-white)'
            fillRule='evenodd'
            d='M11.829 4.171c.228.229.228.6 0 .828l-6.83 6.83A.585.585 0 1 1 4.171 11l6.83-6.83a.585.585 0 0 1 .828 0Z'
            clipRule='evenodd'
          />
        </>
      );
    }
    case 'task-inprogress-icon': {
      return (
        <>
          <path fill='var(--background-primary)' d='M16 8A8 8 0 1 0 0 8a8 8 0 0 0 16 0Z' className='transparent-fill' />
          <path
            fill='#F8D200'
            fillRule='evenodd'
            d='M15 8A7 7 0 1 0 1 8a7 7 0 0 0 14 0ZM8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0Z'
            clipRule='evenodd'
          />
          <path fill='#F8D200' d='M8 8V3a5 5 0 1 1 0 10V8Z' />
        </>
      );
    }
    case 'task-inreview-icon': {
      return (
        <>
          <path fill='var(--background-primary)' d='M16 8A8 8 0 1 0 0 8a8 8 0 0 0 16 0Z' className='transparent-fill' />
          <path
            fill='#5FBB25'
            fillRule='evenodd'
            d='M15 8A7 7 0 1 0 1 8a7 7 0 0 0 14 0ZM8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0Z'
            clipRule='evenodd'
          />
          <path fill='#5FBB25' d='M8 8V3a5 5 0 1 1-5 5h5Z' />
        </>
      );
    }
    case 'task-completed-icon': {
      return (
        <>
          <g clipPath='url(#clip0_26851_232042)'>
            <path fill='var(--text-tertiary)' d='M16 8A8 8 0 1 0 0 8a8 8 0 0 0 16 0Z' className='complete-fill' />
            <path
              fill='var(--text-white)'
              fillRule='evenodd'
              d='M12.338 5.161a.548.548 0 0 1 0 .78l-4.932 4.898a.557.557 0 0 1-.785 0l-2.959-2.94a.548.548 0 0 1 0-.778.557.557 0 0 1 .785 0L7.014 9.67l4.539-4.509a.557.557 0 0 1 .784 0Z'
              clipRule='evenodd'
            />
          </g>
          <defs>
            <clipPath id='clip0_26851_232042'>
              <path fill='var(--text-white)' d='M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Z' />
            </clipPath>
          </defs>
        </>
      );
    }
    case 'updated-task-completed-icon': {
      return (
        <>
          <path fill='var(--text-white)' d='M18 9A9 9 0 1 0 0 9a9 9 0 0 0 18 0Z' />
          <path
            fill='var(--green)'
            fillRule='evenodd'
            d='M13.88 5.807a.617.617 0 0 1 0 .876l-5.548 5.51a.627.627 0 0 1-.883 0L4.12 8.887a.617.617 0 0 1 0-.876.627.627 0 0 1 .883 0l2.887 2.867 5.107-5.071a.627.627 0 0 1 .883 0Z'
            clipRule='evenodd'
          />
        </>
      );
    }
    case 'task-status-icon':
      return (
        <>
          <g>
            <path
              fill='var(--background-primary)'
              d='M16 8A8 8 0 1 0 0 8a8 8 0 0 0 16 0Z'
              className='transparent-fill'
            />
            <path
              fill='var(--border-secondary)'
              fillRule='evenodd'
              d='M9.561.152a8.04 8.04 0 0 0-3.122 0l.194.981a7.04 7.04 0 0 1 2.734 0l.194-.98ZM3.555 1.347l.556.831a7.044 7.044 0 0 0-1.933 1.933l-.83-.556a8.044 8.044 0 0 1 2.207-2.208ZM.152 6.44l.981.194a7.04 7.04 0 0 0 0 2.734l-.98.194a8.04 8.04 0 0 1 0-3.122Zm1.195 6.006.831-.556a7.045 7.045 0 0 0 1.933 1.933l-.556.83a8.043 8.043 0 0 1-2.208-2.207Zm5.092 3.403.194-.981a7.033 7.033 0 0 0 2.734 0l.194.98a8.039 8.039 0 0 1-3.122 0Zm6.006-1.196-.556-.83a7.046 7.046 0 0 0 1.933-1.933l.83.556a8.042 8.042 0 0 1-2.207 2.207Zm3.403-5.09-.981-.195a7.033 7.033 0 0 0 0-2.734l.98-.194a8.039 8.039 0 0 1 0 3.122Zm-1.196-6.007-.83.556a7.045 7.045 0 0 0-1.933-1.933l.556-.83a8.043 8.043 0 0 1 2.207 2.207Z'
              clipRule='evenodd'
              className='fill-path'
            />
          </g>
          <defs>
            <clipPath id='a'>
              <path fill='var(--background-primary)' d='M0 0h16v16H0z' className='transparent-fill' />
            </clipPath>
          </defs>
        </>
      );
    case 'repeat-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M15.64 10.565a.865.865 0 0 1-1.224 0l-1.288-1.288a.565.565 0 1 1 .8-.799l1.1 1.1 1.1-1.1a.565.565 0 1 1 .8.8l-1.289 1.287ZM2.36 7.19a.865.865 0 0 1 1.223 0L4.87 8.478a.565.565 0 0 1-.8.799l-1.1-1.1-1.1 1.1a.565.565 0 0 1-.8-.8L2.36 7.19Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M3.075 7.45c.308.05.517.341.466.65a5.498 5.498 0 0 0 9.317 4.782.565.565 0 0 1 .8.798A6.627 6.627 0 0 1 2.426 7.916a.565.565 0 0 1 .65-.466ZM8.965 3.502A5.479 5.479 0 0 0 5.071 5.12a.565.565 0 0 1-.8-.798 6.627 6.627 0 0 1 11.221 5.838.565.565 0 1 1-1.113-.196 5.498 5.498 0 0 0-5.413-6.461Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'save-invoice-icon':
      return (
        <>
          <path
            fill={fill}
            d='M15.182 5.871a.938.938 0 0 0-.213-.594l-.063-.069-2.12-2.121a.937.937 0 0 0-.663-.275H3.755a.938.938 0 0 0-.938.945l.079 10.5.005.095c.051.47.449.835.932.835h10.411c.518 0 .938-.42.938-.937V5.871Zm1.125 8.379c0 1.14-.924 2.062-2.063 2.063H3.834a2.063 2.063 0 0 1-2.052-1.837l-.011-.21-.079-10.5a2.063 2.063 0 0 1 2.063-2.079h8.368c.548 0 1.072.219 1.458.605l2.121 2.121.137.151c.3.367.468.829.468 1.307v8.379Z'
          />
          <path
            fill={fill}
            d='M5.433 5.182V2.25a.563.563 0 0 1 1.125 0v2.932c0 .103.084.187.187.187h4.5a.188.188 0 0 0 .188-.187V2.25a.563.563 0 0 1 1.125 0v2.932c0 .724-.588 1.312-1.313 1.312h-4.5a1.313 1.313 0 0 1-1.312-1.312ZM12.188 15.75V9.965a.402.402 0 0 0-.402-.402H6.215a.403.403 0 0 0-.402.402v5.785a.562.562 0 1 1-1.125 0V9.965c0-.843.684-1.527 1.527-1.527h5.571c.843 0 1.527.684 1.527 1.527v5.785a.562.562 0 1 1-1.126 0Z'
          />
        </>
      );
    case 'history-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M.896 7.894a.5.5 0 0 1 .708 0L2.75 9.041l1.146-1.147a.5.5 0 1 1 .708.708l-1.5 1.5a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 0-.708Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M2.75 7.748a.5.5 0 0 1 .5.5c0 .421.052.831.144 1.232a.5.5 0 0 1-.975.223 6.488 6.488 0 0 1-.169-1.455.5.5 0 0 1 .5-.5Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M2.25 8.248a6.5 6.5 0 1 1 13 0 .5.5 0 0 1-1 0 5.5 5.5 0 1 0-11 0 .5.5 0 0 1-1 0Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M14.75 7.748a.5.5 0 0 1 .5.5 6.5 6.5 0 0 1-6.5 6.5.5.5 0 1 1 0-1 5.5 5.5 0 0 0 5.5-5.5.5.5 0 0 1 .5-.5Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M3.55 11.275a.5.5 0 0 1 .696.123 5.488 5.488 0 0 0 4.504 2.35.5.5 0 0 1 0 1c-2.205 0-4.15-1.1-5.324-2.776a.5.5 0 0 1 .123-.697ZM8.563 5.071a.5.5 0 0 1 .5.5V8.43l2.19 1.303a.5.5 0 1 1-.511.86L8.306 9.143a.5.5 0 0 1-.245-.43V5.571a.5.5 0 0 1 .5-.5Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'markdown-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M1.808 4.732a.308.308 0 0 0-.308.308v7.92c0 .17.138.308.308.308h14.384c.17 0 .308-.138.308-.308V5.04a.308.308 0 0 0-.308-.308H1.808ZM.5 5.04c0-.722.586-1.308 1.308-1.308h14.384c.722 0 1.308.586 1.308 1.308v7.92c0 .722-.586 1.308-1.308 1.308H1.808A1.308 1.308 0 0 1 .5 12.96V5.04Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            d='M3.02 11.748V6.253h1.617l1.616 2.02 1.616-2.02h1.616v5.495H7.87V8.596l-1.616 2.02-1.616-2.02v3.152H3.02Zm10.101 0L10.697 9.08h1.616V6.253h1.617V9.08h1.616l-2.425 2.667Z'
          />
        </>
      );
    case 'html-code-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M10.46 2.749c.303.069.493.37.424.673l-2.67 11.703a.563.563 0 0 1-1.097-.25l2.67-11.703a.563.563 0 0 1 .673-.423ZM13.102 5.602c.22-.22.576-.22.796 0l3 3c.22.22.22.576 0 .796l-3 3a.562.562 0 1 1-.796-.796L15.704 9l-2.602-2.602a.562.562 0 0 1 0-.796ZM4.898 5.602c.22.22.22.576 0 .796L2.296 9l2.602 2.602a.562.562 0 1 1-.796.796l-3-3a.563.563 0 0 1 0-.796l3-3c.22-.22.576-.22.796 0Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'notion-icon':
      return (
        <>
          <path
            fill={fill}
            d='M3.796 3.623c.515.418.708.387 1.675.322l9.119-.547c.193 0 .032-.193-.032-.225l-1.515-1.095c-.29-.225-.676-.483-1.417-.419l-8.83.644c-.321.032-.386.193-.257.322l1.257.998Zm.547 2.125v9.594c0 .516.258.709.838.677l10.021-.58c.58-.032.645-.387.645-.806v-9.53c0-.417-.161-.643-.516-.61l-10.472.61c-.387.033-.516.227-.516.645Zm9.893.515c.064.29 0 .58-.29.612l-.483.096v7.083c-.42.226-.806.354-1.128.354-.516 0-.645-.16-1.032-.643L8.146 8.806v4.798l1 .225s0 .58-.807.58l-2.222.128c-.065-.129 0-.45.225-.515l.58-.16V7.518l-.805-.065c-.065-.29.096-.708.547-.74l2.385-.161 3.287 5.022V7.133l-.838-.096c-.065-.354.193-.612.515-.644l2.224-.13Zm-12.18-4.83 9.183-.676c1.128-.096 1.418-.031 2.127.483l2.931 2.06c.484.355.645.452.645.838v11.3c0 .709-.258 1.128-1.16 1.192l-10.665.644c-.677.032-1-.064-1.354-.515l-2.159-2.801c-.386-.516-.547-.902-.547-1.353V2.56c0-.579.258-1.062.998-1.126Z'
          />
        </>
      );
    case 'notion-info-icon':
      return (
        <>
          <path
            fill={fill}
            d='M15.19 9A6.19 6.19 0 1 0 2.81 9a6.19 6.19 0 0 0 12.38 0Zm1.125 0a7.316 7.316 0 1 1-14.63 0 7.316 7.316 0 0 1 14.63 0Z'
          />
          <path
            fill={fill}
            d='M8.893 5.437a2.166 2.166 0 0 1 2.282 2.027V7.5c0 .86-.626 1.39-1.014 1.705-.228.185-.384.302-.503.426-.082.086-.096.126-.097.13l-.01.104a.562.562 0 0 1-1.102 0l-.012-.114c0-.403.22-.702.409-.898.183-.192.43-.379.606-.521.411-.335.59-.554.597-.817a1.04 1.04 0 0 0-.987-.954l-.106.001h-.15a1.074 1.074 0 0 0-.995.83.563.563 0 0 1-1.095-.254 2.197 2.197 0 0 1 2.177-1.7ZM9.113 11.169a.56.56 0 0 1 .328.207c.13.103.215.26.215.438a.656.656 0 0 1-1.299.132l-.013-.133.013-.131A.656.656 0 0 1 9 11.157l.113.012Z'
          />
          <path fill={fill} d='M9.656 11.813a.558.558 0 0 1-1 .348A.56.56 0 0 1 9 11.155c.362 0 .656.294.656.656Z' />
        </>
      );
    case 'unassign-profile-icon':
      return (
        <>
          <circle cx={9} cy={9} r={9} fill='var(--background-tertiary)' />
          <path
            fill='var(--text-tertiary)'
            fillRule='evenodd'
            d='M14.37 16.222A8.96 8.96 0 0 1 9 18a8.96 8.96 0 0 1-5.372-1.777c.77-1.838 2.888-3.16 5.371-3.16 2.484 0 4.602 1.322 5.372 3.16Zm-2.245-7.446a3.125 3.125 0 1 1-6.25 0 3.125 3.125 0 0 1 6.25 0Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'copy-link-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M9.637 3.415a3.499 3.499 0 0 1 4.947 4.948L13.03 9.918a.565.565 0 1 1-.799-.799l1.556-1.555a2.37 2.37 0 0 0-3.35-3.35L8.88 5.77a.565.565 0 1 1-.8-.799l1.556-1.555Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M11.473 6.527c.22.22.22.578 0 .799l-4.147 4.147a.565.565 0 1 1-.8-.8l4.148-4.146c.22-.22.578-.22.799 0Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M5.77 8.082c.22.22.22.578 0 .799l-1.556 1.555a2.369 2.369 0 0 0 3.35 3.35l1.555-1.556a.565.565 0 1 1 .8.8l-1.556 1.555a3.5 3.5 0 0 1-4.948-4.948L4.97 8.08c.221-.22.579-.22.8 0Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'white-board-icon':
      return (
        <>
          <g fill={fill} fillRule='evenodd' clipPath='url(#clip0_42581_54006)' clipRule='evenodd'>
            <path d='M.833 2a.5.5 0 0 1 .5-.5h13.334a.5.5 0 1 1 0 1H1.333a.5.5 0 0 1-.5-.5Z' />
            <path d='M2 1.5a.5.5 0 0 1 .5.5v7.921c0 .476.419.912 1 .912h9c.581 0 1-.436 1-.912V2a.5.5 0 0 1 1 0v7.921c0 1.085-.924 1.912-2 1.912h-9c-1.076 0-2-.828-2-1.912V2a.5.5 0 0 1 .5-.5Z' />
            <path d='M8.443 10.886a.5.5 0 0 1 .67.224l1.334 2.666a.5.5 0 0 1-.894.448l-1.334-2.667a.5.5 0 0 1 .224-.67ZM7.557 10.886a.5.5 0 0 1 .224.67l-1.334 2.668a.5.5 0 1 1-.894-.448l1.333-2.666a.5.5 0 0 1 .671-.224Z' />
          </g>
          <defs>
            <clipPath id='clip0_42581_54006'>
              <path fill='#fff' d='M0 0h16v16H0z' />
            </clipPath>
          </defs>
        </>
      );
    case 'question-mark-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M5.435 6.656a3.564 3.564 0 1 1 7.13 0c0 1.497-.956 2.295-1.733 2.819-.723.486-1.267 1.003-1.267 1.931v.375a.565.565 0 1 1-1.13 0v-.375c0-1.522.97-2.334 1.765-2.868.706-.476 1.235-.98 1.235-1.882a2.434 2.434 0 1 0-4.87 0 .565.565 0 0 1-1.13 0ZM8.435 14.345a.565.565 0 1 1 1.13-.002.565.565 0 0 1-1.13.002Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'help-center-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M3.594 2.234a1.873 1.873 0 0 1 1.324-.548h5.442c.136 0 .266.054.362.15l4.082 4.081c.096.096.15.227.15.363v8.163a1.873 1.873 0 0 1-1.873 1.873H4.918a1.873 1.873 0 0 1-1.873-1.873V3.559c0-.497.197-.974.549-1.325Zm1.324.476a.848.848 0 0 0-.848.849v10.884a.848.848 0 0 0 .848.848h8.163a.848.848 0 0 0 .848-.848V6.492L10.148 2.71h-5.23Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M10.36 1.686c.283 0 .512.229.512.512v3.57h3.57a.512.512 0 0 1 0 1.024H10.36a.512.512 0 0 1-.513-.512V2.198c0-.283.23-.512.513-.512ZM5.769 9.681a.51.51 0 0 1 .51-.51h5.442a.51.51 0 1 1 0 1.02H6.279a.51.51 0 0 1-.51-.51ZM5.769 12.402a.51.51 0 0 1 .51-.51h5.442a.51.51 0 1 1 0 1.02H6.279a.51.51 0 0 1-.51-.51ZM5.769 6.96a.51.51 0 0 1 .51-.51h1.36a.51.51 0 1 1 0 1.02H6.28a.51.51 0 0 1-.51-.51Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'round-up-arrow-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M9 2.813a6.187 6.187 0 1 0 0 12.374A6.187 6.187 0 1 0 9 2.813Zm0 13.5A7.312 7.312 0 0 1 1.687 9 7.312 7.312 0 0 1 9 1.687 7.312 7.312 0 0 1 16.313 9 7.312 7.312 0 0 1 9 16.313Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M9 5.438c.31 0 .563.251.563.562v6a.562.562 0 1 1-1.126 0V6c0-.31.252-.563.563-.563Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M8.602 5.602c.22-.22.576-.22.796 0l2.25 2.25a.562.562 0 1 1-.796.796L9 6.795 7.148 8.649a.563.563 0 0 1-.796-.796l2.25-2.25Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'reaction-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M6.996 8.598a.802.802 0 1 1-1.604 0 .802.802 0 0 1 1.604 0ZM10.202 8.598a.802.802 0 1 1-1.604 0 .802.802 0 0 1 1.604 0Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M7.8 4.549a.497.497 0 0 1-.463.484 5.189 5.189 0 1 0 5.63 5.63.497.497 0 0 1 .484-.462c.256 0 .465.207.446.463a6.115 6.115 0 1 1-6.56-6.56c.255-.02.463.19.463.445Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M9.188 12.515a2.5 2.5 0 0 0 .703-.709c.14-.214.408-.329.644-.23.236.098.35.371.221.592a3.427 3.427 0 0 1-5.91.006c-.129-.22-.015-.494.22-.593.237-.1.505.015.645.229a2.502 2.502 0 0 0 3.477.705ZM13.41 1.685c.256 0 .463.207.463.463v4.885a.463.463 0 1 1-.926 0V2.148c0-.256.207-.463.463-.463Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M16.315 4.59a.463.463 0 0 1-.464.463h-4.885a.463.463 0 1 1 0-.926h4.885c.256 0 .464.207.464.463Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'star-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M8.956 3.075a.056.056 0 0 0-.023.026l-1.95 3.856-4.358.62a.073.073 0 0 0-.04.016.059.059 0 0 0-.017.026.046.046 0 0 0-.002.025c0 .002.002.01.016.024l3.162 3.003-.747 4.247c-.003.015 0 .02.001.024a.065.065 0 0 0 .022.024c.013.01.028.015.041.016.011.001.025 0 .045-.01L9 12.974l3.894 1.998c.02.01.034.011.045.01a.086.086 0 0 0 .04-.015c.014-.01.02-.02.023-.025.001-.004.003-.01 0-.024l-.746-4.247 3.162-3.003c.014-.014.016-.022.016-.024a.045.045 0 0 0-.002-.025.06.06 0 0 0-.017-.026.073.073 0 0 0-.04-.015l-4.357-.621L9.066 3.1a.056.056 0 0 0-.022-.026.089.089 0 0 0-.044-.01.089.089 0 0 0-.044.01Zm-1.03-.484c.442-.875 1.706-.875 2.149 0l1.685 3.33 3.775.538c.969.138 1.396 1.33.661 2.028l-2.722 2.586.642 3.65c.175.998-.884 1.692-1.738 1.254L9 14.244l-3.378 1.733c-.854.438-1.914-.256-1.738-1.254l.642-3.65-2.722-2.586c-.735-.698-.308-1.89.661-2.028l3.775-.538 1.685-3.33Z'
            clipRule='evenodd'
          />
        </>
      );

    case 'fill-star-icon':
      return (
        <>
          <path
            fill='#F8D200'
            d='m6.337 6.101 2.027-4.029a.716.716 0 0 1 1.273 0l2.027 4.03 4.534.65c.581.083.813.784.392 1.186l-3.28 3.134.774 4.428c.1.568-.509 1.002-1.03.733L9 14.142l-4.054 2.091c-.52.268-1.129-.165-1.03-.734l.775-4.427-3.28-3.134c-.422-.402-.19-1.103.392-1.187l4.534-.65Z'
          />
        </>
      );
    case 'my-timelog-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M9 2.813a6.188 6.188 0 1 0 0 12.375A6.188 6.188 0 0 0 9 2.812ZM1.687 9a7.313 7.313 0 1 1 14.626 0A7.313 7.313 0 0 1 1.688 9Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M12.773 6.915c.22.22.22.576 0 .795l-2.954 2.954a.563.563 0 0 1-.795 0l-1.29-1.29-1.711 1.711a.562.562 0 1 1-.796-.795l2.11-2.11a.563.563 0 0 1 .795 0l1.29 1.29 2.555-2.555c.22-.22.576-.22.796 0Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M9.703 7.313c0-.311.252-.563.563-.563h2.109c.31 0 .562.252.562.563v2.109a.562.562 0 1 1-1.125 0V7.875h-1.546a.562.562 0 0 1-.563-.563Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'invoice-drag-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M4.003 12.674a1.33 1.33 0 0 1 1.33-1.337c.736 0 1.337.596 1.337 1.333 0 .735-.598 1.333-1.333 1.333a1.335 1.335 0 0 1-1.334-1.33ZM4.003 8.007a1.33 1.33 0 0 1 1.33-1.337c.736 0 1.337.596 1.337 1.333 0 .735-.598 1.334-1.333 1.334a1.335 1.335 0 0 1-1.334-1.33ZM4.003 3.34a1.33 1.33 0 0 1 1.33-1.337c.736 0 1.337.596 1.337 1.334 0 .735-.598 1.333-1.333 1.333a1.335 1.335 0 0 1-1.334-1.33ZM9.337 12.674a1.33 1.33 0 0 1 1.33-1.337c.735 0 1.337.596 1.337 1.333 0 .735-.599 1.333-1.334 1.333a1.335 1.335 0 0 1-1.333-1.33ZM9.337 8.007a1.33 1.33 0 0 1 1.33-1.337c.735 0 1.337.596 1.337 1.333 0 .735-.599 1.334-1.334 1.334a1.335 1.335 0 0 1-1.333-1.33ZM9.337 3.34a1.33 1.33 0 0 1 1.33-1.337c.735 0 1.337.596 1.337 1.334 0 .735-.599 1.333-1.334 1.333a1.335 1.335 0 0 1-1.333-1.33Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'document-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M1.686 5.248a3.564 3.564 0 0 1 3.563-3.563h7.503a3.564 3.564 0 0 1 3.564 3.563v6.57c0 .747-.296 1.463-.823 1.99l-1.463 1.463a3.563 3.563 0 0 1-2.52 1.044H5.25a3.564 3.564 0 0 1-3.564-3.564V5.248ZM5.249 2.81a2.439 2.439 0 0 0-2.438 2.438v7.503a2.439 2.439 0 0 0 2.438 2.44h6.26c.647 0 1.267-.257 1.725-.715l1.463-1.464c.316-.316.494-.745.494-1.193v-6.57a2.439 2.439 0 0 0-2.439-2.44H5.25Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M5.438 7.015c0-.311.251-.563.562-.563h6a.562.562 0 1 1 0 1.125H6a.563.563 0 0 1-.563-.562ZM5.438 10.396c0-.311.251-.563.562-.563h3a.562.562 0 1 1 0 1.125H6a.562.562 0 0 1-.563-.563ZM12.753 11.813a.938.938 0 0 0-.938.939v3a.563.563 0 0 1-1.125 0v-3c0-1.14.923-2.064 2.063-2.064h3a.562.562 0 1 1 0 1.125h-3Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'snooze-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M14.715 6.633a6.186 6.186 0 1 0-11.43 4.734 6.186 6.186 0 0 0 11.43-4.734ZM6.203 2.246a7.31 7.31 0 1 0 5.595 13.51 7.31 7.31 0 0 0-5.595-13.51Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M8.788 5.427c.31 0 .563.252.563.562v3.173l2.472 1.507a.562.562 0 1 1-.586.96L8.495 9.959a.562.562 0 0 1-.27-.48V5.989c0-.31.252-.562.563-.562Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'today-snooze-icon':
      return (
        <>
          <path fill={fill} d='M6 4.5h12A1.5 1.5 0 0 1 19.5 6v2.5h-15V6A1.5 1.5 0 0 1 6 4.5Z' opacity={0.1} />
          <path
            fill={fill}
            d='M6 4h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Zm0 1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H6Zm1 3h10a.5.5 0 0 1 0 1H7a.5.5 0 1 1 0-1Z'
          />
          <path
            fill={fill}
            d='M7.11 17v-.716l2.215-2.295c.236-.249.431-.467.585-.655.155-.19.271-.37.348-.54.077-.17.115-.351.115-.543a1.01 1.01 0 0 0-.153-.563 1.003 1.003 0 0 0-.419-.367 1.33 1.33 0 0 0-.598-.131c-.234 0-.438.048-.613.144a.985.985 0 0 0-.403.405 1.28 1.28 0 0 0-.14.614h-.943c0-.399.091-.747.275-1.045.183-.298.434-.53.754-.694.32-.166.683-.249 1.09-.249.41 0 .773.082 1.086.246.316.162.562.384.739.665.176.279.265.594.265.946 0 .243-.046.48-.138.713-.09.232-.246.49-.47.776-.223.284-.534.628-.933 1.033l-1.3 1.361v.048h2.946V17H7.11Zm5.52 0v-.716l2.214-2.295c.237-.249.432-.467.585-.655.156-.19.272-.37.349-.54.076-.17.115-.351.115-.543a1.01 1.01 0 0 0-.154-.563 1.002 1.002 0 0 0-.418-.367 1.331 1.331 0 0 0-.598-.131c-.234 0-.439.048-.614.144a.985.985 0 0 0-.402.405c-.094.175-.14.38-.14.614h-.944c0-.399.092-.747.275-1.045.183-.298.435-.53.754-.694.32-.166.683-.249 1.09-.249.411 0 .774.082 1.087.246.315.162.561.384.738.665.177.279.265.594.265.946 0 .243-.045.48-.137.713-.09.232-.246.49-.47.776-.224.284-.535.628-.933 1.033l-1.3 1.361v.048h2.946V17H12.63Z'
          />
        </>
      );
    case 'thisweek-snooze-icon':
      return (
        <>
          <path fill={fill} d='M6 4.5h12A1.5 1.5 0 0 1 19.5 6v2.5h-15V6A1.5 1.5 0 0 1 6 4.5Z' opacity={0.1} />
          <path
            fill={fill}
            d='M18 4a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h12Zm0 1H6a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1Zm-1 3a.5.5 0 0 1 0 1H7a.5.5 0 1 1 0-1h10Z'
          />
          <path
            fill={fill}
            d='m11.687 10.109.01-.007-.005.004.04-.029a.52.52 0 0 1 .162-.066l.044-.007-.01.001h.011l.007-.002h.007l-.014.001.06-.004h.02c.045.002.089.01.131.023l.04.015c.033.013.064.03.093.05l.018.014c.014.01.028.021.04.033l2.512 2.511a.5.5 0 0 1-.638.765l-.07-.057-1.646-1.646V17.5a.5.5 0 0 1-.41.492L12 18a.5.5 0 0 1-.492-.41l-.008-.09v-5.792l-1.646 1.646a.5.5 0 0 1-.765-.638l.057-.07 2.512-2.51.001-.001.02-.017.01-.009Z'
          />
        </>
      );
    case 'bold-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M4.07 3.22c0-.328.266-.594.594-.594h4.817a3.484 3.484 0 0 1 2.341 6.063 3.485 3.485 0 0 1-1.378 6.685h-5.78a.594.594 0 0 1-.594-.594V3.22Zm1.188 6.374v4.592h5.186a2.296 2.296 0 1 0 0-4.592H5.258ZM9.48 8.406H5.258V3.814H9.48a2.296 2.296 0 0 1 0 4.592Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'italic-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M10.536 3.377c.33.083.532.418.449.748L8.212 15.216a.617.617 0 1 1-1.197-.3l2.773-11.09a.617.617 0 0 1 .748-.449Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M3.762 15.066c0-.34.276-.617.617-.617h6.47a.617.617 0 0 1 0 1.234h-6.47a.617.617 0 0 1-.617-.617ZM6.534 3.976c0-.341.277-.617.618-.617h6.47a.617.617 0 0 1 0 1.234h-6.47a.617.617 0 0 1-.618-.617Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'strike-icon':
      return (
        <>
          <g fill={fill} fillRule='evenodd' clipPath='url(#clip0_10967_89329)' clipRule='evenodd'>
            <path d='M9.777 9.817a.565.565 0 0 1 .73-.324l.23.089a3.144 3.144 0 0 1 2.01 2.931v.005a3.144 3.144 0 0 1-3.144 3.144H7.67a3.144 3.144 0 0 1-3.144-3.144.565.565 0 1 1 1.13 0c0 1.112.902 2.014 2.014 2.014h1.934a2.014 2.014 0 0 0 2.014-2.014v-.005c0-.831-.512-1.577-1.288-1.877l-.229-.089a.565.565 0 0 1-.323-.73Z' />
            <path d='M2.633 10.021c0-.312.253-.565.565-.565H14.8a.565.565 0 1 1 0 1.13H3.198a.565.565 0 0 1-.565-.565ZM7.767 4.059A2.112 2.112 0 0 0 5.655 6.17c0 .502.191.973.517 1.354a.565.565 0 0 1-.86.733 3.213 3.213 0 0 1-.787-2.087A3.242 3.242 0 0 1 7.767 2.93h1.836a3.144 3.144 0 0 1 3.144 3.143.565.565 0 0 1-1.13 0A2.014 2.014 0 0 0 9.603 4.06H7.767Z' />
          </g>
          <defs>
            <clipPath id='clip0_10967_89329'>
              <path fill='#fff' d='M0 0h18v18H0z' />
            </clipPath>
          </defs>
        </>
      );
    case 'underline-icon':
      return (
        <>
          <g fill={fill} fillRule='evenodd' clipPath='url(#clip0_10967_90667)' clipRule='evenodd'>
            <path d='M5.445 3c.312 0 .565.253.565.565v5.333a2.99 2.99 0 1 0 5.982 0V3.565a.565.565 0 0 1 1.13 0v5.333a4.12 4.12 0 1 1-8.242 0V3.565c0-.312.253-.565.565-.565ZM3.991 15.12c0-.311.253-.564.565-.564h8.89a.565.565 0 1 1 0 1.13h-8.89a.565.565 0 0 1-.565-.565Z' />
          </g>
          <defs>
            <clipPath id='clip0_10967_90667'>
              <path fill='#fff' d='M0 0h18v18H0z' />
            </clipPath>
          </defs>
        </>
      );
    case 'code-block-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M10.46 2.749c.303.069.493.37.424.673l-2.67 11.703a.563.563 0 0 1-1.097-.25l2.67-11.703a.563.563 0 0 1 .673-.423ZM13.102 5.602c.22-.22.576-.22.796 0l3 3c.22.22.22.576 0 .796l-3 3a.562.562 0 1 1-.796-.796L15.704 9l-2.602-2.602a.562.562 0 0 1 0-.796ZM4.898 5.602c.22.22.22.576 0 .796L2.296 9l2.602 2.602a.562.562 0 1 1-.796.796l-3-3a.563.563 0 0 1 0-.796l3-3c.22-.22.576-.22.796 0Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'bullet-list-icon':
      return (
        <>
          <g fill={fill} fillRule='evenodd' clipPath='url(#clip0_10969_92081)' clipRule='evenodd'>
            <path d='M5.474 3.798c0-.312.253-.565.565-.565h10.153a.565.565 0 0 1 0 1.13H6.04a.565.565 0 0 1-.565-.565ZM1.243 3.798c0-.312.253-.565.565-.565h.846a.565.565 0 0 1 0 1.13h-.846a.565.565 0 0 1-.565-.565ZM1.243 8.876c0-.312.253-.565.565-.565h.846a.565.565 0 0 1 0 1.13h-.846a.565.565 0 0 1-.565-.565ZM1.243 13.953c0-.312.253-.565.565-.565h.846a.565.565 0 0 1 0 1.13h-.846a.565.565 0 0 1-.565-.565ZM5.474 8.876c0-.312.253-.565.565-.565h10.153a.565.565 0 0 1 0 1.13H6.04a.565.565 0 0 1-.565-.565ZM5.474 13.953c0-.312.253-.565.565-.565h10.153a.565.565 0 0 1 0 1.13H6.04a.565.565 0 0 1-.565-.565Z' />
          </g>
          <defs>
            <clipPath id='clip0_10969_92081'>
              <path fill='#fff' d='M0 0h18v18H0z' />
            </clipPath>
          </defs>
        </>
      );
    case 'blockquote-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M11.646 15.37a.565.565 0 0 1 .156-.783c1.172-.781 1.83-1.294 2.242-2.12.387-.774.587-1.883.618-3.854h-3.325a1.344 1.344 0 0 1-1.344-1.344V4.154c0-.742.602-1.344 1.344-1.344h3.115c.742 0 1.344.602 1.344 1.344v3.894c0 2.344-.19 3.824-.741 4.925-.561 1.122-1.462 1.778-2.626 2.554a.565.565 0 0 1-.783-.157Zm3.02-7.887v-3.33a.214.214 0 0 0-.214-.213h-3.115a.214.214 0 0 0-.214.214v3.115c0 .118.096.214.214.214h3.329ZM3.857 15.37a.565.565 0 0 1 .157-.783c1.172-.781 1.83-1.294 2.242-2.12.387-.774.587-1.883.618-3.854H3.549a1.344 1.344 0 0 1-1.344-1.344V4.154c0-.742.602-1.344 1.344-1.344h3.115c.742 0 1.344.602 1.344 1.344v3.894c0 2.344-.19 3.824-.741 4.925-.561 1.122-1.462 1.778-2.626 2.554a.565.565 0 0 1-.784-.157Zm3.02-7.887v-3.33a.214.214 0 0 0-.213-.213H3.549a.214.214 0 0 0-.214.214v3.115c0 .118.096.214.214.214h3.329Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'heading-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M6.518 3.738c0-.312.253-.565.565-.565h9.46a.565.565 0 1 1 0 1.13h-9.46a.565.565 0 0 1-.565-.565Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M11.78 3.173c.312 0 .565.253.565.565v11.164a.565.565 0 1 1-1.13 0V3.738c0-.312.253-.565.565-.565ZM4.337 7.824c.313 0 .565.253.565.565v6.513a.565.565 0 0 1-1.13 0V8.389c0-.312.253-.565.565-.565Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M.981 8.39c0-.313.253-.566.565-.566h5.582a.565.565 0 0 1 0 1.13H1.546a.565.565 0 0 1-.565-.565Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'navbar-client-portal-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M3.375 9.563a.562.562 0 0 0-.558.632l.469 3.75a.562.562 0 0 0 .558.492h4.78a.563.563 0 0 0 .559-.632l-.469-3.75a.563.563 0 0 0-.558-.492H3.375ZM2.11 9.008c.32-.363.781-.57 1.265-.57h4.78A1.687 1.687 0 0 1 9.83 9.915l.47 3.75a1.687 1.687 0 0 1-1.675 1.896H3.844a1.687 1.687 0 0 1-1.675-1.478l-.468-3.75c-.06-.48.089-.963.409-1.326Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M7.913 15c0-.31.252-.563.563-.563h4.803a.562.562 0 1 1 0 1.126H8.476A.562.562 0 0 1 7.913 15ZM10.875 2.813a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm-2.625 1.5a2.625 2.625 0 1 1 5.25 0 2.625 2.625 0 0 1-5.25 0ZM10.688 9c0-.31.251-.563.562-.563h2.25a2.813 2.813 0 0 1 2.813 2.813V12c0 .725-.588 1.313-1.313 1.313h-2.25a.562.562 0 1 1 0-1.126H15a.187.187 0 0 0 .188-.187v-.75c0-.932-.756-1.688-1.688-1.688h-2.25A.562.562 0 0 1 10.687 9Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'navbar-support-icon':
      return (
        <>
          <path
            fill={fill}
            d='M12.188 8.25c0-.725.587-1.313 1.312-1.313h.75c1.14 0 2.063.924 2.063 2.063v2.25c0 1.14-.924 2.063-2.063 2.063h-.75A1.313 1.313 0 0 1 12.187 12V8.25ZM13.312 12c0 .103.085.188.188.188h.75c.518 0 .938-.42.938-.938V9a.937.937 0 0 0-.938-.938h-.75a.188.188 0 0 0-.188.188V12ZM4.688 8.25a.188.188 0 0 0-.188-.188h-.75A.937.937 0 0 0 2.812 9v2.25c0 .518.42.938.938.938h.75A.188.188 0 0 0 4.688 12V8.25ZM5.813 12c0 .725-.588 1.313-1.313 1.313h-.75a2.062 2.062 0 0 1-2.063-2.063V9c0-1.14.924-2.063 2.063-2.063h.75c.725 0 1.313.588 1.313 1.313V12Z'
          />
          <path
            fill={fill}
            d='M13.313 7.5v-.375a4.312 4.312 0 1 0-8.626 0V7.5a.563.563 0 0 1-1.125 0v-.375a5.437 5.437 0 1 1 10.876 0V7.5a.562.562 0 1 1-1.126 0ZM9.844 15a.375.375 0 0 0-.375-.375H8.53a.375.375 0 0 0 0 .75h.938A.375.375 0 0 0 9.844 15Zm1.125 0a1.5 1.5 0 0 1-1.5 1.5H8.53a1.5 1.5 0 0 1 0-3h.938a1.5 1.5 0 0 1 1.5 1.5Z'
          />
          <path
            fill={fill}
            d='M12.938 13.5v-.75a.562.562 0 1 1 1.124 0v.75c0 1.14-.923 2.063-2.062 2.063h-1.594a.562.562 0 0 1 0-1.126H12c.518 0 .938-.419.938-.937Z'
          />
        </>
      );
    case 'successful-icon':
      return (
        <>
          <path
            fill='var(--accent-success)'
            d='m39.01 17.083-1.748-1.328c.227-.805.42-1.487.594-2.081.7-2.343 1.084-3.637.122-4.966-.961-1.329-2.273-1.381-4.756-1.451h-2.168c-.297-.77-.524-1.452-.734-2.029-.805-2.308-1.26-3.497-2.833-4.091-1.574-.595-2.675.244-4.703 1.643l-1.749 1.207-1.749-1.172c-1.8-1.416-3.13-2.29-4.72-1.766-1.592.525-2.011 1.749-2.833 4.074-.21.577-.455 1.26-.735 2.046l-2.255.07c-2.448 0-3.795.088-4.756 1.416-.962 1.33-.49 2.623.175 4.984.174.594.384 1.276.594 2.08l-1.749 1.33C1.102 18.516 0 19.338 0 21s1.067 2.466 3.007 3.952l1.749 1.329c-.21.804-.42 1.486-.594 2.08-.7 2.343-1.085 3.637-.123 4.966.962 1.33 2.326 1.364 4.756 1.434h2.15c.298.77.525 1.451.735 2.028.822 2.308 1.26 3.498 2.833 4.092 1.574.595 2.675-.245 4.704-1.644l1.748-1.206 1.749 1.172a7.344 7.344 0 0 0 3.829 1.748 2.99 2.99 0 0 0 .927-.157c1.573-.508 2.01-1.749 2.832-4.075.21-.577.437-1.258.735-2.028h2.168c2.448 0 3.794-.087 4.756-1.434.962-1.346.594-2.622-.105-4.965-.175-.595-.385-1.277-.595-2.081l1.749-1.33c1.923-1.38 2.955-2.132 2.955-3.88 0-1.75-1.032-2.431-2.955-3.918Z'
          />
          <path
            fill='var(--text-white)'
            d='M18.521 27.985a1.566 1.566 0 0 1-1.11-.532l-4.616-5.148a1.569 1.569 0 0 1 2.347-2.08l3.473 3.927 9.904-9.638a1.565 1.565 0 1 1 2.175 2.237L19.617 27.578a1.565 1.565 0 0 1-1.096.407Z'
          />
        </>
      );
    case 'failed-icon':
      return (
        <>
          <path fill={fill} d='M11.376 5.716a.643.643 0 0 1 .909.909l-5.66 5.66a.643.643 0 0 1-.91-.91l5.66-5.66Z' />
          <path
            fill={fill}
            d='M5.716 5.716a.643.643 0 0 1 .909 0l5.66 5.66a.643.643 0 0 1-.91.909l-5.66-5.66a.643.643 0 0 1 0-.91Z'
          />
          <path
            fill={fill}
            d='M9 0a9 9 0 0 1 9 9 9 9 0 0 1-9 9 9 9 0 0 1-9-9 9 9 0 0 1 9-9Zm0 1.286A7.714 7.714 0 0 0 1.286 9 7.714 7.714 0 0 0 9 16.714 7.714 7.714 0 0 0 16.714 9 7.714 7.714 0 0 0 9 1.286Z'
          />
        </>
      );
    case 'heading1-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M2.252 3.162c.313 0 .566.253.566.565v11.478a.565.565 0 0 1-1.13 0V3.727c0-.312.252-.565.565-.565ZM9.905 3.162c.312 0 .565.253.565.565v11.478a.565.565 0 1 1-1.13 0V3.727c0-.312.253-.565.565-.565Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M1.688 9.466c0-.312.253-.565.565-.565h7.652a.565.565 0 1 1 0 1.13H2.253a.565.565 0 0 1-.565-.565ZM15.382 9.9a.565.565 0 0 1 .349.522v4.783a.565.565 0 1 1-1.13 0v-3.418l-.231.23a.565.565 0 1 1-.8-.798l1.196-1.196a.565.565 0 0 1 .616-.123Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M13.167 15.205c0-.312.253-.565.565-.565h2.87a.565.565 0 0 1 0 1.13h-2.87a.565.565 0 0 1-.565-.565Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'heading2-icon':
      return (
        <>
          <path
            fill={fill}
            d='M13.111 11.205c0-.834.677-1.51 1.511-1.51h.581a1.727 1.727 0 0 1 1.31 2.85l-1.608 1.876h1.608a.565.565 0 0 1 0 1.13h-2.836a.566.566 0 0 1-.429-.933l2.407-2.808a.598.598 0 0 0-.452-.985h-.58a.38.38 0 0 0-.38.38.566.566 0 0 1-1.132 0Z'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M2.335 3.078c.312 0 .565.253.565.565v11.343a.565.565 0 1 1-1.13 0V3.643c0-.312.252-.565.565-.565ZM9.897 3.078c.312 0 .565.253.565.565v11.343a.565.565 0 1 1-1.13 0V3.643c0-.312.253-.565.565-.565Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M1.77 9.315c0-.312.252-.565.565-.565h7.562a.565.565 0 0 1 0 1.13H2.335a.565.565 0 0 1-.565-.565Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'heading3-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M2.335 3.078c.312 0 .565.253.565.565v11.343a.565.565 0 0 1-1.13 0V3.643c0-.312.252-.565.565-.565ZM9.897 3.078c.312 0 .565.253.565.565v11.343a.565.565 0 1 1-1.13 0V3.643c0-.312.253-.565.565-.565Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M1.77 9.315c0-.312.252-.565.565-.565h7.562a.565.565 0 1 1 0 1.13H2.335a.565.565 0 0 1-.565-.565ZM15.052 8.894h.004c1.117 0 2.023.905 2.023 2.023 0 .354-.159.646-.324.857a2.66 2.66 0 0 1-.462.449c.158.122.324.273.462.448.165.211.324.503.324.857a2.023 2.023 0 0 1-2.023 2.023h-.004a2.004 2.004 0 0 1-1.919-1.478.565.565 0 0 1 1.09-.296c.103.377.444.64.835.644a.893.893 0 0 0 .891-.893c0-.007-.004-.058-.084-.16a1.697 1.697 0 0 0-.335-.305 3.545 3.545 0 0 0-.546-.322l-.006-.003a.565.565 0 0 1 0-1.031l.23.515-.23-.515h-.001l.007-.003.033-.016a3.664 3.664 0 0 0 .513-.306c.14-.101.258-.206.335-.306.08-.101.084-.152.084-.16a.893.893 0 0 0-.89-.892.874.874 0 0 0-.835.644.565.565 0 1 1-1.09-.296 2.004 2.004 0 0 1 1.918-1.478Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'bulleted-list-icon':
      return (
        <>
          <g fill={fill} fillRule='evenodd' clipPath='url(#clip0_10969_92081)' clipRule='evenodd'>
            <path d='M5.474 3.798c0-.312.253-.565.565-.565h10.153a.565.565 0 0 1 0 1.13H6.04a.565.565 0 0 1-.565-.565ZM1.243 3.798c0-.312.253-.565.565-.565h.846a.565.565 0 0 1 0 1.13h-.846a.565.565 0 0 1-.565-.565ZM1.243 8.876c0-.312.253-.565.565-.565h.846a.565.565 0 0 1 0 1.13h-.846a.565.565 0 0 1-.565-.565ZM1.243 13.953c0-.312.253-.565.565-.565h.846a.565.565 0 0 1 0 1.13h-.846a.565.565 0 0 1-.565-.565ZM5.474 8.876c0-.312.253-.565.565-.565h10.153a.565.565 0 0 1 0 1.13H6.04a.565.565 0 0 1-.565-.565ZM5.474 13.953c0-.312.253-.565.565-.565h10.153a.565.565 0 0 1 0 1.13H6.04a.565.565 0 0 1-.565-.565Z' />
          </g>
          <defs>
            <clipPath id='clip0_10969_92081'>
              <path fill='var(--text-white)' d='M0 0h18v18H0z' />
            </clipPath>
          </defs>
        </>
      );
    case 'number-list-icon':
      return (
        <>
          <g fill={fill} fillRule='evenodd' clipPath='url(#clip0_10969_92090)' clipRule='evenodd'>
            <path d='M7.685 3.375c0-.312.253-.565.565-.565H15a.565.565 0 0 1 0 1.13H8.25a.565.565 0 0 1-.565-.565ZM7.797 7.125c0-.312.253-.565.565-.565h6.637a.565.565 0 0 1 0 1.13H8.362a.565.565 0 0 1-.565-.565ZM4.153 2.853a.565.565 0 0 1 .35.522v3.75a.565.565 0 0 1-1.13 0V4.737a.565.565 0 0 1-.773-.824l.938-.938a.565.565 0 0 1 .615-.122ZM7.685 10.875c0-.313.253-.565.565-.565H15a.565.565 0 1 1 0 1.13H8.25a.565.565 0 0 1-.565-.565ZM7.797 14.625c0-.313.253-.565.565-.565h6.637a.565.565 0 1 1 0 1.13H8.362a.565.565 0 0 1-.565-.565ZM3.75 11.44a.185.185 0 0 0-.185.185.565.565 0 0 1-1.13 0c0-.727.588-1.315 1.315-1.315h.46a1.486 1.486 0 0 1 1.129 2.453L4.228 14.06H5.25a.565.565 0 1 1 0 1.13H3a.565.565 0 0 1-.43-.933l1.911-2.229a.356.356 0 0 0 .068-.345m0 0a.356.356 0 0 0-.339-.243l.339.243Z' />
            <path d='M2.435 7.125c0-.312.253-.565.565-.565h1.875a.565.565 0 0 1 0 1.13H3a.565.565 0 0 1-.565-.565Z' />
          </g>
          <defs>
            <clipPath id='clip0_10969_92090'>
              <path fill='var(--text-white)' d='M0 0h18v18H0z' />
            </clipPath>
          </defs>
        </>
      );
    case 'check-list-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M7.749 9.104c0-.312.253-.565.565-.565h6.855a.565.565 0 1 1 0 1.13H8.314a.565.565 0 0 1-.565-.565ZM4.771 8.535a.806.806 0 1 0-1.14 1.14.806.806 0 0 0 1.14-1.14Zm.8-.8a1.936 1.936 0 1 0-2.738 2.738A1.936 1.936 0 0 0 5.57 7.736ZM7.749 4.306c0-.312.253-.565.565-.565h6.855a.565.565 0 1 1 0 1.13H8.314a.565.565 0 0 1-.565-.565ZM6.677 2.557c.209.232.19.59-.042.798l-2.28 2.054a.565.565 0 0 1-.757 0l-1.133-1.02a.565.565 0 1 1 .756-.84l.755.68L5.88 2.515a.565.565 0 0 1 .798.042ZM7.749 13.903c0-.312.253-.565.565-.565h6.855a.565.565 0 1 1 0 1.13H8.314a.565.565 0 0 1-.565-.565ZM4.771 13.333a.806.806 0 1 0-1.14 1.14.806.806 0 0 0 1.14-1.14Zm.8-.8a1.936 1.936 0 1 0-2.738 2.738 1.936 1.936 0 0 0 2.737-2.737Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'list-view-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M1.168 3.487c0-.312.253-.565.565-.565h14.536a.565.565 0 0 1 0 1.13H1.733a.565.565 0 0 1-.565-.565ZM1.168 9.14c0-.312.253-.565.565-.565h14.536a.565.565 0 0 1 0 1.13H1.733a.565.565 0 0 1-.565-.565ZM1.168 14.793c0-.313.253-.566.565-.566h14.536a.565.565 0 0 1 0 1.13H1.733a.565.565 0 0 1-.565-.564Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'board-view-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M1.595 3.3c0-.942.763-1.705 1.705-1.705h3.04c.941 0 1.705.763 1.705 1.705v3.04c0 .941-.764 1.705-1.705 1.705H3.3A1.705 1.705 0 0 1 1.595 6.34V3.3ZM3.3 2.725a.575.575 0 0 0-.575.575v3.04c0 .317.257.575.575.575h3.04a.575.575 0 0 0 .575-.575V3.3a.575.575 0 0 0-.575-.575H3.3ZM9.954 3.3c0-.942.763-1.705 1.705-1.705h3.04c.942 0 1.705.763 1.705 1.705v3.04c0 .941-.763 1.705-1.705 1.705h-3.04A1.705 1.705 0 0 1 9.954 6.34V3.3Zm1.705-.575a.575.575 0 0 0-.575.575v3.04c0 .317.258.575.575.575h3.04a.575.575 0 0 0 .575-.575V3.3a.575.575 0 0 0-.575-.575h-3.04ZM9.954 11.66c0-.942.763-1.705 1.705-1.705h3.04c.942 0 1.705.763 1.705 1.705v3.04c0 .942-.763 1.705-1.705 1.705h-3.04A1.705 1.705 0 0 1 9.954 14.7v-3.04Zm1.705-.575a.575.575 0 0 0-.575.575v3.04c0 .318.258.575.575.575h3.04a.575.575 0 0 0 .575-.575v-3.04a.575.575 0 0 0-.575-.575h-3.04ZM1.595 11.66c0-.942.763-1.705 1.705-1.705h3.04c.941 0 1.705.763 1.705 1.705v3.04c0 .942-.764 1.705-1.705 1.705H3.3A1.705 1.705 0 0 1 1.595 14.7v-3.04Zm1.705-.575a.575.575 0 0 0-.575.575v3.04c0 .318.257.575.575.575h3.04a.575.575 0 0 0 .575-.575v-3.04a.575.575 0 0 0-.575-.575H3.3Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'attach-file-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M8.4 2.403a3.086 3.086 0 1 1 4.365 4.364L7.943 11.59a1.91 1.91 0 0 1-2.701-2.702L8.899 5.23a.5.5 0 1 1 .707.707L5.95 9.594a.91.91 0 0 0 1.287 1.288l4.822-4.822a2.086 2.086 0 1 0-2.95-2.95L4.285 7.931A3.261 3.261 0 1 0 8.9 12.544l2.926-2.926a.5.5 0 0 1 .707.707l-2.926 2.926A4.261 4.261 0 1 1 3.58 7.224L8.4 2.403Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'insert-gif-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M10.793 9.188c0-.311.252-.563.563-.563h1.59a.563.563 0 0 1 0 1.125h-1.59a.562.562 0 0 1-.563-.563Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M10.791 7.503c0-.31.252-.563.563-.563h1.92a.562.562 0 1 1 0 1.125h-1.358v2.81a.562.562 0 1 1-1.125 0V7.503ZM9.338 6.938c.31 0 .562.251.562.562v3.375a.562.562 0 1 1-1.125 0V7.5c0-.31.252-.563.563-.563ZM3.938 9.188a2.25 2.25 0 0 1 2.25-2.25h1.125a.563.563 0 0 1 0 1.125H6.188a1.125 1.125 0 1 0 0 2.25h.562V9.75h-.375a.563.563 0 0 1 0-1.125h.938c.31 0 .562.252.562.563v1.687c0 .31-.252.563-.563.563H6.188a2.25 2.25 0 0 1-2.25-2.25Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M6 2.813A3.188 3.188 0 0 0 2.812 6v6A3.188 3.188 0 0 0 6 15.188h6A3.188 3.188 0 0 0 15.188 12V6A3.188 3.188 0 0 0 12 2.812H6ZM1.687 6A4.313 4.313 0 0 1 6 1.687h6A4.313 4.313 0 0 1 16.313 6v6A4.313 4.313 0 0 1 12 16.313H6A4.313 4.313 0 0 1 1.687 12V6Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'record-snap-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M9.018 15.203a6.185 6.185 0 1 0 0-12.37 6.185 6.185 0 0 0 0 12.37Zm0 1.13a7.315 7.315 0 1 0 0-14.63 7.315 7.315 0 0 0 0 14.63Z'
            clipRule='evenodd'
            className='fill-color'
          />
          <circle cx={9.018} cy={9} r={3.008} fill={fill} className='fill-color' />
        </>
      );
    case 'snap-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M7.919 7.277v3.444L10.831 9 7.919 7.277l.286-.484-.286.484Zm.573-.968a1.125 1.125 0 0 0-1.698.969v3.443c0 .87.947 1.413 1.698.969l2.911-1.722a1.125 1.125 0 0 0 0-1.937L8.492 6.309Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M4.5 2.813c-.932 0-1.688.755-1.688 1.687v9c0 .932.756 1.688 1.688 1.688h9c.932 0 1.688-.756 1.688-1.688v-9c0-.932-.756-1.688-1.688-1.688h-9ZM1.687 4.5A2.812 2.812 0 0 1 4.5 1.687h9A2.812 2.812 0 0 1 16.313 4.5v9a2.812 2.812 0 0 1-2.813 2.813h-9A2.812 2.812 0 0 1 1.687 13.5v-9Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'divider-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M4.125 12.563a.562.562 0 0 0-.563.562v1.5a.562.562 0 1 1-1.124 0v-1.5c0-.932.755-1.688 1.687-1.688h9.75c.932 0 1.688.756 1.688 1.688v1.5a.562.562 0 1 1-1.126 0v-1.5a.562.562 0 0 0-.562-.563h-9.75ZM3.188 9c0-.31.251-.563.562-.563h10.5a.562.562 0 1 1 0 1.126H3.75A.563.563 0 0 1 3.187 9ZM3 2.813c.31 0 .563.251.563.562v1.5c0 .31.251.563.562.563h9.75c.31 0 .563-.252.563-.563v-1.5a.562.562 0 1 1 1.124 0v1.5c0 .932-.755 1.688-1.687 1.688h-9.75a1.688 1.688 0 0 1-1.688-1.688v-1.5c0-.31.252-.563.563-.563Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'block-quote-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M11.646 15.37a.565.565 0 0 1 .156-.783c1.172-.781 1.83-1.294 2.242-2.12.387-.774.587-1.883.618-3.854h-3.325a1.344 1.344 0 0 1-1.344-1.344V4.154c0-.742.602-1.344 1.344-1.344h3.115c.742 0 1.344.602 1.344 1.344v3.894c0 2.344-.19 3.824-.741 4.925-.561 1.122-1.462 1.778-2.626 2.554a.565.565 0 0 1-.783-.157Zm3.02-7.887v-3.33a.214.214 0 0 0-.214-.213h-3.115a.214.214 0 0 0-.214.214v3.115c0 .118.096.214.214.214h3.329ZM3.857 15.37a.565.565 0 0 1 .157-.783c1.172-.781 1.83-1.294 2.242-2.12.387-.774.587-1.883.618-3.854H3.549a1.344 1.344 0 0 1-1.344-1.344V4.154c0-.742.602-1.344 1.344-1.344h3.115c.742 0 1.344.602 1.344 1.344v3.894c0 2.344-.19 3.824-.741 4.925-.561 1.122-1.462 1.778-2.626 2.554a.565.565 0 0 1-.784-.157Zm3.02-7.887v-3.33a.214.214 0 0 0-.213-.213H3.549a.214.214 0 0 0-.214.214v3.115c0 .118.096.214.214.214h3.329Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'table-icon':
      return (
        <>
          <path
            fill={fill}
            d='M15.185 4.5c0-.93-.754-1.685-1.685-1.685h-9c-.93 0-1.685.754-1.685 1.685v9c0 .93.754 1.685 1.685 1.685h9c.93 0 1.685-.754 1.685-1.685v-9Zm1.13 9a2.816 2.816 0 0 1-2.815 2.815h-9A2.816 2.816 0 0 1 1.685 13.5v-9A2.816 2.816 0 0 1 4.5 1.685h9A2.816 2.816 0 0 1 16.315 4.5v9Z'
          />
          <path
            fill={fill}
            d='M10.688 15.75V2.25a.562.562 0 1 1 1.124 0v13.5a.562.562 0 1 1-1.124 0ZM6.188 15.75V2.25a.563.563 0 0 1 1.125 0v13.5a.562.562 0 1 1-1.125 0Z'
          />
          <path
            fill={fill}
            d='M15.75 10.643a.562.562 0 1 1 0 1.125H2.25a.563.563 0 0 1 0-1.125h13.5ZM15.75 6.143a.562.562 0 1 1 0 1.125H2.25a.563.563 0 0 1 0-1.125h13.5Z'
          />
        </>
      );
    case 'toggle-icon':
      return (
        <>
          <path
            fill={fill}
            d='M5.226 4.101c.22-.22.578-.22.799 0l4.5 4.5c.22.22.22.578 0 .799l-4.5 4.5a.565.565 0 1 1-.799-.799l4.1-4.1-4.1-4.101a.565.565 0 0 1 0-.799Z'
          />
          <path
            fill={fill}
            d='M15.185 4.5c0-.93-.754-1.685-1.685-1.685h-9c-.93 0-1.685.754-1.685 1.685v9c0 .93.754 1.685 1.685 1.685h9c.93 0 1.685-.754 1.685-1.685v-9Zm1.13 9a2.816 2.816 0 0 1-2.815 2.815h-9A2.816 2.816 0 0 1 1.685 13.5v-9A2.816 2.816 0 0 1 4.5 1.685h9A2.816 2.816 0 0 1 16.315 4.5v9Z'
          />
        </>
      );
    case 'back-arrow': // tabs back arrow
      return (
        <>
          <path
            fill={fill}
            d='M5.674 4.52a.75.75 0 0 1 1.152.96L5.351 7.25h6.899a.75.75 0 0 1 0 1.5H5.351l1.475 1.77a.75.75 0 0 1-1.152.96l-2.5-3a.75.75 0 0 1 0-.96l2.5-3Z'
          />
        </>
      );
    case 'back-navigation-arrow': // mobile back arrow
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M16.315 9a.565.565 0 0 0-.565-.565H2.25a.565.565 0 0 0 0 1.13h13.5A.565.565 0 0 0 16.315 9Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M1.85 8.6a.565.565 0 0 0 0 .8l4.822 4.82a.565.565 0 1 0 .8-.799L2.65 8.601a.565.565 0 0 0-.8-.001Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M7.471 3.779a.565.565 0 0 0-.799 0L1.851 8.6a.565.565 0 1 0 .799.8L7.47 4.577a.565.565 0 0 0 0-.8Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'record-invoice-icon':
      return (
        <>
          <path
            fill={fill}
            d='M14.063 3.75a.937.937 0 0 0-.938-.938h-8.25a.937.937 0 0 0-.938.938v10.5c0 .518.42.938.938.938h8.25c.518 0 .938-.42.938-.938V3.75Zm1.124 10.5c0 1.14-.923 2.063-2.062 2.063h-8.25a2.062 2.062 0 0 1-2.063-2.063V3.75c0-1.14.924-2.063 2.063-2.063h8.25c1.14 0 2.063.924 2.063 2.063v10.5Z'
          />
          <path
            fill={fill}
            d='M12 10.688a.562.562 0 1 1 0 1.124H6a.562.562 0 1 1 0-1.124h6ZM12 12.938a.562.562 0 1 1 0 1.124H6a.562.562 0 1 1 0-1.124h6ZM8.438 5.063V4.5a.563.563 0 0 1 1.124 0v.563a.563.563 0 0 1-1.124 0ZM8.438 9v-.563a.563.563 0 0 1 1.124 0V9a.563.563 0 0 1-1.124 0Z'
          />
          <path
            fill={fill}
            d='M7.73 7.556a.563.563 0 0 1 .705.095l.069.091.047.06c.05.052.108.075.168.075h.616a.228.228 0 0 0 .056-.45v.002l-1.055-.265h-.001a1.353 1.353 0 0 1 .33-2.664h.616c.456 0 .834.221 1.077.532l.097.139.049.102a.563.563 0 0 1-.94.576l-.069-.091-.047-.06a.23.23 0 0 0-.167-.073h-.616a.228.228 0 0 0-.227.228c0 .103.07.195.172.22l1.054.264h.001l.11.033a1.354 1.354 0 0 1-.44 2.632h-.616c-.457 0-.835-.222-1.08-.534l-.096-.14-.049-.102a.562.562 0 0 1 .236-.67Z'
          />
        </>
      );
    case 'mail-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M3 3.563a.942.942 0 0 0-.938.937v9c0 .514.424.938.938.938h12a.942.942 0 0 0 .938-.938v-9A.942.942 0 0 0 15 3.562H3ZM.937 4.5c0-1.136.927-2.063 2.063-2.063h12c1.136 0 2.063.927 2.063 2.063v9A2.067 2.067 0 0 1 15 15.563H3A2.067 2.067 0 0 1 .937 13.5v-9Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M1.04 4.177a.562.562 0 0 1 .783-.138L9 9.063l7.177-5.024a.563.563 0 1 1 .646.922l-7.5 5.25a.563.563 0 0 1-.646 0l-7.5-5.25a.562.562 0 0 1-.138-.784Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'feedback-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M16.315 9A7.315 7.315 0 0 0 9 1.687a7.315 7.315 0 0 0-6.488 10.687l-.81 3.24a.565.565 0 0 0 .685.686l3.24-.81A7.315 7.315 0 0 0 16.316 9ZM9 2.817a6.185 6.185 0 1 1-3.02 11.579.564.564 0 0 0-.414-.056l-2.539.635.635-2.54a.565.565 0 0 0-.056-.413A6.147 6.147 0 0 1 2.816 9 6.185 6.185 0 0 1 9 2.816Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'url-icon':
      return (
        <>
          <path
            fill={fill}
            d='M6.42 3.609a.693.693 0 1 1 0 1.386h-.693a3.005 3.005 0 0 0 0 6.01h.693a.693.693 0 0 1 0 1.386h-.693a4.391 4.391 0 1 1 0-8.782h.693ZM10.58 11.005a.693.693 0 0 0 0 1.386h.694a4.391 4.391 0 1 0 0-8.782h-.694a.693.693 0 0 0 0 1.386h.694a3.005 3.005 0 1 1 0 6.01h-.694Z'
          />
          <path fill={fill} d='M6.651 7.307a.693.693 0 1 0 0 1.386h3.698a.693.693 0 1 0 0-1.386H6.651Z' />
        </>
      );
    case 'minimize-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M3.42 9c0-.312.254-.565.566-.565h9.99a.565.565 0 1 1 0 1.13h-9.99A.565.565 0 0 1 3.42 9Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'expand-icon':
      return (
        <>
          <path
            fill={fill}
            d='M13.61 5.55c0-.64-.52-1.16-1.16-1.16h-6.9a1.16 1.16 0 0 0-1.16 1.16v6.9c0 .64.52 1.16 1.16 1.16h6.9c.64 0 1.16-.52 1.16-1.16v-6.9Zm1.13 6.9a2.29 2.29 0 0 1-2.29 2.29h-6.9a2.29 2.29 0 0 1-2.29-2.29v-6.9a2.29 2.29 0 0 1 2.29-2.29h6.9a2.29 2.29 0 0 1 2.29 2.29v6.9Z'
          />
        </>
      );
    case 'app-close-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M2.8 2.8a.44.44 0 0 1 .622 0l7.778 7.778a.44.44 0 1 1-.622.622L2.801 3.422a.44.44 0 0 1 0-.621Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M11.2 2.8a.44.44 0 0 1 0 .622L3.422 11.2a.44.44 0 0 1-.621-.622l7.777-7.777a.44.44 0 0 1 .622 0Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'expand-sidebar-icon':
      return (
        <>
          <path
            fill={fill}
            d='M15 5.25A3.25 3.25 0 0 0 11.75 2h-7.5A3.25 3.25 0 0 0 1 5.25v5.5A3.25 3.25 0 0 0 4.25 14h7.5A3.25 3.25 0 0 0 15 10.75v-5.5Zm-3.5 7.25H7v-9h4.5a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2Zm-6 0H4.25a1.75 1.75 0 0 1-1.75-1.75v-5.5c0-.966.784-1.75 1.75-1.75H5.5v9Z'
          />
        </>
      );
    case 'teamcamp-logo':
      return (
        <>
          <path
            fill={fill}
            d='m9.59 5 1.229 2.351c1.337 2.56-.488 5.646-3.339 5.646H5V10.15h2.48c.74 0 1.213-.8.866-1.463l-1.23-2.352L9.59 5ZM14.41 5l-1.229 2.351c-1.337 2.56.488 5.646 3.339 5.646H19V10.15h-2.48c-.74 0-1.213-.8-.866-1.463l1.23-2.352L14.41 5ZM11.93 15.855 9.792 19l-2.304-1.618 2.139-3.145a2.774 2.774 0 0 1 4.606 0l2.139 3.145L14.068 19l-2.138-3.145Z'
          />
        </>
      );
    case 'branch-merged-icon':
      return (
        <>
          <path
            fill='var(--accent-secondary)'
            fillRule='evenodd'
            d='M4.375 3.44v-.003.004a.562.562 0 1 1 0-.004v.003Zm.338 1.425a1.687 1.687 0 1 0-1.463.163V8.97a1.688 1.688 0 1 0 1.125 0V6.341A4.301 4.301 0 0 0 7.562 7.75h1.034a1.688 1.688 0 1 0 0-1.125H7.562a3.187 3.187 0 0 1-2.85-1.76Zm5.474 2.884a.562.562 0 1 0 0-1.124.562.562 0 0 0 0 1.124Zm-6.374 3.375a.562.562 0 1 0 0-1.124.562.562 0 0 0 0 1.124Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'github-small-icon':
      return (
        <>
          <path
            fill={fill}
            d='M7 0a7 7 0 0 0-2.213 13.642c.35.065.478-.151.478-.336 0-.167-.006-.719-.01-1.304-1.947.424-2.358-.826-2.358-.826-.318-.809-.777-1.024-.777-1.024-.635-.434.048-.425.048-.425.703.049 1.073.721 1.073.721.625 1.07 1.638.76 2.037.582.063-.452.244-.761.445-.936-1.555-.177-3.19-.777-3.19-3.46 0-.764.274-1.388.722-1.878-.073-.177-.313-.889.067-1.853 0 0 .588-.188 1.926.718A6.706 6.706 0 0 1 7 3.385c.595.003 1.194.08 1.754.236 1.336-.906 1.923-.718 1.923-.718.38.964.141 1.676.068 1.853.45.49.72 1.114.72 1.878 0 2.689-1.637 3.281-3.196 3.454.252.218.475.644.475 1.297 0 .936-.008 1.69-.008 1.92 0 .187.126.405.481.336A7 7 0 0 0 7 0Z'
          />
        </>
      );
    case 'play-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='m7.183 4.628 5.77 3.412c.73.432.73 1.488 0 1.92l-5.77 3.412a1.115 1.115 0 0 1-1.683-.96V5.588c0-.864.94-1.4 1.683-.96Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'pause-icon':
      return (
        <>
          <path
            fill='#202022'
            d='M4.433 5.606c0-.654.53-1.184 1.184-1.184h6.765c.654 0 1.184.53 1.184 1.184v6.765c0 .654-.53 1.184-1.184 1.184H5.617c-.654 0-1.184-.53-1.184-1.184V5.606Z'
          />
        </>
      );
    case 'sentry-icon':
      return (
        <>
          <path
            fill='var(--accent-secondary)'
            d='M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16Z'
          />
          <path
            fill='var(--text-white)'
            d='M17.59 7.094a1.87 1.87 0 0 0-3.203 0l-2.634 4.513a12.898 12.898 0 0 1 7.107 10.675h-1.85a11.082 11.082 0 0 0-6.19-9.097L8.38 17.4a6.375 6.375 0 0 1 3.696 4.873H7.829a.303.303 0 0 1-.249-.444l1.178-2.002a4.3 4.3 0 0 0-1.346-.761l-1.165 2.002a1.817 1.817 0 0 0 .677 2.498c.276.156.587.239.905.24h5.818a7.768 7.768 0 0 0-3.204-6.93l.925-1.602a9.559 9.559 0 0 1 4.125 8.533h4.929a14.367 14.367 0 0 0-6.571-12.733l1.87-3.204a.308.308 0 0 1 .42-.108c.212.116 8.125 13.922 8.273 14.083a.304.304 0 0 1-.272.452h-1.906c.024.51.024 1.019 0 1.526h1.914A1.84 1.84 0 0 0 26 21.978c0-.321-.086-.636-.249-.913l-8.16-13.97Z'
          />
        </>
      );
    case 'correct-sign-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M15.398 4.477c.22.22.22.576 0 .796l-8.25 8.25a.562.562 0 0 1-.796 0l-3.75-3.75a.563.563 0 0 1 .796-.796L6.75 12.33l7.852-7.852c.22-.22.576-.22.796 0Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'dark-background-subscription':
      return (
        <>
          <mask
            id='a'
            width={662}
            height={150}
            x={0}
            y={0}
            maskUnits='userSpaceOnUse'
            style={{
              maskType: 'alpha'
            }}>
            <rect width={662} height={150} fill='#202022' rx={7} />
          </mask>
          <g mask='url(#a)'>
            <path
              fill='url(#b)'
              d='M793.739-7.783 776.041.852l17.226 8.405.158.076v17.27l.314.153-.314.154v17.269l-17.376 8.478 17.232 8.407.157.076v17.882l-18.169-8.865-.158-.076V53.113l-.014.007V35.543L758.59 27.49c-.152.13-.346.222-.562.27v33.684l-17.698 8.634v17.268l-16.827 8.209c.029.088.049.18.049.274 0 .095-.02.185-.047.272l16.668 8.132.157.077v16.955l17.056-8.32V78.101l17.136 8.36a1.35 1.35 0 0 1 .877-.308c.682 0 1.235.467 1.235 1.043 0 .484-.392.887-.921 1.005v33.359l17.569 8.572.158.076v17.884l-17.727-8.649v.017l-18.012-8.787-18.014 8.787v-17.581l-17.527-8.551-.157-.077V96.834c-.528-.118-.92-.521-.92-1.005 0-.483.392-.886.92-1.005v-16.42l17.698-8.633V52.809l-17.069-8.327v16.964l-17.698 8.635v.307l-.315-.153-.314.153v-.306l-17.54-8.559-.157-.076V43.563l17.135 8.36c.224-.19.534-.31.877-.31.344 0 .654.12.878.31l16.506-8.052V9.025l18.012 8.788 17.385-8.48L774.784.851l-17.069-8.328-.314.154v-.308l-.315-.153.315-.154v-17.27l17.698-8.634v-16.11c-.529-.118-.921-.521-.921-1.006 0-.576.553-1.043 1.235-1.043s1.235.467 1.235 1.043a.864.864 0 0 1-.048.273l16.669 8.132.157.077v17.883l-17.698-8.635v16.655l18.011 8.79Zm-17.998 77.557 17.069 8.327V61.447l-17.069-8.327v16.654ZM792.796 9.64l-17.07-8.328v16.655l17.07 8.328V9.64Zm0 17.576-17.07 8.328v16.655l17.07-8.328V27.216Zm-17.384 7.867 17.069-8.328-7.754-3.783-9.314-4.544-16.512 8.055a.884.884 0 0 1 .048.272c0 .096-.02.185-.048.273l16.511 8.055ZM757.4 43.868V27.76a1.305 1.305 0 0 1-.563-.271l-7.972 3.89-8.535 4.163v16.654l8.535-4.164 8.535-4.163Zm.615 69.077 17.069 8.327v-16.655l-17.069-8.327v16.655Zm0-33.923v16.654l17.069 8.327V88.201c-.529-.119-.92-.522-.92-1.006 0-.094.02-.185.048-.272l-16.197-7.901Zm17.726 59.821 17.069 8.328v-16.656l-17.069-8.327v16.655Zm-.657-16.957-17.069-8.328v16.654l17.069 8.328v-16.654Zm-34.768 16.654 17.07-8.328v-16.654l-17.056 8.321v.313l-.013-.006-.001 16.354Zm-.615-17.268v-16.655l-16.506-8.053c-.153.13-.347.223-.562.271v16.11l17.068 8.327Zm-17.069-42.56v16.113c.215.047.408.14.561.268l16.508-8.054V70.385l-17.069 8.327ZM757.4 61.137V44.483l-8.535 4.164-8.534 4.163v16.655l17.069-8.328Zm-70.163-16.652V61.14l17.069 8.328V53.663c-.529-.118-.921-.521-.921-1.005a.88.88 0 0 1 .048-.271l-16.196-7.902Zm17.697 9.178v15.804l17.069-8.328V44.486l-16.196 7.901a.877.877 0 0 1 .047.271c0 .483-.391.887-.92 1.005Zm17.698-9.794 17.069 8.327V35.543l-17.069-8.328v16.653Zm0-17.268 17.069 8.327V18.273l-17.069-8.328v16.656Zm17.698-8.327v16.654l8.535-4.164 7.662-3.738a.88.88 0 0 1-.048-.27c0-.484.392-.887.92-1.006V9.947l-17.069 8.327Zm17.699 7.477c.215.048.409.14.562.27l16.507-8.053V1.313l-17.069 8.328v16.11ZM775.097.39l.315.154.314-.154 16.755-8.174-17.068-8.327-17.069 8.327L775.097.392Zm-17.068-8.635 17.069-8.327v-16.655L758.029-24.9v16.655Zm34.767-17.268v-16.655l-16.508-8.054c-.152.13-.346.222-.561.27v16.11l17.069 8.329ZM688.157 78.56c0 .095-.02.185-.048.273l16.668 8.132.158.076v34.519l16.408 8.005a1.309 1.309 0 0 1 1.003-.439c.682 0 1.235.468 1.235 1.044 0 .484-.392.887-.92 1.005v16.917l-17.699-8.636v16.963l-18.327 8.941v-17.884l17.366-8.472-17.079-8.332-16.512 8.055a.883.883 0 0 1 .048.272c0 .576-.553 1.043-1.235 1.043-.681 0-1.234-.467-1.234-1.043 0-.484.391-.887.92-1.005v-15.802l-.001-17.577-17.383-8.48-17.069 8.328 17.227 8.405.157.077v17.268l.314.154-.314.153v16.962l17.541 8.558.157.076V174l-18.17-8.865-.157-.076v-16.962l-17.069 8.328v.307l-.315-.154-18.012 8.789v-16.725a1.299 1.299 0 0 1-.563-.271l-16.507 8.052v17.572l-17.698-8.635v.004l-18.169-8.865-.158-.076v-16.961l-17.069 8.327v.307l-.314-.153-.315.153v-.307l-17.383-8.48-18.013 8.787v-17.575l-17.068-8.327v16.963l-18.328 8.941-17.698 8.634v-17.576l-16.507-8.053c-.224.19-.533.308-.876.308-.682 0-1.235-.467-1.235-1.043 0-.576.553-1.043 1.235-1.043.343 0 .653.118.876.308l16.507-8.053v-17.577l18.17 8.866.158.077v16.962l17.069-8.327v-17.575l17.135 8.36c.153-.13.347-.223.562-.271V95.678l18.328-8.94v17.268l17.698-8.635v17.883l-17.383 8.48 17.067 8.327 18.013-8.789v17.576l17.069 8.327V113.25l-17.54-8.558-.158-.077V86.731l17.137 8.361a1.35 1.35 0 0 1 .876-.309c.682 0 1.235.467 1.235 1.044 0 .483-.392.886-.921 1.005v16.112l17.541 8.558.158.077v16.962l17.069-8.327v-16.111c-.528-.118-.92-.521-.92-1.005 0-.095.02-.185.048-.273l-16.669-8.132-.157-.076V86.735l18.013 8.788 17.698-8.635 17.699 8.634 17.698-8.634 17.384 8.48V79.566c-.529-.118-.92-.52-.92-1.005 0-.576.553-1.044 1.234-1.044.681.001 1.234.468 1.234 1.044Zm16.148 8.788-16.507-8.053c-.153.13-.346.222-.562.27v16.11l.315.153 16.754 8.174V87.349Zm-34.767 33.923 17.07-8.327V96.29l-17.07 8.327v16.655Zm17.699-8.327 17.069 8.327v-16.655l-17.069-8.327v16.655Zm17.068 8.941-17.069-8.328v16.654l17.069 8.328v-16.654Zm17.726 25.285v-15.997c-.528-.118-.92-.52-.92-1.004 0-.034.008-.065.012-.098l-16.161-7.884v16.655l17.069 8.328Zm-34.767 17.269 17.069-8.328v-16.655l-17.069 8.328v16.655Zm-17.725-26.445c.215.048.409.141.561.27l16.508-8.053v-16.654l-17.069 8.328v16.109Zm-35.711-15.955-17.069 8.328 7.754 3.783 9.314 4.544 17.069-8.327-7.754-3.783-9.314-4.545Zm-17.384 24.592c.215.048.409.141.562.27l16.193-7.9-16.755-8.174v15.804Zm17.069-7.17-16.197 7.902a.889.889 0 0 1 .048.272c0 .095-.02.185-.048.272l16.197 7.902v-16.348Zm0-17.883v-16.655l-16.197 7.903a.882.882 0 0 1 .048.271c0 .483-.391.886-.92 1.005v15.804l17.069-8.328Zm-17.069-9.486c.216.048.41.141.563.271l16.192-7.9-16.755-8.174v15.803Zm34.767 1.159-17.069-8.328v16.655l17.069 8.328v-16.655Zm.629 51.499 17.069 8.327v-16.654l-17.069-8.327v16.654Zm-.629-17.268v-16.655l-17.069 8.328v16.655l17.069-8.328Zm-18.013 8.788-16.192-7.901a1.302 1.302 0 0 1-.562.272v15.803l16.754-8.174Zm-35.081 16.803v-16.651l-17.07-8.327v16.65l17.07 8.328Zm-53.094-25.898v-16.654l-17.069-8.328v16.654l17.069 8.328Zm-34.768 0 17.07-8.328v-16.654l-8.535 4.164-8.534 4.164-.001 16.654Zm17.07-42.249-8.535 4.163-7.662 3.738a.883.883 0 0 1 .048.272c0 .484-.392.887-.92 1.005v15.803l8.534-4.163 8.535-4.164v-16.654Zm-35.396 17.267-17.069 8.328v16.655l17.069-8.328v-16.655Zm-34.768 33.618 17.069-8.329v-16.655l-17.069 8.328v16.656Zm-16.825-25.172 16.511 8.056 17.069-8.328-7.754-3.783-9.315-4.545-16.511 8.056a.914.914 0 0 1 .048.272.914.914 0 0 1-.048.272Zm33.894-17.387-17.069-8.328v16.655l17.069 8.328v-16.655Zm18.328-8.326v16.654l17.069 8.327v-15.803c-.529-.118-.921-.522-.921-1.005 0-.095.021-.185.048-.272l-16.196-7.901Zm34.767-17.27-17.07 8.328v16.11c.216.047.41.14.562.27l7.973-3.889 8.535-4.164V87.658Zm17.698 8.635-17.069 8.327v16.655l17.069-8.327V96.292Zm17.697 25.901-17.069 8.328v16.655l17.069-8.328v-16.655Zm.629 17.269v16.654l17.069 8.327v-16.654l-17.069-8.327Zm34.768 16.344v-16.651l-17.07-8.327v16.651l17.07 8.327Zm-34.768-68.153v16.656l17.069 8.327V96.832c-.528-.118-.92-.52-.92-1.005 0-.095.02-.185.048-.272l-16.197-7.902Zm34.768 34.233-17.07-8.328v16.655l17.07 8.328v-16.655Zm.629 33.923 16.196-7.902a.882.882 0 0 1-.048-.271c0-.483.392-.887.921-1.005v-15.803l-17.069 8.327v16.654Zm0-51.499 16.507 8.053c.152-.13.346-.222.562-.271v-16.11l-17.07-8.326v16.654h.001Zm35.081-16.809-17.069 8.328 16.755 8.174.314.153.315-.153 16.754-8.174-17.069-8.328Zm18.327 8.328 17.069 8.327 17.069-8.327-17.069-8.328-17.069 8.328Z'
            />
          </g>
          <defs>
            <radialGradient
              id='b'
              cx={0}
              cy={0}
              r={1}
              gradientTransform='matrix(-631.04341 -362.33865 336.67417 -586.34655 744.359 442.989)'
              gradientUnits='userSpaceOnUse'>
              <stop stopColor='#B6B6B6' />
              <stop offset={0.664} stopColor='#202022' />
              <stop offset={0.867} stopColor='#202022' />
              <stop offset={0.976} stopColor='#202022' />
            </radialGradient>
          </defs>
        </>
      );
    case 'light-background-subscription':
      return (
        <>
          <mask
            id='a'
            width={662}
            height={150}
            x={0}
            y={0}
            maskUnits='userSpaceOnUse'
            style={{
              maskType: 'alpha'
            }}>
            <rect width={662} height={150} fill='#fff' rx={7} />
          </mask>
          <g mask='url(#a)'>
            <path
              fill='url(#b)'
              d='m794-10.218-17.757 8.941 17.284 8.702.157.08v17.88l.316.159-.316.159v17.88l-17.433 8.778 17.29 8.705.157.079V79.66l-18.23-9.179-.157-.079V52.833l-.014.008v-18.2l-16.562-8.338c-.153.135-.347.23-.564.28V61.46l-17.757 8.94v17.88l-16.882 8.5c.029.09.05.185.05.283a.982.982 0 0 1-.048.282l16.723 8.419.158.08v17.555l17.111-8.615V78.707l17.193 8.656a1.33 1.33 0 0 1 .88-.32c.684 0 1.239.484 1.239 1.08 0 .501-.393.919-.923 1.04v34.541l17.627 8.875.158.079v18.517l-17.786-8.955v.018l-18.071-9.099-18.073 9.099v-18.204l-17.585-8.854-.158-.079V98.103c-.53-.122-.923-.54-.923-1.04 0-.502.393-.919.923-1.042v-17l17.757-8.94V52.52l-17.126-8.622v17.565l-17.756 8.94v.319l-.316-.16-.315.16v-.318l-17.598-8.861-.158-.08V42.947l17.191 8.656c.225-.197.536-.32.881-.32.344 0 .656.122.88.32l16.561-8.337V7.185l18.072 9.099 17.442-8.78 17.44-8.782L757.857-9.9l-.315.159v-.318l-.316-.16.316-.158v-17.88l17.756-8.941v-16.68c-.53-.123-.923-.54-.923-1.042 0-.596.554-1.08 1.239-1.08.684 0 1.238.484 1.238 1.08a.954.954 0 0 1-.047.283l16.723 8.42.158.079v18.516l-17.757-8.94v17.244l18.071 9.1Zm-18.058 80.303 17.126 8.622V61.463l-17.126-8.622v17.244Zm17.111-62.263L775.928-.8v17.244l17.125 8.623V7.822Zm0 18.198-17.125 8.622v17.245l17.125-8.623V26.02Zm-17.441 8.146 17.126-8.623-7.78-3.917-9.345-4.705-16.566 8.34c.027.09.048.184.048.282a.978.978 0 0 1-.048.282l16.565 8.34Zm-18.071 9.096V26.583a1.29 1.29 0 0 1-.565-.28l-7.998 4.027-8.563 4.31v17.244l8.563-4.31 8.563-4.312Zm.617 71.521 17.125 8.622v-17.244l-17.125-8.622v17.244Zm0-35.123v17.243l17.125 8.622V89.163c-.53-.122-.923-.54-.923-1.04 0-.098.02-.192.048-.282l-16.25-8.181Zm17.784 61.939 17.126 8.622v-17.245l-17.126-8.622v17.245Zm-.659-17.558-17.125-8.622v17.243l17.125 8.622v-17.243Zm-34.882 17.243 17.125-8.622v-17.243l-17.111 8.615v.324l-.013-.006v16.932h-.001Zm-.617-17.879v-17.244l-16.561-8.338c-.153.135-.348.23-.564.28v16.68l17.125 8.622Zm-17.126-44.066v16.683a1.3 1.3 0 0 1 .563.278l16.563-8.34V70.719l-17.126 8.621Zm34.883-18.197V43.898l-8.563 4.311-8.563 4.311v17.244l17.126-8.622ZM687.146 43.9v17.245l17.125 8.622V53.403c-.53-.122-.923-.54-.923-1.04 0-.099.02-.191.047-.281L687.146 43.9Zm17.756 9.503v16.364l17.125-8.622V43.9l-16.249 8.181a.97.97 0 0 1 .047.28c0 .501-.393.919-.923 1.041Zm17.756-10.14 17.126 8.621V34.642l-17.126-8.623v17.243Zm0-17.88 17.126 8.622V16.761l-17.126-8.623v17.245Zm17.757-8.621v17.243l8.563-4.31 7.687-3.871a.94.94 0 0 1-.048-.28c0-.502.393-.919.923-1.041V8.14l-17.125 8.622Zm17.757 7.741c.216.05.411.146.564.28l16.561-8.338V-.8l-17.125 8.623v16.68Zm17.125-26.257.315.159.316-.16v.001l16.81-8.464-17.125-8.622-17.125 8.622 16.809 8.464Zm-17.125-8.94 17.125-8.623v-17.245l-17.125 8.623v17.244Zm34.881-17.88V-45.82l-16.562-8.339c-.152.134-.347.23-.562.28v16.68l17.124 8.623ZM688.069 79.182c0 .098-.02.192-.048.282l16.724 8.42.157.08v35.74l16.463 8.289c.224-.275.59-.455 1.006-.455.684 0 1.239.484 1.239 1.08 0 .501-.393.919-.923 1.041v17.516l-17.757-8.942v17.563l-18.387 9.258v-18.516l17.423-8.773-17.136-8.627-16.566 8.34c.028.09.048.183.048.282 0 .596-.555 1.08-1.239 1.08s-1.239-.484-1.239-1.08c0-.501.393-.919.924-1.041v-16.361l-.001-18.199-17.44-8.78-17.126 8.622 17.283 8.703.158.079v17.88l.316.159-.316.159v17.563l17.599 8.86.158.079V178l-18.23-9.179-.158-.079V151.18l-17.125 8.623v.317l-.316-.159-18.072 9.1v-17.317a1.308 1.308 0 0 1-.565-.28l-16.561 8.337v18.194l-17.757-8.941v.004l-18.229-9.178-.158-.079v-17.562l-17.125 8.622v.318l-.316-.159-.315.159v-.318l-17.44-8.78-18.073 9.098v-18.197l-17.125-8.622v17.563l-18.388 9.258-17.756 8.94v-18.199l-16.562-8.338c-.225.197-.535.32-.879.32-.684 0-1.239-.484-1.239-1.08 0-.597.555-1.081 1.239-1.081.344 0 .655.123.879.32l16.562-8.339v-18.198l18.23 9.179.157.079v17.563l17.126-8.622v-18.197l17.192 8.656c.153-.134.348-.231.564-.28V96.906l18.388-9.257v17.879l17.757-8.94v18.516l-17.441 8.78 17.124 8.621 18.072-9.099v18.197l17.126 8.622v-35.126l-17.599-8.861-.158-.079V87.642l17.193 8.657c.225-.198.536-.32.879-.32.685 0 1.239.484 1.239 1.08 0 .501-.393.918-.923 1.041v16.683l17.599 8.861.158.079v17.563l17.126-8.622v-16.681c-.531-.123-.924-.54-.924-1.041 0-.098.021-.191.048-.282l-16.723-8.42-.158-.079V87.646l18.072 9.099 17.757-8.941 17.757 8.94 17.756-8.94 17.442 8.781V80.223c-.53-.122-.923-.539-.923-1.04 0-.597.554-1.08 1.239-1.08.682 0 1.237.484 1.237 1.08Zm16.202 9.099-16.562-8.338c-.153.134-.347.23-.564.28v16.68l.316.158 16.81 8.464V88.282Zm-34.882 35.123 17.126-8.622V97.539l-17.126 8.622v17.244Zm17.757-8.622 17.125 8.622v-17.244l-17.125-8.622v17.244Zm17.125 9.258-17.126-8.622v17.243l17.126 8.622v-17.243Zm17.784 26.18v-16.563c-.53-.122-.923-.539-.923-1.04 0-.034.009-.067.012-.101l-16.214-8.163v17.245l17.125 8.622Zm-34.881 17.881 17.125-8.623v-17.244l-17.125 8.622v17.245Zm-17.785-27.382c.216.05.411.146.564.28l16.562-8.338v-17.243l-17.126 8.622v16.679Zm-35.828-16.519-17.126 8.622 7.78 3.917 9.345 4.706 17.126-8.623-7.78-3.917-9.345-4.705Zm-17.441 25.462c.216.05.41.146.563.28l16.247-8.179-16.81-8.464v16.363Zm17.125-7.423-16.251 8.181a.953.953 0 0 1 .048.282c0 .098-.02.191-.048.281l16.251 8.182V142.24Zm0-18.516v-17.245l-16.251 8.182c.028.09.048.183.048.281 0 .501-.392.918-.923 1.041v16.363l17.126-8.622Zm-17.125-9.822c.216.05.411.145.564.28l16.246-8.18-16.81-8.463v16.363Zm34.881 1.2-17.125-8.623v17.245l17.125 8.622v-17.244Zm.631 53.322 17.126 8.622v-17.244l-17.126-8.622v17.244Zm-.631-17.88V133.3l-17.125 8.622v17.245l17.125-8.623Zm-18.072 9.099-16.246-8.18a1.279 1.279 0 0 1-.564.281v16.363l16.81-8.464Zm-35.198 17.398v-17.24l-17.125-8.622v17.24l17.125 8.622Zm-53.268-26.815v-17.243l-17.126-8.622v17.243l17.126 8.622Zm-34.883 0 17.126-8.622v-17.243l-8.563 4.311-8.562 4.311v17.243h-.001Zm17.126-43.744-8.563 4.311-7.687 3.87c.028.09.048.183.048.282 0 .5-.393.918-.923 1.04v16.363l8.562-4.311 8.563-4.311v-17.244Zm-35.513 17.879-17.126 8.622v17.245l17.126-8.623v-17.244Zm-34.882 34.807 17.125-8.623V133.3l-17.125 8.623v17.245Zm-16.881-26.063 16.565 8.341 17.126-8.622-7.78-3.917-9.346-4.706-16.565 8.341a.98.98 0 0 1 .048.282.974.974 0 0 1-.048.281Zm34.006-18.003-17.125-8.623v17.245l17.125 8.623v-17.245Zm18.388-8.62v17.243l17.125 8.622v-16.362c-.53-.122-.923-.54-.923-1.041 0-.098.02-.191.048-.282l-16.25-8.18Zm34.882-17.88-17.126 8.621v16.68c.216.05.411.146.564.28l7.999-4.027 8.563-4.311V88.602Zm17.757 8.939-17.126 8.622v17.244l17.126-8.622V97.541Zm17.755 26.818-17.125 8.623v17.244l17.125-8.623v-17.244Zm.631 17.88v17.244l17.126 8.622v-17.244l-17.126-8.622Zm34.882 16.923v-17.24l-17.125-8.622v17.24l17.125 8.622Zm-34.882-70.566v17.246l17.126 8.622V98.101c-.53-.123-.923-.54-.923-1.041 0-.099.02-.192.048-.282l-16.251-8.181Zm34.882 35.445-17.125-8.623v17.245l17.125 8.623v-17.245Zm.632 35.124 16.25-8.181a.941.941 0 0 1-.048-.281c0-.501.393-.918.923-1.041V133.3l-17.125 8.622v17.243Zm0-53.322 16.561 8.338c.153-.134.348-.23.564-.28v-16.68L598.362 88.6v17.244h.001Zm35.197-17.404-17.125 8.623 16.81 8.463.315.159.316-.159 16.81-8.463-17.126-8.623Zm18.388 8.623 17.125 8.622 17.126-8.622-17.126-8.623-17.125 8.623Z'
            />
          </g>
          <defs>
            <radialGradient
              id='b'
              cx={0}
              cy={0}
              r={1}
              gradientTransform='matrix(-633.12871 -375.16248 354.03476 -597.47331 744.457 456.511)'
              gradientUnits='userSpaceOnUse'>
              <stop stopColor='#8B8B8B' />
              <stop offset={0.664} stopColor='#FEFEFE' />
              <stop offset={0.867} stopColor='#FAFAFB' />
              <stop offset={0.976} stopColor='#fff' />
            </radialGradient>
          </defs>
        </>
      );
    case 'desktop-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M5.438 15.75c0-.31.251-.563.562-.563h6a.562.562 0 1 1 0 1.126H6a.562.562 0 0 1-.563-.563ZM.938 3.75c0-1.14.923-2.063 2.062-2.063h12c1.14 0 2.063.924 2.063 2.063v7.5c0 1.14-.924 2.063-2.063 2.063H3A2.062 2.062 0 0 1 .937 11.25v-7.5ZM3 2.812a.937.937 0 0 0-.938.938v7.5c0 .518.42.938.938.938h12c.518 0 .938-.42.938-.938v-7.5A.937.937 0 0 0 15 2.812H3Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M.938 10.5c0-.31.251-.563.562-.563h15a.562.562 0 1 1 0 1.126h-15a.562.562 0 0 1-.563-.563ZM10.5 12.188c.31 0 .563.251.563.562v.75c0 .553.113 1.026.27 1.34a.967.967 0 0 0 .217.304.237.237 0 0 0 .072.043h.003a.562.562 0 1 1 0 1.126c-.639 0-1.065-.503-1.299-.97-.25-.501-.389-1.153-.389-1.843v-.75c0-.31.252-.563.563-.563ZM7.5 12.188c.31 0 .563.251.563.562v.75c0 .69-.14 1.342-.39 1.842-.233.467-.66.97-1.298.97a.562.562 0 1 1 0-1.125h.003a.237.237 0 0 0 .072-.043.967.967 0 0 0 .217-.305c.157-.313.27-.786.27-1.339v-.75c0-.31.252-.563.563-.563Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'chrome-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M13.375 4.625a6.187 6.187 0 0 0-8.75 0l-.398-.398.398.398a6.187 6.187 0 1 0 8.75 0Zm.795-.796A7.313 7.313 0 1 0 3.83 14.17 7.313 7.313 0 0 0 14.171 3.83v-.001Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M10.772 7.228a2.506 2.506 0 1 0-3.544 3.544 2.506 2.506 0 0 0 3.544-3.544Zm.795-.796a3.63 3.63 0 0 0-5.134 5.135l.354-.354-.354.354a3.63 3.63 0 0 0 5.134 0l-.398-.398.398.398a3.63 3.63 0 0 0 0-5.134Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M11.937 10.045c.27.154.363.498.209.768l-2.983 5.216a.563.563 0 1 1-.976-.559l2.982-5.216a.563.563 0 0 1 .768-.209ZM3.039 4.869a.563.563 0 0 1 .77.202l3.022 5.183a.563.563 0 0 1-.972.566L2.836 5.638a.563.563 0 0 1 .203-.77ZM8.438 5.933c0-.311.251-.563.562-.563h6.015a.562.562 0 1 1 0 1.125H9a.563.563 0 0 1-.563-.562Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'mobile-device-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M7.321 1.74c.313 0 .566.254.566.567v1.448h2.226V2.307a.566.566 0 0 1 1.133 0v1.51c0 .49-.35 1.07-.986 1.07H7.74c-.636 0-.985-.58-.985-1.07v-1.51c0-.313.253-.567.566-.567ZM7.494 13.642c0-.313.254-.567.566-.567h1.881a.566.566 0 0 1 0 1.133h-1.88a.566.566 0 0 1-.567-.566Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M6.482 2.873c-.615 0-1.113.498-1.113 1.113V14.06c0 .615.498 1.113 1.113 1.113h5.038c.615 0 1.113-.498 1.113-1.113V3.986c0-.615-.498-1.113-1.113-1.113H6.482ZM4.236 3.986A2.245 2.245 0 0 1 6.482 1.74h5.038a2.245 2.245 0 0 1 2.245 2.246V14.06a2.245 2.245 0 0 1-2.245 2.246H6.482a2.245 2.245 0 0 1-2.246-2.246V3.986Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'arc-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M6.84 3.118c.737-1.475 2.842-1.475 3.58 0l1.788 3.577c.153-.317.264-.658.328-1.016a2.268 2.268 0 0 1 4.465.795 8.492 8.492 0 0 1-2.553 4.702l.612 1.223a2.267 2.267 0 1 1-4.056 2.028l-.57-1.14a8.538 8.538 0 0 1-3.608 0l-.57 1.14A2.268 2.268 0 0 1 2.2 12.399l.61-1.223A8.534 8.534 0 0 1 1.417 9.48 2.267 2.267 0 0 1 5.02 6.756l1.82-3.638Zm-.689 4.957c.347.278.74.499 1.167.648l.954-1.907a.4.4 0 0 1 .716 0l3.447 6.895a.666.666 0 1 0 1.193-.596l-4.64-9.282a.4.4 0 0 0-.715 0L6.151 8.075Zm2.903 2.454a5.565 5.565 0 0 1-5.15-2.605.667.667 0 1 0-1.13.707 6.899 6.899 0 0 0 6.915 3.167l-.635-1.269Zm-4.952 1.645-.47.94a.667.667 0 0 0 1.192.597l.458-.916a8.452 8.452 0 0 1-1.18-.62Zm9.592-2.507a6.886 6.886 0 0 0 1.731-3.473.667.667 0 0 0-1.312-.234 5.54 5.54 0 0 1-1.068 2.41l.649 1.297Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'github-branch-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M5.625 2.252a1.122 1.122 0 1 0 0 2.245 1.122 1.122 0 0 0 0-2.245ZM3.372 3.375a2.253 2.253 0 1 1 4.505 0 2.253 2.253 0 0 1-4.505 0ZM5.625 13.502a1.122 1.122 0 1 0 0 2.245 1.122 1.122 0 0 0 0-2.245Zm-2.253 1.123a2.252 2.252 0 1 1 4.505 0 2.252 2.252 0 0 1-4.505 0Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M5.625 4.497c.312 0 .565.253.565.565v7.875a.565.565 0 0 1-1.13 0V5.062c0-.312.253-.565.565-.565ZM12.375 4.502a1.122 1.122 0 1 0 0 2.245 1.122 1.122 0 0 0 0-2.245Zm-2.253 1.123a2.252 2.252 0 1 1 4.505 0 2.252 2.252 0 0 1-4.505 0Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M12.375 6.747c.312 0 .565.253.565.565 0 1.3-.505 2.148-1.302 2.69-.74.505-1.698.715-2.523.887l-.133.027c-.824.171-1.514.315-2.023.605a1.47 1.47 0 0 0-.56.518c-.123.207-.21.489-.21.898a.565.565 0 0 1-1.13 0c0-.575.125-1.066.37-1.477.246-.411.59-.705.97-.921.673-.383 1.535-.56 2.297-.718l.188-.039c.863-.18 1.593-.356 2.118-.713.468-.319.808-.806.808-1.757 0-.312.252-.565.565-.565Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'send-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M2.104 5.549c-.896-.896-.261-2.426 1.005-2.426h11.783a1.42 1.42 0 0 1 1.217 2.152L9.86 15.692c-.66 1.102-2.326.83-2.605-.422L5.948 9.393 2.104 5.549Zm1.005-1.29a.284.284 0 0 0-.202.486L6.87 8.706c.076.077.13.173.153.279l1.341 6.038c.056.252.39.305.521.085l6.25-10.418a.284.284 0 0 0-.242-.43H3.109Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M16.123 3.843c.15.276.05.621-.227.771l-9.16 4.994a.568.568 0 0 1-.544-.998l9.16-4.994a.568.568 0 0 1 .771.227Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'branch-opened-icon':
      return (
        <>
          <path
            fill='var(--accent-success)'
            fillRule='evenodd'
            d='M6.4 3.378 8.146 1.63a.182.182 0 0 1 .311.129v3.496a.182.182 0 0 1-.31.129L6.398 3.636a.182.182 0 0 1 0-.258ZM3.534 2.96a.547.547 0 1 0 0 1.094.547.547 0 0 0 0-1.094Zm-1.64.547a1.641 1.641 0 1 1 2.187 1.547v3.834a1.642 1.642 0 1 1-1.093 0V5.054a1.642 1.642 0 0 1-1.094-1.547Zm7.293-.547h-.73v1.094h.73a.73.73 0 0 1 .729.73v4.104a1.642 1.642 0 1 0 1.094 0V4.783A1.823 1.823 0 0 0 9.188 2.96Zm-6.2 7.475a.547.547 0 1 1 1.095 0 .547.547 0 0 1-1.094 0Zm6.93 0a.547.547 0 1 1 1.093 0 .547.547 0 0 1-1.094 0Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'branch-closed-icon':
      return (
        <>
          <path
            fill='var(--accent-error)'
            fillRule='evenodd'
            d='M9.04 1.92c.22-.22.576-.22.795 0l.727.728.728-.727a.562.562 0 1 1 .795.795l-.727.727.727.728a.562.562 0 1 1-.795.795l-.727-.727-.728.727a.563.563 0 0 1-.795-.795l.727-.728-.727-.727a.563.563 0 0 1 0-.795ZM10.563 5.875a.562.562 0 0 0-.563.563V8.97a1.688 1.688 0 1 0 1.125 0V6.437a.562.562 0 0 0-.563-.562Zm0 4.125a.563.563 0 1 0 0 1.125.563.563 0 0 0 0-1.125ZM2.875 3.438a.563.563 0 1 1 1.125 0 .563.563 0 0 1-1.125 0Zm.563-1.688a1.688 1.688 0 0 0-.563 3.279v3.942a1.688 1.688 0 1 0 1.125 0V5.029a1.688 1.688 0 0 0-.563-3.279Zm0 8.25a.563.563 0 1 0 0 1.125.563.563 0 0 0 0-1.125Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'download-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M2.25 10.685c.312 0 .565.252.565.565v3a.935.935 0 0 0 .935.935h10.5a.935.935 0 0 0 .935-.935v-3a.565.565 0 1 1 1.13 0v3a2.065 2.065 0 0 1-2.065 2.065H3.75a2.065 2.065 0 0 1-2.065-2.065v-3c0-.313.253-.565.565-.565Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M8.6 11.649c.22.22.577.22.798 0l3.75-3.75a.565.565 0 1 0-.799-.8L9 10.45 5.649 7.1a.565.565 0 1 0-.8.799l3.75 3.75Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M9 11.815a.565.565 0 0 0 .565-.566v-9a.565.565 0 0 0-1.13 0v9c0 .313.253.566.565.566Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'close-preview-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M3.6 3.6c.22-.22.578-.22.8 0l10 10a.565.565 0 0 1-.8.8l-10-10a.565.565 0 0 1 0-.8Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M14.4 3.6c.22.22.22.578 0 .8l-10 10a.565.565 0 0 1-.8-.8l10-10c.22-.22.578-.22.8 0Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'repo-public-icon':
      return (
        <>
          <path
            fill='var(--text-primary)'
            fillRule='evenodd'
            d='M3.429 3.905A1.905 1.905 0 0 1 5.333 2H12a.572.572 0 0 1 .572.571v9.524a.571.571 0 0 1-.572.572h-1.905a.571.571 0 1 1 0-1.143h1.334V10H5.333a.761.761 0 0 0-.544 1.295.572.572 0 0 1-.816.8 1.9 1.9 0 0 1-.544-1.333V3.905Zm8-.762v5.714H5.333c-.27 0-.528.057-.761.159V3.905a.762.762 0 0 1 .761-.762h6.096Zm-5.715 8.19v2.476a.19.19 0 0 0 .305.153l1.105-.828a.19.19 0 0 1 .229 0l1.104.828a.19.19 0 0 0 .305-.152v-2.477a.19.19 0 0 0-.19-.19H5.905a.19.19 0 0 0-.19.19Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'github-inbox-light-icon':
      return (
        <>
          <path fill='#51B2E8' d='M0 14C0 6.268 6.268 0 14 0s14 6.268 14 14-6.268 14-14 14S0 21.732 0 14Z' />
          <path
            fill='#fff'
            d='M17.256 21.66h-6.128v-1.021h-.966a2.396 2.396 0 0 1-2.23-1.545l-.357-.957a.34.34 0 0 0-.319-.222h-.213a1.02 1.02 0 0 1-1.008-1.191c.08-.485.527-.851 1.042-.851h.766a1.702 1.702 0 0 1 1.566 1.03l.405.94a.682.682 0 0 0 .625.413h.69c.059-.834.335-1.494.808-1.958l.094-.09c-2.162-.714-3.626-2.467-3.626-4.42.005-.8.241-1.58.68-2.247V8.124c0-.554.129-1.1.375-1.596l.098-.187h.587a2.707 2.707 0 0 1 1.928.796l.162.161a7.03 7.03 0 0 1 3.923 0l.162-.161a2.706 2.706 0 0 1 1.923-.796h.588l.093.187c.247.496.375 1.042.375 1.596V9.54c.44.667.676 1.448.68 2.247 0 1.953-1.463 3.706-3.625 4.42l.08.082a2.742 2.742 0 0 1 .822 1.949v3.421Zm-5.447 0h4.766v-3.421a2.057 2.057 0 0 0-.617-1.46l-.944-.923.604-.14c2.166-.511 3.68-2.124 3.68-3.928a3.454 3.454 0 0 0-.62-1.954l-.06-.085V8.124c0-.378-.074-.753-.217-1.102h-.158a2.03 2.03 0 0 0-1.442.6l-.46.455-.2-.068a6.333 6.333 0 0 0-3.898 0l-.2.068-.46-.455a2.03 2.03 0 0 0-1.442-.6h-.157c-.144.35-.217.724-.217 1.102v1.625l-.06.086a3.455 3.455 0 0 0-.621 1.953c0 1.804 1.515 3.417 3.68 3.923l.605.14-.957.937c-.354.344-.558.855-.609 1.523a.68.68 0 0 1-.677.626h-.689a1.361 1.361 0 0 1-1.251-.826l-.4-.94a1.022 1.022 0 0 0-.94-.617h-.766c-.183 0-.345.123-.37.28a.34.34 0 0 0 .331.4h.209a1.025 1.025 0 0 1 .957.664l.358.954a1.71 1.71 0 0 0 1.595 1.106h.966a.68.68 0 0 1 .681.68v1.022Z'
          />
        </>
      );
    case 'github-inbox-dark-icon':
      return (
        <>
          <path fill='#2E2E30' d='M0 14C0 6.268 6.268 0 14 0s14 6.268 14 14-6.268 14-14 14S0 21.732 0 14Z' />
          <path
            fill='#fff'
            d='M17.256 21.66h-6.128v-1.021h-.966a2.396 2.396 0 0 1-2.23-1.545l-.357-.957a.34.34 0 0 0-.319-.222h-.213a1.02 1.02 0 0 1-1.008-1.191c.08-.485.527-.851 1.042-.851h.766a1.702 1.702 0 0 1 1.566 1.03l.405.94a.682.682 0 0 0 .625.413h.69c.059-.834.335-1.494.808-1.958l.094-.09c-2.162-.714-3.626-2.467-3.626-4.42.005-.8.241-1.58.68-2.247V8.124c0-.554.129-1.1.375-1.596l.098-.187h.587a2.707 2.707 0 0 1 1.928.796l.162.161a7.03 7.03 0 0 1 3.923 0l.162-.161a2.706 2.706 0 0 1 1.923-.796h.588l.093.187c.247.496.375 1.042.375 1.596V9.54c.44.667.676 1.448.68 2.247 0 1.953-1.463 3.706-3.625 4.42l.08.082a2.742 2.742 0 0 1 .822 1.949v3.421Zm-5.447 0h4.766v-3.421a2.057 2.057 0 0 0-.617-1.46l-.944-.923.604-.14c2.166-.511 3.68-2.124 3.68-3.928a3.454 3.454 0 0 0-.62-1.954l-.06-.085V8.124c0-.378-.074-.753-.217-1.102h-.158a2.03 2.03 0 0 0-1.442.6l-.46.455-.2-.068a6.333 6.333 0 0 0-3.898 0l-.2.068-.46-.455a2.03 2.03 0 0 0-1.442-.6h-.157c-.144.35-.217.724-.217 1.102v1.625l-.06.086a3.455 3.455 0 0 0-.621 1.953c0 1.804 1.515 3.417 3.68 3.923l.605.14-.957.937c-.354.344-.558.855-.609 1.523a.68.68 0 0 1-.677.626h-.689a1.361 1.361 0 0 1-1.251-.826l-.4-.94a1.022 1.022 0 0 0-.94-.617h-.766c-.183 0-.345.123-.37.28a.34.34 0 0 0 .331.4h.209a1.025 1.025 0 0 1 .957.664l.358.954a1.71 1.71 0 0 0 1.595 1.106h.966a.68.68 0 0 1 .681.68v1.022Z'
          />
        </>
      );
    case 'video-pause-icon':
      return (
        <>
          <g>
            <path
              fill='#000'
              fillOpacity={0.1}
              fillRule='evenodd'
              d='M15 30c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15Z'
              clipRule='evenodd'
            />
            <rect width={1.941} height={11} x={11.559} y={9.5} fill='#202022' rx={0.971} />
            <rect width={1.941} height={11} x={16.5} y={9.5} fill='#202022' rx={0.971} />
          </g>
          <defs>
            <clipPath id='a'>
              <path fill='#fff' d='M0 0h30v30H0z' />
            </clipPath>
          </defs>
        </>
      );
    case 'inline-code-icon':
      return (
        <path
          fill={fill}
          fillRule='evenodd'
          d='M2.002 3.433c0-.312.253-.565.565-.565h13.077a.565.565 0 1 1 0 1.13H2.567a.565.565 0 0 1-.565-.565ZM12.173 9.126c0-.312.253-.565.565-.565h2.907a.565.565 0 1 1 0 1.13h-2.907a.565.565 0 0 1-.565-.565ZM2.004 14.813c0-.312.253-.565.565-.565h13.077a.565.565 0 0 1 0 1.13H2.569a.565.565 0 0 1-.565-.565ZM4.381 7.023c.22.22.22.578 0 .799l-1.31 1.31 1.31 1.31a.565.565 0 0 1-.799.799L1.95 9.607a.673.673 0 0 1 0-.951l1.633-1.633c.22-.22.579-.22.8 0ZM7.515 7.023a.565.565 0 0 0 0 .799l1.31 1.31-1.31 1.31a.565.565 0 0 0 .8.799l1.633-1.634a.673.673 0 0 0 0-.951L8.314 7.023a.565.565 0 0 0-.799 0ZM6.453 6.613a.565.565 0 0 1 .434.672L6.042 11.2a.565.565 0 0 1-1.104-.238l.844-3.915a.565.565 0 0 1 .671-.434Z'
          clipRule='evenodd'
        />
      );
    case 'workspace-loading-logo':
      return (
        <>
          <path
            fill='#ACAEB0'
            d='M0 18C0 8.059 8.059 0 18 0s18 8.059 18 18-8.059 18-18 18S0 27.941 0 18Z'
            className='fill'
          />
          <mask
            id='b'
            width={24}
            height={24}
            x={6}
            y={6}
            maskUnits='userSpaceOnUse'
            style={{
              maskType: 'alpha'
            }}>
            <mask
              id='a'
              width={24}
              height={24}
              x={6}
              y={6}
              maskUnits='userSpaceOnUse'
              style={{
                maskType: 'luminance'
              }}>
              <path fill='#fff' d='M29.988 6.012H6.012v23.976h23.976V6.012Z' />
            </mask>
            <g fill='#1263BE' mask='url(#a)'>
              <path d='m22.13 6.012-2.105 4.027 4.234 2.287 2.105-4.027-4.234-2.287Zm3.612 13.695h4.247v-4.875h-4.247v4.875Zm-5.717-9.668c-2.291 4.383.834 9.668 5.717 9.668v-4.875c-1.266 0-2.076-1.37-1.483-2.506l-4.234-2.287ZM13.87 6.012l2.106 4.027-4.235 2.287-2.105-4.027 4.235-2.287ZM10.26 19.707H6.01v-4.875h4.248v4.875Zm5.717-9.668c2.29 4.383-.835 9.668-5.717 9.668v-4.875c1.266 0 2.076-1.37 1.482-2.506l4.235-2.287ZM14.219 29.988l3.662-5.385-3.945-2.772-3.662 5.386 3.945 2.771Zm3.662-5.385 3.662 5.385 4.18-2.536-3.897-5.62-3.945 2.77Zm0 0a.05.05 0 0 1 .005-.007l-.005.004a.027.027 0 0 1-.004.002l-.002.001h.002a.023.023 0 0 1 .008 0h.002-.002l-.005-.003a.034.034 0 0 1-.003-.003c-.001-.001-.001-.001 0 0l.004.006 3.945-2.772a4.751 4.751 0 0 0-7.89 0l3.945 2.772Z' />
            </g>
          </mask>
          <g mask='url(#b)'>
            <path
              fill='url(#c)'
              d='M18 29.988c6.62 0 11.988-5.367 11.988-11.988 0-6.62-5.367-11.988-11.988-11.988-6.62 0-11.988 5.367-11.988 11.988 0 6.62 5.367 11.988 11.988 11.988Z'
            />
          </g>
          <defs>
            <linearGradient id='c' x1={18} x2={18} y1={6.012} y2={29.988} gradientUnits='userSpaceOnUse'>
              <stop stopColor='#fff' />
              <stop offset={1} stopColor='#fff' stopOpacity={0.9} />
            </linearGradient>
          </defs>
        </>
      );
    case 'user-icon':
      return (
        <>
          <path
            fill='var(--text-primary)'
            fillRule='evenodd'
            d='M7.05 12.256A2.725 2.725 0 0 0 4.306 15a.556.556 0 1 1-1.112 0 3.837 3.837 0 0 1 3.856-3.856h3.825A3.837 3.837 0 0 1 14.731 15a.556.556 0 1 1-1.112 0 2.725 2.725 0 0 0-2.744-2.744H7.05ZM10.859 4.304a2.7 2.7 0 0 0-3.723.006c-1.017.957-.994 2.623.024 3.704.958 1.018 2.623.994 3.705-.024 1.03-.97 1.05-2.624-.006-3.686Zm.775-.815a3.825 3.825 0 0 0-5.269.001C4.832 4.933 4.96 7.317 6.341 8.786c1.443 1.532 3.827 1.405 5.295.024 1.518-1.428 1.5-3.818.014-5.306a.397.397 0 0 0-.008-.008l-.008-.007Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'youtube-icon':
      return (
        <>
          <g clipPath='url(#a)'>
            <path
              fill='red'
              d='M19.563 5.186a2.518 2.518 0 0 0-1.771-1.771c-1.553-.424-7.805-.424-7.805-.424s-6.251.012-7.804.436A2.519 2.519 0 0 0 .41 5.2C0 6.752 0 10 0 10s0 3.248.424 4.814a2.519 2.519 0 0 0 1.771 1.771c1.553.424 7.805.424 7.805.424s6.252 0 7.805-.423a2.518 2.518 0 0 0 1.772-1.772C20 13.261 20 10 20 10s-.012-3.248-.437-4.814Z'
            />
            <path fill='#fff' d='M7.997 13.004 13.183 10 7.997 6.996v6.008Z' />
          </g>
          <defs>
            <clipPath id='a'>
              <path fill='#fff' d='M0 0h20v20H0z' />
            </clipPath>
          </defs>
        </>
      );
    case 'updated-external-link-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M16.105 1.816a.557.557 0 0 1 .218.446v5.257a.563.563 0 1 1-1.126 0V3.62L9.399 9.42a.563.563 0 0 1-.797-.796L14.4 2.825h-3.897a.563.563 0 1 1 0-1.127h5.257a.57.57 0 0 1 .345.118Zm0 0A.56.56 0 0 0 15.8 1.7l.304.116Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M1.678 3.764c0-1.141.924-2.066 2.065-2.066h3.004a.563.563 0 0 1 0 1.127H3.743a.938.938 0 0 0-.939.939v10.514c0 .519.42.939.94.939h10.514c.518 0 .938-.42.938-.939v-3.004a.563.563 0 0 1 1.127 0v3.004a2.065 2.065 0 0 1-2.066 2.065H3.744a2.065 2.065 0 0 1-2.065-2.065V3.764Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'table-first-row-header-icon':
      return (
        <>
          <path
            fill='var(--neutral-primary)'
            d='M2.65 6.948c0-1.306 1.124-2.364 2.51-2.364h7.68c1.387 0 2.51 1.058 2.51 2.364v2.071H2.65V6.948Z'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M2.651 9c0-.312.253-.564.565-.564h11.567a.565.565 0 1 1 0 1.13H3.216A.565.565 0 0 1 2.651 9Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M2.651 7.077a2.493 2.493 0 0 1 2.493-2.493h7.71a2.493 2.493 0 0 1 2.494 2.493v3.847a2.493 2.493 0 0 1-2.493 2.493h-7.71a2.493 2.493 0 0 1-2.494-2.493V7.077Zm2.493-1.363c-.753 0-1.363.61-1.363 1.363v3.847c0 .753.61 1.363 1.363 1.363h7.71c.753 0 1.364-.61 1.364-1.363V7.077c0-.753-.61-1.363-1.363-1.363h-7.71Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M10.606 4.584c.312 0 .565.253.565.565v7.703a.565.565 0 1 1-1.13 0V5.149c0-.312.253-.565.565-.565ZM7.033 4.72c.312 0 .565.254.565.566v7.566a.565.565 0 1 1-1.13 0V5.286c0-.312.253-.565.565-.565Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'navigation-home-icon':
      return (
        <path
          fill='var(--text-tertiary)'
          fillRule='evenodd'
          d='M14.303 3.04a3.75 3.75 0 0 0-4.605 0h4.604Zm0 0 6 4.667a3.749 3.749 0 0 1 1.447 2.96V18A3.75 3.75 0 0 1 18 21.75h-3.5a.75.75 0 0 1-.75-.75v-4.5a1.75 1.75 0 1 0-3.5 0V21a.75.75 0 0 1-.75.75H6A3.75 3.75 0 0 1 2.25 18v-7.333c0-1.157.534-2.25 1.448-2.96l6-4.667'
          clipRule='evenodd'
        />
      );
    case 'navigation-inbox-icon':
      return (
        <>
          <path
            fill='var(--text-tertiary)'
            fillRule='evenodd'
            d='M5.06 4.035A2.75 2.75 0 0 1 7.637 2.25h9.228a2.75 2.75 0 0 1 2.575 1.785l2.386 10.363c.116.308.175.636.175.965V19a2.75 2.75 0 0 1-2.75 2.75h-14A2.75 2.75 0 0 1 2.5 19v-3.637c0-.33.06-.656.174-.965L5.061 4.035Zm1.405.526L4.08 14.922c-.053.141-.08.29-.08.441V19c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25v-3.637c0-.15-.027-.3-.08-.439L18.036 4.561a1.25 1.25 0 0 0-1.171-.811H7.636a1.25 1.25 0 0 0-1.17.811Z'
            clipRule='evenodd'
          />
          <path
            fill='var(--text-tertiary)'
            fillRule='evenodd'
            d='M2.534 15a.75.75 0 0 1 .75-.75h4.348c.663 0 1.27.375 1.565.968l.446.893c.043.086.13.139.225.139h4.764c.095 0 .18-.053.223-.138l.447-.894a1.752 1.752 0 0 1 1.566-.968h4.348a.75.75 0 0 1 .75.75c0 .414-.336 5.75-.75 5.75H3.284c-.414 0-.75-5.336-.75-5.75Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'table-first-column-header-icon':
      return (
        <>
          <path
            fill='var(--neutral-primary)'
            d='M5.264 13.417c-1.15 0-2.081-.782-2.081-1.746V6.33c0-.964.931-1.746 2.08-1.746h1.824v8.833H5.264Z'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M2.651 9c0-.312.253-.564.565-.564h11.567a.565.565 0 1 1 0 1.13H3.216A.565.565 0 0 1 2.651 9Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M2.651 7.077a2.493 2.493 0 0 1 2.493-2.493h7.71a2.493 2.493 0 0 1 2.494 2.493v3.847a2.493 2.493 0 0 1-2.493 2.493h-7.71a2.493 2.493 0 0 1-2.494-2.493V7.077Zm2.493-1.363c-.753 0-1.363.61-1.363 1.363v3.847c0 .753.61 1.363 1.363 1.363h7.71c.753 0 1.364-.61 1.364-1.363V7.077c0-.753-.61-1.363-1.363-1.363h-7.71Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M10.606 4.584c.312 0 .565.253.565.565v7.703a.565.565 0 1 1-1.13 0V5.149c0-.312.253-.565.565-.565ZM7.033 4.72c.312 0 .565.254.565.566v7.566a.565.565 0 1 1-1.13 0V5.286c0-.312.253-.565.565-.565Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'navigation-setting-icon':
      return (
        <>
          <path
            fill='var(--text-tertiary)'
            fillRule='evenodd'
            d='M18.505 19.287a1.397 1.397 0 0 1-1.976 0 1.443 1.443 0 0 0-1.578-.308 8.149 8.149 0 0 1-.174.07 1.32 1.32 0 0 0-.83 1.232v.072c0 .772-.625 1.397-1.396 1.397h-1.106a1.396 1.396 0 0 1-1.397-1.397v-.072c0-.542-.325-1.034-.83-1.232a8.188 8.188 0 0 1-.173-.07 1.435 1.435 0 0 0-1.574.307 1.397 1.397 0 0 1-1.976 0l-.782-.782a1.398 1.398 0 0 1 0-1.975 1.435 1.435 0 0 0 .308-1.574 8.2 8.2 0 0 1-.07-.174 1.32 1.32 0 0 0-1.232-.83h-.073a1.397 1.397 0 0 1-1.397-1.397v-1.107c0-.771.626-1.396 1.397-1.396h.073c.541 0 1.034-.326 1.233-.83a5.89 5.89 0 0 1 .07-.174c.228-.54.106-1.16-.308-1.575a1.397 1.397 0 0 1 0-1.975l.784-.782a1.397 1.397 0 0 1 1.975 0 1.435 1.435 0 0 0 1.574.308c.044-.02.089-.038.133-.056l.04-.016c.504-.198.83-.69.83-1.232v-.072c0-.772.625-1.397 1.398-1.397h1.106c.772 0 1.397.625 1.397 1.397v.072c0 .542.326 1.035.83 1.236.06.023.117.047.174.07.54.228 1.16.107 1.574-.307a1.397 1.397 0 0 1 1.976 0l.782.782c.545.545.545 1.43 0 1.976a1.435 1.435 0 0 0-.308 1.574c.024.057.048.115.07.173.199.504.69.83 1.232.83h.073c.771 0 1.396.625 1.396 1.397v1.106c0 .771-.625 1.396-1.396 1.396h-.073c-.541 0-1.033.325-1.232.83-.022.059-.046.116-.07.174-.227.54-.106 1.16.308 1.574.545.545.545 1.43 0 1.975l-.782.782Zm-4.25-5.032a3.188 3.188 0 1 0-4.509-4.508 3.188 3.188 0 0 0 4.509 4.508Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'full-width-icon':
      return (
        <>
          <path
            fill='var(--text-primary)'
            fillRule='evenodd'
            d='M2 2.167a.5.5 0 0 1 .5.5v10.666a.5.5 0 0 1-1 0V2.667a.5.5 0 0 1 .5-.5ZM14 2.167a.5.5 0 0 1 .5.5v10.666a.5.5 0 0 1-1 0V2.667a.5.5 0 0 1 .5-.5ZM10.313 6.313a.5.5 0 0 1 .707 0l1.334 1.333a.5.5 0 0 1 0 .708L11.02 9.687a.5.5 0 1 1-.708-.707l.98-.98-.98-.98a.5.5 0 0 1 0-.707ZM5.687 6.313a.5.5 0 0 1 0 .707l-.98.98.98.98a.5.5 0 0 1-.707.707L3.646 8.354a.5.5 0 0 1 0-.708L4.98 6.313a.5.5 0 0 1 .707 0Z'
            clipRule='evenodd'
          />
          <path
            fill='var(--text-primary)'
            fillRule='evenodd'
            d='M3.5 8a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 0 1H4a.5.5 0 0 1-.5-.5Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'navigation-search-icon':
      return (
        <>
          <path
            fill='var(--text-tertiary)'
            fillRule='evenodd'
            d='M16.63 6.354a6.736 6.736 0 1 0-9.526 9.526 6.736 6.736 0 0 0 9.526-9.526Zm1.293-1.293A8.564 8.564 0 1 0 5.812 17.173 8.564 8.564 0 0 0 17.923 5.06Z'
            clipRule='evenodd'
          />
          <path
            fill='var(--text-tertiary)'
            fillRule='evenodd'
            d='M16.626 15.875a.914.914 0 0 1 1.293 0l4.01 4.01a.914.914 0 0 1-1.293 1.293l-4.01-4.01a.914.914 0 0 1 0-1.293Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'navigation-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M13.168 2.893c1.197-.443 2.362.722 1.918 1.92l-3.759 10.141c-.51 1.376-2.491 1.267-2.849-.156L7.42 10.57 3.176 9.503c-1.422-.357-1.53-2.337-.155-2.848l10.147-3.762Zm-2.9 11.668L14.027 4.42a.363.363 0 0 0-.467-.467L3.414 7.715a.363.363 0 0 0 .037.692l4.572 1.149c.202.05.36.208.41.41l1.141 4.557c.087.346.57.372.694.038Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'calender-prev2Label':
      return (
        <>
          <path
            fill='var(--text-primary)'
            fillRule='evenodd'
            d='M8.742 1.65a.502.502 0 0 0-.709 0l-6 6a.502.502 0 0 0 0 .71l6 6a.502.502 0 0 0 .71-.708L3.096 8.006 8.742 2.36a.502.502 0 0 0 0-.71Z'
            clipRule='evenodd'
          />
          <path
            fill='var(--text-primary)'
            fillRule='evenodd'
            d='M13.968 1.65a.502.502 0 0 0-.71 0l-6 6a.502.502 0 0 0 0 .71l6 6a.502.502 0 1 0 .71-.708L8.322 8.006l5.646-5.646a.502.502 0 0 0 0-.71Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'calender-next2Label':
      return (
        <>
          <path
            fill='var(--text-primary)'
            fillRule='evenodd'
            d='M2.032 1.645a.502.502 0 0 1 .71 0l6 6a.502.502 0 0 1 0 .71l-6 6a.502.502 0 0 1-.71-.709L7.678 8 2.032 2.354a.502.502 0 0 1 0-.709Z'
            clipRule='evenodd'
          />
          <path
            fill='var(--text-primary)'
            fillRule='evenodd'
            d='M7.258 1.645a.502.502 0 0 1 .71 0l6 6a.501.501 0 0 1 0 .71l-6 6a.502.502 0 1 1-.71-.709L12.904 8 7.258 2.354a.502.502 0 0 1 0-.709Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'calender-prevLabel':
      return (
        <>
          <path
            fill='var(--text-secondary)'
            fillRule='evenodd'
            d='M11.356 1.65a.502.502 0 0 0-.71 0l-6 6a.502.502 0 0 0 0 .71l6 6a.502.502 0 0 0 .71-.708L5.71 8.006l5.646-5.646a.502.502 0 0 0 0-.71Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'calender-nextLabel':
      return (
        <>
          <path
            fill='var(--text-secondary)'
            fillRule='evenodd'
            d='M4.646 1.65a.502.502 0 0 1 .71 0l6 6a.502.502 0 0 1 0 .71l-6 6a.502.502 0 0 1-.71-.708l5.645-5.646L4.646 2.36a.502.502 0 0 1 0-.71Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'warning-icon':
      return (
        <>
          <path
            fill='var(--accent-caution)'
            fillRule='evenodd'
            d='M10.5 3.128A6.872 6.872 0 0 0 3.628 10 6.872 6.872 0 1 0 10.5 3.128Zm0 15A8.127 8.127 0 0 1 2.372 10 8.127 8.127 0 0 1 10.5 1.872 8.127 8.127 0 0 1 18.628 10a8.127 8.127 0 0 1-8.128 8.128Z'
            clipRule='evenodd'
          />
          <path
            fill='var(--accent-caution)'
            fillRule='evenodd'
            d='M10.5 5.622c.347 0 .628.281.628.628v4.166a.628.628 0 1 1-1.256 0V6.25c0-.347.281-.628.628-.628ZM9.664 13.543a.835.835 0 1 1 1.672-.002.836.836 0 0 1-1.672.002Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'error-icon':
      return (
        <>
          <path
            fill='var(--accent-error)'
            fillRule='evenodd'
            d='M10.499 3.067a6.932 6.932 0 1 0 0 13.864 6.932 6.932 0 0 0 0-13.864ZM2.312 10a8.187 8.187 0 1 1 16.374 0 8.187 8.187 0 0 1-16.374 0Z'
            clipRule='evenodd'
          />
          <path
            fill='var(--accent-error)'
            fillRule='evenodd'
            d='M7.279 6.718a.628.628 0 0 1 .887 0l5.556 5.556a.628.628 0 0 1-.888.887L7.28 7.606a.628.628 0 0 1 0-.888Z'
            clipRule='evenodd'
          />
          <path
            fill='var(--accent-error)'
            fillRule='evenodd'
            d='M13.722 6.718a.628.628 0 0 1 0 .888L8.166 13.16a.628.628 0 1 1-.887-.887l5.555-5.556a.628.628 0 0 1 .888 0Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'filter-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M12.938 3.75c0-.31.251-.563.562-.563h2.25a.562.562 0 1 1 0 1.126H13.5a.562.562 0 0 1-.563-.563ZM1.688 3.75c0-.31.251-.563.562-.563h8.25a.562.562 0 1 1 0 1.126H2.25a.563.563 0 0 1-.563-.563ZM6.938 9c0-.31.251-.563.562-.563h8.25a.562.562 0 1 1 0 1.126H7.5A.563.563 0 0 1 6.937 9ZM1.688 9c0-.31.251-.563.562-.563H4.5a.563.563 0 0 1 0 1.126H2.25A.563.563 0 0 1 1.687 9ZM12.938 14.25c0-.31.251-.563.562-.563h2.25a.562.562 0 1 1 0 1.126H13.5a.562.562 0 0 1-.563-.563ZM1.688 14.25c0-.31.251-.563.562-.563h8.25a.562.562 0 1 1 0 1.126H2.25a.562.562 0 0 1-.563-.563Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M12.663 3.087a.937.937 0 1 0-1.326 1.326.937.937 0 0 0 1.326-1.326Zm.795-.795a2.062 2.062 0 1 0-2.916 2.916 2.062 2.062 0 0 0 2.916-2.916ZM6.663 8.337a.937.937 0 1 0-1.326 1.326.937.937 0 0 0 1.326-1.326Zm.795-.795a2.063 2.063 0 0 0-2.917 2.917l.398-.398-.397.397a2.062 2.062 0 1 0 2.916-2.916ZM12.663 13.587a.937.937 0 1 0-1.326 1.326.937.937 0 0 0 1.326-1.326Zm.795-.795a2.062 2.062 0 1 0-2.916 2.916 2.062 2.062 0 0 0 2.916-2.916Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'flip-h-icon':
      return (
        <>
          <path
            fill='var(--text-white)'
            fillRule='evenodd'
            d='M11.853 17.943a.628.628 0 0 1 0-.888l3.857-3.857a.628.628 0 0 1 .887.888l-3.857 3.857a.628.628 0 0 1-.887 0Z'
            clipRule='evenodd'
          />
          <path
            fill='var(--text-white)'
            fillRule='evenodd'
            d='M12.295 18.127a.628.628 0 0 1-.628-.628V2.5a.628.628 0 0 1 1.255 0v15a.628.628 0 0 1-.627.627ZM3.405 6.8a.628.628 0 0 1 0-.888L7.26 2.055a.628.628 0 0 1 .888.888L4.292 6.8a.628.628 0 0 1-.887 0Z'
            clipRule='evenodd'
          />
          <path
            fill='var(--text-white)'
            fillRule='evenodd'
            d='M7.704 18.127a.628.628 0 0 1-.628-.628V2.5a.628.628 0 1 1 1.255 0v14.999a.628.628 0 0 1-.627.628Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'flip-v-icon':
      return (
        <>
          <path
            fill='var(--text-white)'
            fillRule='evenodd'
            d='M2.056 11.852a.628.628 0 0 1 .888 0L6.8 15.709a.628.628 0 1 1-.888.887L2.056 12.74a.628.628 0 0 1 0-.888Z'
            clipRule='evenodd'
          />
          <path
            fill='var(--text-white)'
            fillRule='evenodd'
            d='M1.872 12.294c0-.347.281-.628.628-.628h14.999a.628.628 0 0 1 0 1.256h-15a.628.628 0 0 1-.627-.628ZM13.199 3.404a.628.628 0 0 1 .888 0l3.857 3.857a.628.628 0 0 1-.888.888l-3.857-3.857a.628.628 0 0 1 0-.888Z'
            clipRule='evenodd'
          />
          <path
            fill='var(--text-white)'
            fillRule='evenodd'
            d='M1.872 7.703c0-.347.281-.628.628-.628h14.999a.628.628 0 0 1 0 1.256h-15a.628.628 0 0 1-.627-.628Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'rotate-left-icon':
      return (
        <>
          <path
            fill='var(--text-white)'
            fillRule='evenodd'
            d='M10.848 16.531c0 .47-.38.85-.85.85H4.77a.85.85 0 0 1-.85-.85v-5.228c0-.47.38-.85.85-.85h5.228c.47 0 .85.38.85.85v5.228Zm-.85 2.138c1.181 0 2.138-.957 2.138-2.138v-5.228c0-1.18-.957-2.138-2.138-2.138H4.77c-1.181 0-2.138.957-2.138 2.138v5.228c0 1.181.957 2.138 2.138 2.138h5.228ZM11.947 6.912a.644.644 0 0 0 0-.91l-1.785-1.785 1.785-1.786a.644.644 0 1 0-.91-.91l-2.24 2.24a.644.644 0 0 0 0 .91l2.24 2.241a.644.644 0 0 0 .91 0Z'
            clipRule='evenodd'
          />
          <path
            fill='var(--text-white)'
            fillRule='evenodd'
            d='M16.721 10.836a.644.644 0 0 0 .644-.644V7.204a3.632 3.632 0 0 0-3.631-3.631H9.252a.644.644 0 1 0 0 1.287h4.482a2.344 2.344 0 0 1 2.344 2.344v2.988c0 .355.288.644.643.644Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'rotate-right-icon':
      return (
        <>
          <path
            fill='var(--text-white)'
            fillRule='evenodd'
            d='M9.15 16.531c0 .47.38.85.85.85h5.228c.47 0 .85-.38.85-.85v-5.228a.85.85 0 0 0-.85-.85H10a.85.85 0 0 0-.85.85v5.228Zm.85 2.138a2.137 2.137 0 0 1-2.138-2.138v-5.228c0-1.181.957-2.138 2.138-2.138h5.228c1.181 0 2.138.957 2.138 2.138v5.228c0 1.18-.957 2.138-2.138 2.138H10ZM8.05 6.912a.644.644 0 0 1 0-.91l1.786-1.786-1.785-1.785a.644.644 0 0 1 .91-.91l2.241 2.24a.644.644 0 0 1 0 .91l-2.24 2.241a.644.644 0 0 1-.911 0Z'
            clipRule='evenodd'
          />
          <path
            fill='var(--text-white)'
            fillRule='evenodd'
            d='M3.277 10.835a.644.644 0 0 1-.644-.643V7.204a3.632 3.632 0 0 1 3.631-3.631h4.482a.644.644 0 0 1 0 1.287H6.264A2.344 2.344 0 0 0 3.92 7.204v2.988a.644.644 0 0 1-.643.643Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'zoom-out-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M9.5 3.13a6.37 6.37 0 1 0 0 12.74 6.37 6.37 0 0 0 0-12.74Zm0 13.998a7.628 7.628 0 1 1-.001-15.256 7.628 7.628 0 0 1 0 15.256Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M14.007 14.007a.63.63 0 0 1 .89 0l3.046 3.046a.63.63 0 0 1-.89.89l-3.046-3.046a.63.63 0 0 1 0-.89ZM5.757 9.5a.63.63 0 0 1 .63-.63h6.225a.63.63 0 0 1 0 1.26H6.386a.63.63 0 0 1-.63-.63Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'zoom-in-icon':
      return (
        <>
          <path
            fill='var(--text-white)'
            fillRule='evenodd'
            d='M9.5 3.13a6.37 6.37 0 1 0 0 12.74 6.37 6.37 0 0 0 0-12.74Zm0 13.998a7.628 7.628 0 1 1-.001-15.256 7.628 7.628 0 0 1 0 15.256Z'
            clipRule='evenodd'
          />
          <path
            fill='var(--text-white)'
            fillRule='evenodd'
            d='M14.007 14.007a.63.63 0 0 1 .89 0l3.046 3.046a.63.63 0 0 1-.89.89l-3.046-3.046a.63.63 0 0 1 0-.89ZM5.757 9.5a.63.63 0 0 1 .63-.63h6.225a.63.63 0 0 1 0 1.26H6.386a.63.63 0 0 1-.63-.63Z'
            clipRule='evenodd'
          />
          <path
            fill='var(--text-white)'
            fillRule='evenodd'
            d='M9.5 5.758a.63.63 0 0 1 .629.63v6.225a.63.63 0 0 1-1.259 0V6.388a.63.63 0 0 1 .63-.63Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'help-support-icon':
      return (
        <>
          <path
            fill='var(--text-primary)'
            d='M15.19 8.999a6.19 6.19 0 1 0-12.38 0 6.19 6.19 0 0 0 12.38 0Zm1.125 0a7.316 7.316 0 1 1-14.631 0 7.316 7.316 0 0 1 14.631 0Z'
          />
          <path
            fill='var(--text-primary)'
            d='M8.893 5.437a2.166 2.166 0 0 1 2.282 2.027V7.5c0 .86-.626 1.39-1.014 1.705-.228.185-.384.302-.503.426-.082.086-.096.126-.097.13l-.01.104a.562.562 0 0 1-1.102 0l-.012-.114c0-.403.22-.702.409-.898.183-.192.43-.379.606-.521.411-.335.59-.554.597-.817a1.04 1.04 0 0 0-.987-.954l-.106.001h-.15a1.074 1.074 0 0 0-.995.83.563.563 0 0 1-1.095-.254 2.197 2.197 0 0 1 2.177-1.7ZM9.113 11.17a.56.56 0 0 1 .328.207c.13.103.215.26.215.438a.656.656 0 0 1-1.299.132l-.013-.132.013-.132A.656.656 0 0 1 9 11.158l.113.012Z'
          />
          <path
            fill='var(--text-primary)'
            d='M9.656 11.813a.558.558 0 0 1-1 .348A.56.56 0 0 1 9 11.155c.362 0 .656.294.656.656Z'
          />
        </>
      );
    case 'workspace-switch-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M1.185 5.25A3.565 3.565 0 0 1 4.75 1.685h8.5a3.565 3.565 0 0 1 3.565 3.565v7.5a3.565 3.565 0 0 1-3.565 3.565h-8.5a3.565 3.565 0 0 1-3.565-3.565v-7.5ZM4.75 2.815A2.435 2.435 0 0 0 2.315 5.25v7.5a2.435 2.435 0 0 0 2.435 2.435h8.5a2.435 2.435 0 0 0 2.435-2.435v-7.5a2.435 2.435 0 0 0-2.435-2.435h-8.5Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M7.52 1.685c.312 0 .565.253.565.565v13.5a.565.565 0 0 1-1.13 0V2.25c0-.312.253-.565.565-.565ZM3.185 5.403c0-.312.253-.565.565-.565h1.385a.565.565 0 0 1 0 1.13H3.75a.565.565 0 0 1-.565-.565ZM3.185 7.652c0-.312.253-.565.565-.565h1.385a.565.565 0 0 1 0 1.13H3.75a.565.565 0 0 1-.565-.565Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'drop-file-icon':
      return (
        <>
          <path
            fill='var(--background-primary)'
            d='M4.956 29.913h21.05c.305 0 .554-.25.554-.555V7.755h-4.985a1.664 1.664 0 0 1-1.662-1.662V1.107H4.956a.556.556 0 0 0-.554.554v27.697c0 .305.25.555.554.555Z'
          />
          <path fill='var(--background-primary)' d='M25.776 6.65 21.02 1.896v4.202c0 .304.249.554.553.554h4.203Z' />
          <path
            fill='var(--text-secondary)'
            fillRule='evenodd'
            d='m27.402 6.486-5.998-6A1.673 1.673 0 0 0 20.229 0H5.177c-.916 0-1.661.746-1.661 1.662v27.697c0 .916.745 1.662 1.661 1.662h21.05c.916 0 1.662-.746 1.662-1.662v-21.7c0-.442-.173-.86-.487-1.173Zm-6.16-4.595 4.756 4.756h-4.202a.555.555 0 0 1-.554-.554V1.891ZM5.177 29.913h21.05c.305 0 .554-.25.554-.554V7.755h-4.985a1.664 1.664 0 0 1-1.662-1.662V1.108H5.177a.556.556 0 0 0-.553.554v27.697c0 .306.248.554.553.554Z'
            clipRule='evenodd'
            opacity={0.67}
          />
          <path fill='var(--text-secondary)' d='M15 27.009a9 9 0 1 1 18 0 9 9 0 0 1-18 0Z' />
          <path
            fill='var(--background-primary)'
            d='M23.735 26.744a.376.376 0 0 1 .531 0l1.5 1.5a.376.376 0 0 1-.531.53l-1.5-1.5a.376.376 0 0 1 0-.53Z'
          />
          <path
            fill='var(--background-primary)'
            d='M23.735 26.744a.376.376 0 0 1 .531.53l-1.5 1.5a.376.376 0 0 1-.531-.53l1.5-1.5Z'
          />
          <path fill='var(--background-primary)' d='M23.625 31.009v-4a.375.375 0 0 1 .75 0v4a.375.375 0 0 1-.75 0Z' />
          <path
            fill='var(--background-primary)'
            d='M28.625 28.509c0-.898-.727-1.625-1.625-1.625a.375.375 0 0 1-.371-.428l.005-.035a2.662 2.662 0 0 0-2.49-3.033L24 23.384a2.66 2.66 0 0 0-2.634 3.037l.005.035a.376.376 0 0 1-.371.428 1.625 1.625 0 1 0 0 3.25h1a.375.375 0 0 1 0 .75h-1a2.375 2.375 0 0 1-.408-4.713A3.411 3.411 0 0 1 24 22.634l.185.005a3.41 3.41 0 0 1 3.222 3.532A2.374 2.374 0 0 1 27 30.884h-1a.375.375 0 0 1 0-.75h1c.898 0 1.625-.728 1.625-1.625Z'
          />
        </>
      );
    case 'navbar-views-icon':
      return (
        <>
          <path
            fill={fill}
            d='M15.63 12.185a.563.563 0 0 1 .35 1.064l-6.758 3.015a.563.563 0 0 1-.459-1.028l6.758-3.014.108-.037Z'
          />
          <path
            fill={fill}
            d='m2.371 12.185.109.037 6.742 3.015a.562.562 0 1 1-.46 1.027l-6.741-3.015-.099-.057a.563.563 0 0 1 .45-1.007ZM15.63 8.45a.563.563 0 0 1 .35 1.064l-6.758 3.014a.563.563 0 0 1-.459-1.027l6.758-3.015.108-.036Z'
          />
          <path
            fill={fill}
            d='m2.371 8.45.109.036 6.742 3.016a.562.562 0 1 1-.46 1.026L2.022 9.514l-.099-.057a.563.563 0 0 1 .45-1.007ZM8.894 1.7a.563.563 0 0 1 .345.036l6.74 3.019a.563.563 0 0 1 0 1.026l-6.76 3.02a.563.563 0 0 1-.346.036L8.761 8.8 2.02 5.78a.563.563 0 0 1 0-1.027l6.76-3.018.113-.037ZM3.627 5.268l5.363 2.4 5.381-2.402-5.362-2.4-5.382 2.402Z'
          />
        </>
      );
    case 'share-icon':
      return (
        <>
          <path
            fill='var(--text-primary)'
            fillRule='evenodd'
            d='M5.348 7.096a1.278 1.278 0 1 0-1.807 1.808 1.278 1.278 0 0 0 1.807-1.808Zm.707-.707a2.278 2.278 0 1 0-3.221 3.222 2.278 2.278 0 0 0 3.221-3.222ZM12.459 3.54a1.278 1.278 0 1 0-1.807 1.808 1.278 1.278 0 0 0 1.807-1.807Zm.707-.706a2.278 2.278 0 1 0-3.221 3.221 2.278 2.278 0 0 0 3.221-3.221ZM12.459 10.652a1.278 1.278 0 1 0-1.807 1.807 1.278 1.278 0 0 0 1.807-1.807Zm.707-.707a2.278 2.278 0 1 0-3.221 3.221 2.278 2.278 0 0 0 3.221-3.221Z'
            clipRule='evenodd'
          />
          <path
            fill='var(--text-primary)'
            fillRule='evenodd'
            d='M10.42 5.01a.5.5 0 0 1-.223.67L6.25 7.654a.5.5 0 1 1-.447-.895L9.75 4.786a.5.5 0 0 1 .67.224ZM9.75 11.214 5.803 9.24l.447-.895 3.947 1.973-.447.895Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'small-filter-updated-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M6.95 13.36c0-.312.253-.565.565-.565h2.93a.565.565 0 0 1 0 1.13h-2.93a.565.565 0 0 1-.565-.565ZM3.88 9.029c0-.312.253-.565.565-.565h9.06a.565.565 0 0 1 0 1.13h-9.06a.565.565 0 0 1-.565-.565ZM1.611 4.64c0-.312.253-.565.565-.565h13.648a.565.565 0 1 1 0 1.13H2.176a.565.565 0 0 1-.565-.565Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'exit-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M6.832 9c0-.31.252-.563.563-.563h7.604a.562.562 0 1 1 0 1.126H7.395A.563.563 0 0 1 6.832 9ZM4.492 14.998c0-.312.231-.565.517-.565h3.244c.285 0 .517.253.517.565 0 .312-.232.565-.517.565H5.009c-.286 0-.517-.253-.517-.565Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M5 3.563A1.04 1.04 0 0 0 3.959 4.6V13.4a1.04 1.04 0 0 0 1.046 1.039.563.563 0 0 1 .005 1.124A2.165 2.165 0 0 1 2.834 13.4V4.6c0-1.195.97-2.163 2.166-2.163h3.207a.563.563 0 0 1 0 1.124H5ZM11.602 5.602c.22-.22.576-.22.796 0l3 3c.22.22.22.576 0 .796l-3 3a.562.562 0 1 1-.796-.796L14.204 9l-2.602-2.602a.562.562 0 0 1 0-.796Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'filter-due-date-icon':
      return (
        <>
          <path
            fill='var(--text-primary)'
            fillRule='evenodd'
            d='M1.5 4.737a3.253 3.253 0 0 1 3.253-3.253h6.493A3.253 3.253 0 0 1 14.5 4.737v6.493a3.253 3.253 0 0 1-3.254 3.253H4.753A3.253 3.253 0 0 1 1.5 11.23V4.737ZM4.753 2.41a2.326 2.326 0 0 0-2.326 2.326v6.493a2.326 2.326 0 0 0 2.326 2.326h6.493a2.326 2.326 0 0 0 2.326-2.326V4.737a2.326 2.326 0 0 0-2.326-2.326H4.753Z'
            clipRule='evenodd'
          />
          <path
            fill='var(--text-primary)'
            d='M1.503 5.19a3.692 3.692 0 0 1 3.692-3.692h5.61a3.692 3.692 0 0 1 3.692 3.692v.936H1.503V5.19Z'
          />
        </>
      );
    case 'template-icon':
      return (
        <>
          <path
            fill='#A29BF3'
            d='M1.128 13.607v-.25a.5.5 0 0 1 1 0v.25a2.5 2.5 0 0 0 2.5 2.5v1l-.18-.005a3.5 3.5 0 0 1-3.32-3.495Zm3.75 2.5a.5.5 0 0 1 0 1h-.25v-1h.25Zm8.75 0v1h-.25a.5.5 0 1 1 0-1h.25Zm3.5-2.5a3.5 3.5 0 0 1-3.5 3.5v-1a2.5 2.5 0 0 0 2.5-2.5v-.25a.5.5 0 0 1 1 0v.25Zm-16-9a3.5 3.5 0 0 1 3.32-3.496l.18-.004h.25a.5.5 0 0 1 0 1h-.25a2.5 2.5 0 0 0-2.5 2.5v.25a.5.5 0 1 1-1 0v-.25Zm16 .25a.5.5 0 1 1-1 0v-.25a2.5 2.5 0 0 0-2.5-2.5h-.25a.5.5 0 0 1 0-1h.25a3.5 3.5 0 0 1 3.5 3.5v.25ZM10.747 16.107a.5.5 0 0 1 0 1H7.51a.5.5 0 1 1 0-1h3.237ZM10.747 1.107a.5.5 0 0 1 0 1H7.51a.5.5 0 1 1 0-1h3.237ZM2.128 10.726a.5.5 0 0 1-1 0V7.489a.5.5 0 0 1 1 0v3.237ZM17.127 10.726a.5.5 0 1 1-1 0V7.489a.5.5 0 0 1 1 0v3.237Z'
          />
          <path
            fill='#483DC6'
            d='M4.994 6.43c0-.655.53-1.186 1.186-1.186h.578c.655 0 1.186.531 1.186 1.186v5.728c0 .655-.531 1.186-1.186 1.186H6.18a1.186 1.186 0 0 1-1.186-1.186V6.43Zm3.802 0c0-.655.531-1.186 1.186-1.186h1.926c.655 0 1.186.531 1.186 1.186v1.96c0 .655-.531 1.186-1.186 1.186H9.982A1.186 1.186 0 0 1 8.796 8.39V6.43Zm0 5.116c0-.655.531-1.186 1.186-1.186h1.926c.655 0 1.186.53 1.186 1.186v.612c0 .655-.531 1.186-1.186 1.186H9.982a1.186 1.186 0 0 1-1.186-1.186v-.612Z'
          />
        </>
      );
    case 'spreadsheet-icon':
      return (
        <>
          <path
            fill='#107C41'
            d='M4.275 12.942c0-.336.272-.608.608-.608h.688c.336 0 .608.272.608.608v.703a.608.608 0 0 1-.608.607h-.688a.608.608 0 0 1-.608-.607v-.703Zm3.046-3.07c0-.335.272-.608.608-.608h3.734c.336 0 .608.273.608.608v.703a.608.608 0 0 1-.608.608H7.93a.608.608 0 0 1-.608-.608v-.703Zm-3.046 0c0-.335.272-.608.608-.608h.688c.336 0 .608.273.608.608v.703a.608.608 0 0 1-.608.608h-.688a.608.608 0 0 1-.608-.608v-.703Zm3.046 3.07c0-.336.272-.608.608-.608h3.734c.336 0 .608.272.608.608v.703a.608.608 0 0 1-.608.607H7.93a.608.608 0 0 1-.608-.607v-.703Z'
          />
          <path
            fill='#107C41'
            d='M1.357 15.871V2.13a1.5 1.5 0 0 1 1.5-1.5h7.545a1.5 1.5 0 0 1 1.1.479l3.947 4.249.091.108c.2.26.31.581.31.913v3.108a.5.5 0 0 1-1 0V6.38a.5.5 0 0 0-.103-.305l-.03-.036-3.948-4.249a.5.5 0 0 0-.367-.16H2.857a.5.5 0 0 0-.5.5v13.742a.5.5 0 0 0 .5.5l10.435.019.051.002a.5.5 0 0 1 0 .995l-.05.003-10.436-.019a1.5 1.5 0 0 1-1.5-1.5Z'
          />
          <path
            fill='#107C41'
            d='M14.85 16.871v-4.118l-.829.829a.5.5 0 0 1-.707-.708l1.682-1.682a.5.5 0 0 1 .707 0l1.682 1.682a.5.5 0 0 1-.707.707l-.828-.828v4.118a.5.5 0 1 1-1 0Z'
          />
        </>
      );
    case 'new-back-arrow-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M11.396 4.59c.22.22.221.578.001.8L7.801 9l3.596 3.61a.565.565 0 1 1-.8.798l-3.994-4.01a.565.565 0 0 1 0-.797l3.994-4.009a.565.565 0 0 1 .799-.002Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'new-large-back-arrow-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M12.775 1.857a.564.564 0 0 0-.798 0l-6.75 6.75a.564.564 0 0 0 0 .798l6.75 6.751a.564.564 0 1 0 .798-.798L6.424 9.006l6.351-6.351a.564.564 0 0 0 0-.798Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'pie-chart-icon':
      return (
        <>
          <g fill={fill} clipPath='url(#clip0_44464_82950)'>
            <path d='M8.31.941c-.478-.073-.873.326-.873.809v3.938c0 .483.392.875.875.875h3.938c.483 0 .882-.395.809-.872A5.692 5.692 0 0 0 8.309.94Z' />
            <path d='M12.838 8.858c.162-.508-.252-.983-.784-.983H7A.875.875 0 0 1 6.125 7V1.946c0-.532-.475-.946-.983-.784a6.125 6.125 0 1 0 7.696 7.696Z' />
          </g>
          <defs>
            <clipPath id='clip0_44464_82950'>
              <path fill='#fff' d='M0 0h14v14H0z' />
            </clipPath>
          </defs>
        </>
      );
    case 'arrow-ne':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M3.828 14.173a.565.565 0 0 1 0-.8l9.545-9.545a.565.565 0 0 1 .8.799l-9.546 9.546a.565.565 0 0 1-.8 0Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M13.773 3.662c.312 0 .565.253.565.565v6.819a.565.565 0 1 1-1.13 0V4.227c0-.312.253-.565.565-.565Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M6.39 4.227c0-.312.252-.565.564-.565h6.819a.565.565 0 0 1 0 1.13H6.954a.565.565 0 0 1-.565-.565Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'my-profile-icon':
      return (
        <>
          <path
            fill='var(--text-primary)'
            fillRule='evenodd'
            d='M7.05 12.256A2.725 2.725 0 0 0 4.306 15a.556.556 0 0 1-1.112 0 3.837 3.837 0 0 1 3.856-3.855h3.825A3.837 3.837 0 0 1 14.731 15a.556.556 0 0 1-1.112 0 2.725 2.725 0 0 0-2.744-2.744H7.05ZM10.859 4.304a2.7 2.7 0 0 0-3.723.006c-1.017.957-.994 2.623.024 3.704.958 1.018 2.623.994 3.705-.024 1.03-.97 1.05-2.624-.006-3.686Zm.775-.815a3.825 3.825 0 0 0-5.269.001C4.832 4.933 4.96 7.317 6.341 8.786c1.443 1.532 3.827 1.405 5.295.024 1.518-1.428 1.5-3.818.014-5.306a.397.397 0 0 0-.008-.008l-.008-.007Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'email-icon':
      return (
        <>
          <path
            fill='var(--text-primary)'
            fillRule='evenodd'
            d='M3.5 4.063A.942.942 0 0 0 2.562 5v8c0 .514.424.938.938.938h11a.942.942 0 0 0 .938-.938V5a.942.942 0 0 0-.938-.938h-11ZM1.437 5c0-1.136.927-2.063 2.063-2.063h11c1.136 0 2.063.927 2.063 2.063v8a2.067 2.067 0 0 1-2.063 2.063h-11A2.067 2.067 0 0 1 1.437 13V5Z'
            clipRule='evenodd'
          />
          <path
            fill='var(--text-primary)'
            fillRule='evenodd'
            d='M1.54 4.677a.562.562 0 0 1 .783-.138L9 9.697l6.678-5.158a.563.563 0 1 1 .645.922l-7 5.25a.563.563 0 0 1-.646 0l-7-5.25a.562.562 0 0 1-.138-.784Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'password-icon':
      return (
        <>
          <path
            fill='var(--text-primary)'
            d='M11.769 7.333v-2.5a2.768 2.768 0 0 0-5.537 0v2.5a.566.566 0 0 1-1.13 0v-2.5a3.9 3.9 0 0 1 7.796 0v2.5a.565.565 0 1 1-1.13 0Z'
          />
          <path
            fill='var(--text-primary)'
            d='M14.269 9c0-.609-.493-1.102-1.102-1.102H4.834c-.609 0-1.102.493-1.102 1.102v5.833c0 .609.493 1.102 1.102 1.102h8.333c.609 0 1.102-.493 1.102-1.102V9Zm1.13 5.833a2.23 2.23 0 0 1-2.232 2.231H4.834a2.232 2.232 0 0 1-2.232-2.231V9c0-1.233 1-2.232 2.232-2.232h8.333c1.233 0 2.231 1 2.231 2.232v5.833Z'
          />
          <path
            fill='var(--text-primary)'
            d='M6.615 11.315c.004 0 .007.002.01.003.015.003.028.008.043.012.023.007.047.012.071.022.021.008.041.02.061.03.055.03.111.063.16.112a.651.651 0 1 1-1.1.576l-.01-.115.01-.115a.647.647 0 0 1 .18-.346.639.639 0 0 1 .158-.111c.02-.011.04-.023.061-.031.021-.009.043-.014.064-.02l.052-.014a.653.653 0 0 1 .125-.013l.115.01Zm-.115 1.28Zm-.113-.01.113.01a.65.65 0 0 1-.121-.013l.008.004Zm.277-.014Zm-.405-.023c.022.009.044.014.066.02-.022-.006-.045-.012-.066-.02Zm.541-.03.05-.028-.05.028Zm-.652-.028c.014.01.03.016.045.024l-.045-.024ZM9.12 11.315l.01.003c.015.003.028.008.042.012.024.007.048.012.072.022.021.008.041.02.061.03.055.03.11.063.16.112a.651.651 0 0 1-.888.95.652.652 0 0 1-.217-.406l-.006-.083.01-.115a.647.647 0 0 1 .18-.346.639.639 0 0 1 .159-.111c.02-.011.04-.023.061-.031.021-.009.043-.014.064-.02l.052-.014a.653.653 0 0 1 .125-.013l.115.01Zm-.115 1.28Zm-.113-.01.113.01a.65.65 0 0 1-.122-.013l.01.004Zm.277-.014Zm-.405-.023c.022.009.044.014.066.02-.022-.006-.045-.012-.066-.02Zm.541-.03.05-.028-.05.028Zm-.653-.028c.015.01.031.016.046.024-.015-.008-.031-.015-.046-.024ZM11.615 11.315l.01.003c.015.003.028.008.043.012.023.007.047.012.071.022.021.008.041.02.061.03.055.03.111.063.16.112a.651.651 0 1 1-1.1.576l-.01-.115.01-.115a.647.647 0 0 1 .18-.346.64.64 0 0 1 .158-.111c.02-.011.04-.023.061-.031.021-.009.043-.014.064-.02l.052-.014a.653.653 0 0 1 .125-.013l.115.01Zm-.115 1.28Zm-.113-.01.113.01a.65.65 0 0 1-.121-.013l.008.004Zm.277-.014Zm-.405-.023c.022.009.044.014.066.02-.022-.006-.045-.012-.066-.02Zm.541-.03.05-.028c-.015.01-.033.019-.05.028Zm-.652-.028c.014.01.03.016.045.024-.015-.008-.031-.015-.045-.024Z'
          />
        </>
      );
    case 'notification-icon':
      return (
        <>
          <path
            fill='var(--text-primary)'
            d='M11.494 2.515a2.823 2.823 0 0 1 3.777-.195l.215.195.193.213a2.824 2.824 0 1 1-4.185-.213Zm3.196.794a1.698 1.698 0 1 0-2.401 2.403 1.698 1.698 0 0 0 2.401-2.403Z'
          />
          <path
            fill='var(--text-primary)'
            d='M1.688 14.25v-9c0-1.14.923-2.063 2.062-2.063h4.5a.563.563 0 0 1 0 1.126h-4.5a.937.937 0 0 0-.938.937v9c0 .518.42.938.938.938h9c.518 0 .938-.42.938-.938v-4.5a.562.562 0 1 1 1.124 0v4.5c0 1.14-.923 2.063-2.062 2.063h-9a2.062 2.062 0 0 1-2.063-2.063Z'
          />
        </>
      );
    case 'security-icon':
      return (
        <>
          <path
            fill='var(--text-primary)'
            d='M1.769 14.157v-.691a3.33 3.33 0 0 1 3.33-3.33h2.764l.115.012a.566.566 0 0 1 0 1.107l-.115.012H5.1c-1.215 0-2.2.984-2.2 2.199v.691a.565.565 0 0 1-1.13 0ZM10.063 5.172a2.2 2.2 0 1 0-4.4.001 2.2 2.2 0 0 0 4.4-.001Zm1.13 0a3.33 3.33 0 1 1-6.66 0 3.33 3.33 0 0 1 6.66 0ZM15.23 12.144a.5.5 0 1 1 1 0 2.737 2.737 0 0 1-2.736 2.736h-.006a2.718 2.718 0 0 1-.802-.134.5.5 0 1 1 .31-.95c.162.053.331.08.501.083a1.735 1.735 0 0 0 1.734-1.735Z'
          />
          <path
            fill='var(--text-primary)'
            d='M15.231 12.144c0-.96-.777-1.737-1.736-1.737a.5.5 0 1 1 0-1 2.737 2.737 0 0 1 2.736 2.737.5.5 0 0 1-1 0Z'
          />
          <path
            fill='var(--text-primary)'
            d='M13.496 9.407a.5.5 0 0 1 0 1c-.959 0-1.736.778-1.736 1.737.003.168.03.336.083.497a.5.5 0 1 1-.95.308 2.708 2.708 0 0 1-.133-.799v-.006a2.737 2.737 0 0 1 2.736-2.737Z'
          />
          <path
            fill='var(--text-primary)'
            d='M12.487 13.918a.5.5 0 0 1 .708.707l-1.209 1.21a1.09 1.09 0 0 1-.667.317l-.108.006h-.634a1.096 1.096 0 0 1-1.09-.984l-.006-.113v-.631l.006-.108a1.1 1.1 0 0 1 .314-.665l1.213-1.215a.5.5 0 0 1 .707.707L10.51 14.36v.001a.101.101 0 0 0-.029.07v.63l.008.038a.096.096 0 0 0 .088.059h.635c.024 0 .048-.01.065-.027l.001-.002 1.21-1.211ZM13.599 11.622a.531.531 0 0 1 .428.523l-.01.106a.533.533 0 0 1-1.043 0l-.011-.107.01-.107a.533.533 0 0 1 .521-.426l.105.011Z'
          />
        </>
      );
    case 'refer-earn-icon':
      return (
        <>
          <path
            fill='var(--text-primary)'
            d='M8.437 11.249v-.76A1.648 1.648 0 0 0 6.76 8.812H4.49a1.648 1.648 0 0 0-1.678 1.677v.76a.562.562 0 1 1-1.125 0v-.75a2.773 2.773 0 0 1 2.812-2.812h2.25A2.772 2.772 0 0 1 9.562 10.5v.75a.562.562 0 1 1-1.125 0ZM15.188 11.249v-.76a1.648 1.648 0 0 0-1.677-1.677H12a.562.562 0 1 1 0-1.125h1.5a2.772 2.772 0 0 1 2.813 2.812v.75a.562.562 0 1 1-1.125 0ZM6.938 4.125a1.313 1.313 0 1 0-2.626 0 1.313 1.313 0 0 0 2.625 0Zm1.125 0a2.438 2.438 0 1 1-4.876 0 2.438 2.438 0 0 1 4.876 0ZM13.688 4.5a.937.937 0 1 0-1.875 0 .937.937 0 0 0 1.874 0Zm1.124 0a2.062 2.062 0 1 1-4.124 0 2.062 2.062 0 0 1 4.124 0ZM13.501 12.563l.113.011a.563.563 0 0 1 0 1.102l-.113.011h-1.944a.563.563 0 0 1 0-1.124H13.5Z'
          />
          <path
            fill='var(--text-primary)'
            d='M12.938 15.042v-1.917a.562.562 0 1 1 1.124 0v1.917a.562.562 0 1 1-1.124 0Z'
          />
          <path
            fill='var(--text-primary)'
            d='M4.231 12.667a.563.563 0 0 1 .699.131l.064.095.152.258a4.4 4.4 0 0 0 7.574-.258.563.563 0 0 1 .988.537 5.524 5.524 0 0 1-9.51.325l-.192-.325-.044-.105a.563.563 0 0 1 .27-.658Z'
          />
        </>
      );
    case 'organization-icon':
      return (
        <>
          <path
            fill='var(--text-primary)'
            d='M10.448 15.087V3.6a.11.11 0 0 0-.111-.11H4.283a.11.11 0 0 0-.11.11v11.486a.566.566 0 0 1-1.131 0V3.6c0-.686.556-1.242 1.241-1.242h6.054c.685 0 1.241.556 1.241 1.242v11.486a.566.566 0 0 1-1.13 0Z'
          />
          <path
            fill='var(--text-primary)'
            d='M13.827 15.088V6.245a.052.052 0 0 0-.052-.052h-2.761a.566.566 0 0 1 0-1.13h2.761c.653 0 1.182.53 1.182 1.182v8.843a.564.564 0 0 1-1.13 0Z'
          />
          <path
            fill='var(--text-primary)'
            d='m12.255 7.64.113.011a.565.565 0 0 1 0 1.108l-.113.012h-.69a.566.566 0 0 1 0-1.131h.69ZM12.255 9.77l.113.012a.565.565 0 0 1 0 1.108l-.113.011h-.69a.566.566 0 0 1 0-1.13h.69ZM12.255 11.901l.113.012a.565.565 0 0 1 0 1.107l-.113.012h-.69a.566.566 0 0 1 0-1.13h.69ZM8.323 5.13l.114.012a.565.565 0 0 1 0 1.107l-.114.012H6.296a.566.566 0 0 1 0-1.131h2.027ZM8.323 7.76l.114.012a.565.565 0 0 1 0 1.108l-.114.012H6.296a.566.566 0 0 1 0-1.131h2.027ZM8.323 10.392l.114.011a.565.565 0 0 1 0 1.108l-.114.012H6.296a.566.566 0 0 1 0-1.131h2.027ZM6.746 15.088v-1.352a.566.566 0 0 1 1.13 0v1.352a.565.565 0 0 1-1.13 0Z'
          />
          <path
            fill='var(--text-primary)'
            d='m15.757 14.521.114.012a.566.566 0 0 1 0 1.108l-.114.011H2.243a.566.566 0 0 1 0-1.13h13.514Z'
          />
        </>
      );
    case 'templates-icon':
      return (
        <>
          <path
            fill='var(--text-primary)'
            fillRule='evenodd'
            d='M1.686 5.248a3.564 3.564 0 0 1 3.563-3.563h7.503a3.564 3.564 0 0 1 3.564 3.563v6.57c0 .747-.296 1.463-.823 1.99l-1.463 1.463a3.563 3.563 0 0 1-2.52 1.044H5.25a3.564 3.564 0 0 1-3.564-3.564V5.248ZM5.249 2.81a2.439 2.439 0 0 0-2.438 2.438v7.503a2.439 2.439 0 0 0 2.438 2.44h6.26c.647 0 1.267-.257 1.725-.715l1.463-1.464c.316-.316.494-.745.494-1.193v-6.57a2.439 2.439 0 0 0-2.439-2.44H5.25Z'
            clipRule='evenodd'
          />
          <path
            fill='var(--text-primary)'
            fillRule='evenodd'
            d='M5.438 7.015c0-.311.251-.563.562-.563h6a.562.562 0 1 1 0 1.125H6a.563.563 0 0 1-.563-.562ZM5.438 10.396c0-.311.251-.563.562-.563h3a.562.562 0 1 1 0 1.125H6a.562.562 0 0 1-.563-.563ZM12.753 11.813a.938.938 0 0 0-.938.939v3a.563.563 0 0 1-1.125 0v-3c0-1.14.923-2.064 2.063-2.064h3a.562.562 0 1 1 0 1.125h-3Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'invoicing-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M5.356 11.907c0-.312.253-.565.565-.565h4.17a.565.565 0 0 1 0 1.13h-4.17a.565.565 0 0 1-.565-.565ZM5.356 8.83c0-.312.253-.565.565-.565h6.594a.565.565 0 0 1 0 1.13H5.92a.565.565 0 0 1-.565-.565Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M14.366 1.726A1.334 1.334 0 0 1 15.72 3.06V14.6a1.334 1.334 0 0 1-1.931 1.193l-.594-.297a.205.205 0 0 0-.183 0l-1.362.681a1.335 1.335 0 0 1-1.194 0l-1.364-.681a.204.204 0 0 0-.182 0l-1.364.68a1.333 1.333 0 0 1-1.194.001l-1.364-.681a.204.204 0 0 0-.182 0l-.593.296A1.334 1.334 0 0 1 2.281 14.6V3.06a1.334 1.334 0 0 1 1.317-1.333h10.767Zm.127 1.16a.204.204 0 0 0-.111-.03H3.61a.204.204 0 0 0-.2.204V14.6a.204.204 0 0 0 .296.182l.593-.297a1.332 1.332 0 0 1 1.194 0l1.363.681a.204.204 0 0 0 .182 0l1.364-.68s0-.001 0 0a1.333 1.333 0 0 1 1.194-.001l1.364.681a.205.205 0 0 0 .183 0l1.362-.681a1.334 1.334 0 0 1 1.194 0l.594.297a.205.205 0 0 0 .296-.183V3.06a.204.204 0 0 0-.097-.173Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M5.433 6c0-.312.253-.565.565-.565h6.431a.565.565 0 0 1 0 1.13H5.998A.565.565 0 0 1 5.433 6Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'online-payment-icon':
      return (
        <>
          <path
            fill='var(--text-primary)'
            fillRule='evenodd'
            d='M1.688 6.75c0-.31.251-.563.562-.563h13.5a.562.562 0 1 1 0 1.125H2.25a.563.563 0 0 1-.563-.562ZM4.688 9.75c0-.31.251-.563.562-.563h1.928a.563.563 0 0 1 0 1.126H5.25a.562.562 0 0 1-.563-.563Z'
            clipRule='evenodd'
          />
          <path
            fill='var(--text-primary)'
            fillRule='evenodd'
            d='M4.5 4.313c-.932 0-1.688.755-1.688 1.687v6c0 .932.756 1.688 1.688 1.688h9c.932 0 1.688-.756 1.688-1.688V6c0-.932-.756-1.688-1.688-1.688h-9ZM1.687 6A2.812 2.812 0 0 1 4.5 3.187h9A2.812 2.812 0 0 1 16.313 6v6a2.812 2.812 0 0 1-2.813 2.813h-9A2.812 2.812 0 0 1 1.687 12V6Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'subscription-icon':
      return (
        <>
          <path
            fill='var(--text-primary)'
            d='M8.24 6.098v-.98a.565.565 0 1 1 1.13 0v.98a.566.566 0 0 1-1.13 0ZM8.24 12.948v-.98a.565.565 0 1 1 1.13 0v.98a.566.566 0 0 1-1.13 0Z'
          />
          <path
            fill='var(--text-primary)'
            d='M7.419 10.562c.031.474.42.844.894.844h1.074a.808.808 0 0 0 .196-1.594l-1.834-.46a1.94 1.94 0 0 1 .472-3.82h1.072c1.08 0 1.95.842 2.022 1.897a.565.565 0 0 1-1.109.188l-.018-.113-.011-.087a.897.897 0 0 0-.884-.755H8.221a.808.808 0 0 0-.197 1.594l1.834.46a1.94 1.94 0 0 1-.471 3.82H8.313a2.03 2.03 0 0 1-2.022-1.901l.564-.036.564-.037Zm-.6-.528c.31-.02.58.216.6.527l-1.128.074a.566.566 0 0 1 .527-.6Z'
          />
          <path
            fill='var(--text-primary)'
            d='M15.226 9.034a6.223 6.223 0 0 0-6.225-6.22c-1.719 0-3.274.695-4.4 1.822a.565.565 0 0 1-.8-.8 7.354 7.354 0 0 1 12.555 5.198c0 .57-.071 1.12-.191 1.646a.565.565 0 0 1-1.102-.252c.103-.453.163-.918.163-1.394Z'
          />
          <path
            fill='var(--text-primary)'
            d='M16.618 9.105a.566.566 0 0 1 .8.8L16.19 11.13a.565.565 0 0 1-.799 0l-1.226-1.227a.565.565 0 1 1 .798-.799l.828.828.827-.828ZM1.644 9.031c0-.57.07-1.12.191-1.645a.565.565 0 0 1 1.102.252 6.235 6.235 0 0 0-.163 1.393 6.222 6.222 0 0 0 6.224 6.221c1.72 0 3.275-.696 4.401-1.822a.565.565 0 0 1 .8.8A7.354 7.354 0 0 1 1.643 9.032Z'
          />
          <path
            fill='var(--text-primary)'
            d='M1.809 6.935c.22-.22.578-.22.799 0l1.227 1.227a.565.565 0 0 1-.8.799l-.827-.827-.827.827a.565.565 0 1 1-.799-.799L1.81 6.935Z'
          />
        </>
      );
    case 'api-icon':
      return (
        <>
          <path
            fill='var(--text-primary)'
            fillRule='evenodd'
            d='M10.46 2.749c.303.069.493.37.424.673l-2.67 11.703a.563.563 0 0 1-1.097-.25l2.67-11.703a.563.563 0 0 1 .673-.423ZM13.102 5.602c.22-.22.576-.22.796 0l3 3c.22.22.22.576 0 .796l-3 3a.562.562 0 1 1-.796-.796L15.704 9l-2.602-2.602a.562.562 0 0 1 0-.796ZM4.898 5.602c.22.22.22.576 0 .796L2.296 9l2.602 2.602a.562.562 0 1 1-.796.796l-3-3a.563.563 0 0 1 0-.796l3-3c.22-.22.576-.22.796 0Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'integrations-icon':
      return (
        <>
          <path
            fill='var(--text-primary)'
            d='M6.938 3.75A.937.937 0 0 0 6 2.812H3.75a.937.937 0 0 0-.938.938V6c0 .518.42.938.938.938H6c.518 0 .938-.42.938-.938V3.75ZM8.063 6c0 1.14-.924 2.063-2.063 2.063H3.75A2.062 2.062 0 0 1 1.687 6V3.75c0-1.14.924-2.063 2.063-2.063H6c1.14 0 2.063.924 2.063 2.063V6ZM15.188 12a.937.937 0 0 0-.938-.938H12a.937.937 0 0 0-.938.938v2.25c0 .518.42.938.938.938h2.25c.518 0 .938-.42.938-.938V12Zm1.124 2.25c0 1.14-.923 2.063-2.062 2.063H12a2.062 2.062 0 0 1-2.063-2.063V12c0-1.14.924-2.063 2.063-2.063h2.25c1.14 0 2.063.924 2.063 2.063v2.25ZM6.938 12A.937.937 0 0 0 6 11.062H3.75a.937.937 0 0 0-.938.938v2.25c0 .518.42.938.938.938H6c.518 0 .938-.42.938-.938V12Zm1.125 2.25c0 1.14-.924 2.063-2.063 2.063H3.75a2.062 2.062 0 0 1-2.063-2.063V12c0-1.14.924-2.063 2.063-2.063H6c1.14 0 2.063.924 2.063 2.063v2.25ZM12.563 6.749v-3.75a.562.562 0 1 1 1.124 0v3.75a.562.562 0 1 1-1.124 0Z'
          />
          <path fill='var(--text-primary)' d='M15 4.312a.562.562 0 1 1 0 1.125h-3.75a.562.562 0 1 1 0-1.125H15Z' />
        </>
      );
    case 'apps-icon':
      return (
        <>
          <path
            fill='var(--text-primary)'
            fillRule='evenodd'
            d='M1.595 3.3c0-.942.763-1.705 1.705-1.705h3.04c.941 0 1.705.763 1.705 1.705v3.04c0 .941-.764 1.705-1.705 1.705H3.3A1.705 1.705 0 0 1 1.595 6.34V3.3ZM3.3 2.725a.575.575 0 0 0-.575.575v3.04c0 .317.257.575.575.575h3.04a.575.575 0 0 0 .575-.575V3.3a.575.575 0 0 0-.575-.575H3.3ZM9.954 3.3c0-.942.763-1.705 1.705-1.705h3.04c.942 0 1.705.763 1.705 1.705v3.04c0 .941-.763 1.705-1.705 1.705h-3.04A1.705 1.705 0 0 1 9.954 6.34V3.3Zm1.705-.575a.575.575 0 0 0-.575.575v3.04c0 .317.258.575.575.575h3.04a.575.575 0 0 0 .575-.575V3.3a.575.575 0 0 0-.575-.575h-3.04ZM9.954 11.66c0-.942.763-1.705 1.705-1.705h3.04c.942 0 1.705.763 1.705 1.705v3.04c0 .942-.763 1.705-1.705 1.705h-3.04A1.705 1.705 0 0 1 9.954 14.7v-3.04Zm1.705-.575a.575.575 0 0 0-.575.575v3.04c0 .318.258.575.575.575h3.04a.575.575 0 0 0 .575-.575v-3.04a.575.575 0 0 0-.575-.575h-3.04ZM1.595 11.66c0-.942.763-1.705 1.705-1.705h3.04c.941 0 1.705.763 1.705 1.705v3.04c0 .942-.764 1.705-1.705 1.705H3.3A1.705 1.705 0 0 1 1.595 14.7v-3.04Zm1.705-.575a.575.575 0 0 0-.575.575v3.04c0 .318.257.575.575.575h3.04a.575.575 0 0 0 .575-.575v-3.04a.575.575 0 0 0-.575-.575H3.3Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'usage-icon':
      return (
        <>
          <path
            fill='var(--text-primary)'
            d='M15.188 9A6.187 6.187 0 1 0 2.812 9a6.187 6.187 0 1 0 12.376 0Zm1.124 0A7.312 7.312 0 0 1 9 16.313 7.312 7.312 0 0 1 1.687 9 7.312 7.312 0 0 1 9 1.687 7.312 7.312 0 0 1 16.313 9Z'
          />
          <path
            fill='var(--text-primary)'
            d='M8.49 2.266a.563.563 0 0 1 1.125 0v5.73l4.947-2.858a.563.563 0 0 1 .562.974l-5.79 3.345a.563.563 0 0 1-.844-.487V2.266Z'
          />
        </>
      );
    case 'display-icon':
      return (
        <>
          <path
            fill='var(--text-primary)'
            d='M13.43 4.758a.188.188 0 0 0-.188-.188H11.38c-.349 0-.683-.139-.93-.385L9.133 2.867a.188.188 0 0 0-.266 0L7.55 4.185c-.247.246-.581.385-.93.385H4.758a.188.188 0 0 0-.188.188V6.64c0 .336-.134.658-.372.896l-1.33 1.331a.188.188 0 0 0 0 .266l1.318 1.317c.246.247.384.58.384.929v1.863c0 .104.084.188.188.188H6.62c.349 0 .683.139.93.385l1.317 1.318a.188.188 0 0 0 .266 0l1.317-1.318c.247-.247.58-.385.929-.385h1.863a.188.188 0 0 0 .188-.188V11.38c0-.349.139-.683.385-.93l1.318-1.317a.188.188 0 0 0 0-.266L13.815 7.55a1.314 1.314 0 0 1-.385-.929V4.758Zm1.125 1.863c0 .05.02.098.055.133l1.318 1.318a1.312 1.312 0 0 1 0 1.856l-1.318 1.317a.19.19 0 0 0-.055.135v1.862c0 .725-.588 1.313-1.313 1.313H11.38c-.05 0-.098.02-.133.055l-1.318 1.318a1.312 1.312 0 0 1-1.856 0L6.755 14.61a.19.19 0 0 0-.135-.055H4.758a1.312 1.312 0 0 1-1.313-1.313V11.38c0-.05-.02-.098-.055-.133L2.072 9.928a1.312 1.312 0 0 1 0-1.856l1.331-1.33a.144.144 0 0 0 .042-.102V4.758c0-.725.588-1.313 1.313-1.313H6.62l.073-.014a.19.19 0 0 0 .062-.041l1.317-1.318a1.312 1.312 0 0 1 1.856 0l1.317 1.318a.191.191 0 0 0 .135.055h1.862c.725 0 1.313.588 1.313 1.313V6.62Z'
          />
          <path
            fill='var(--text-primary)'
            d='M11.438 9c0-1.152-.8-2.116-1.876-2.37v4.74A2.436 2.436 0 0 0 11.438 9Zm1.124 0A3.563 3.563 0 0 1 9 12.563.562.562 0 0 1 8.437 12V6c0-.31.252-.563.563-.563A3.563 3.563 0 0 1 12.563 9Z'
          />
        </>
      );
    case 'team-timeline-icon':
      return (
        <>
          <path
            fill={fill}
            d='M8.477 5.828a.563.563 0 0 1 1.125 0v3.026l2.357 1.437.09.068a.563.563 0 0 1-.573.942l-.103-.049L8.746 9.65a.563.563 0 0 1-.27-.48V5.828Z'
          />
          <path
            fill={fill}
            d='M2.625 6.37a7.025 7.025 0 1 1 8.23 9.18.562.562 0 1 1-.257-1.095l.255-.066a5.9 5.9 0 1 0-7.167-7.644.562.562 0 1 1-1.06-.375ZM3.717 14.07a1.013 1.013 0 0 0-.907 1.005v.115h4.502v-.115l-.005-.103a1.013 1.013 0 0 0-.902-.902l-.103-.005H3.82l-.103.005Zm4.72 1.308c0 .518-.42.937-.938.937H2.622a.938.938 0 0 1-.937-.937v-.307l.011-.217a2.138 2.138 0 0 1 2.12-1.914h2.489l.217.011a2.138 2.138 0 0 1 1.915 2.12v.307Z'
          />
          <path
            fill={fill}
            d='M5.056 8.063a2.063 2.063 0 1 1 .01 4.125 2.063 2.063 0 0 1-.01-4.125Zm.003 1.125a.938.938 0 1 0 .005 1.876.938.938 0 0 0-.005-1.876Z'
          />
        </>
      );
    case 'magic-icon':
      return (
        <>
          <path
            fill={fill}
            d='M12.085 13.078a.43.43 0 0 0 .607 0l.385-.385a.43.43 0 0 0 0-.608L6.466 5.474a.43.43 0 0 0-.608 0l-.385.385a.43.43 0 0 0 0 .607l6.612 6.612ZM4.763 7.177a1.434 1.434 0 0 1 0-2.028l.385-.385c.56-.56 1.469-.56 2.029 0l6.611 6.61c.56.56.56 1.47 0 2.03l-.385.385c-.56.56-1.468.559-2.028-.001L4.763 7.177ZM10.041 4.214V2.948a.503.503 0 0 1 1.004 0v1.266a.503.503 0 1 1-1.004 0Z'
          />
          <path
            fill={fill}
            d='M11.175 3.079a.503.503 0 0 1 0 1.004H9.909a.502.502 0 1 1 0-1.004h1.265ZM3.078 11.175V9.909a.503.503 0 0 1 1.004 0v1.266a.502.502 0 1 1-1.004 0Z'
          />
          <path
            fill={fill}
            d='M4.214 10.041a.503.503 0 0 1 0 1.004H2.948a.503.503 0 1 1 0-1.004h1.266ZM2.445 3.58V2.314a.503.503 0 0 1 1.005 0V3.58a.502.502 0 1 1-1.005 0Z'
          />
          <path
            fill={fill}
            d='M3.58 2.445a.503.503 0 0 1 0 1.005H2.316a.502.502 0 1 1 0-1.005h1.266ZM7.36 5.658a.502.502 0 1 1 .71.71L6.367 8.07a.502.502 0 0 1-.71-.71L7.36 5.658Z'
          />
        </>
      );
    case 'check-icon':
      return (
        <>
          <path
            fill='var(--text-secondary)'
            fillRule='evenodd'
            d='M13.687 3.98a.5.5 0 0 1 0 .707L6.353 12.02a.5.5 0 0 1-.707 0L2.313 8.687a.5.5 0 0 1 .707-.707L6 10.96l6.98-6.98a.5.5 0 0 1 .707 0Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'workspace-icon':
      return (
        <>
          <path
            fill={fill}
            d='M0 6.117c0-.788.56-1.464 1.335-1.609l19.9-3.73a1.636 1.636 0 0 1 1.937 1.608v32.382a.818.818 0 0 1-.818.818H1.636A1.636 1.636 0 0 1 0 33.95V6.117ZM24.827 9.296c0-.524.485-.912.996-.799l8.895 1.977c.75.166 1.282.83 1.282 1.597V33.95c0 .904-.733 1.636-1.637 1.636h-8.717a.818.818 0 0 1-.819-.818V9.296Z'
          />
          <rect width={9.103} height={4.138} x={7.034} y={11.586} fill='var(--background-primary)' rx={0.818} />
          <rect width={9.103} height={4.138} x={7.034} y={18.621} fill='var(--background-primary)' rx={0.828} />
          <rect width={9.103} height={4.138} x={7.034} y={25.655} fill='var(--background-primary)' rx={0.818} />
        </>
      );
    case 'ai-icon':
      return (
        <>
          <path
            fill={fill}
            d='M11.962 1.498h-.61A2.134 2.134 0 0 1 9.22 3.63v.61a2.134 2.134 0 0 1 2.133 2.133h.61a2.134 2.134 0 0 1 2.133-2.133v-.61a2.134 2.134 0 0 1-2.133-2.133ZM1.904 7.594c1.806 0 2.845 1.016 2.845 2.844h.812c0-1.828 1.016-2.844 2.845-2.844V6.78c-1.829 0-2.845-1.016-2.845-2.845H4.75c0 1.829-1.016 2.845-2.845 2.845v.813Zm8.432 6.908a2.134 2.134 0 0 1 2.134-2.133v-.61a2.134 2.134 0 0 1-2.134-2.133h-.61a2.134 2.134 0 0 1-2.133 2.133v.61a2.134 2.134 0 0 1 2.134 2.133h.61Z'
          />
        </>
      );
    case 'credit-icon':
      return (
        <>
          <path
            fill='var(--text-primary)'
            d='M8.313 7c0-.05-.022-.137-.145-.257-.124-.123-.326-.253-.611-.372-.569-.237-1.384-.393-2.308-.393-.923 0-1.739.156-2.307.393-.285.119-.488.25-.612.372-.123.12-.145.207-.145.256 0 .05.022.136.145.256.124.123.327.253.612.372.568.237 1.384.394 2.307.394.924 0 1.74-.157 2.308-.394.285-.12.487-.25.611-.372.123-.12.145-.207.145-.256Zm.875 0c0 .353-.174.65-.405.879-.23.227-.541.41-.89.556-.698.291-1.634.46-2.644.46-1.01 0-1.945-.169-2.644-.46-.348-.145-.659-.33-.89-.556-.23-.228-.405-.526-.405-.88 0-.353.174-.651.406-.88.23-.226.54-.41.89-.555.698-.291 1.633-.461 2.643-.461 1.01 0 1.946.17 2.644.46.349.146.66.33.89.557.231.228.405.526.405.88Z'
          />
          <path
            fill='var(--text-primary)'
            d='M1.31 9.042a.438.438 0 0 1 .875 0c0 .05.022.136.145.256.124.123.327.254.612.373.568.236 1.384.393 2.307.393.924 0 1.74-.157 2.308-.393.285-.12.487-.25.611-.373.123-.12.145-.206.145-.256a.438.438 0 0 1 .875 0c0 .354-.174.652-.405.88-.23.227-.541.41-.89.556-.699.291-1.634.461-2.644.461-1.01 0-1.945-.17-2.644-.461-.348-.145-.659-.33-.89-.556-.23-.228-.405-.526-.405-.88Z'
          />
          <path
            fill='var(--text-primary)'
            d='M1.31 9.042V7a.437.437 0 1 1 .875 0v2.043c0 .05.022.136.145.257.124.123.327.253.612.372.568.236 1.384.393 2.307.393.924 0 1.74-.157 2.308-.393.285-.12.487-.25.611-.372.123-.12.145-.207.145-.257V7a.437.437 0 1 1 .875 0v2.043c0 .354-.174.652-.405.88-.23.227-.541.41-.89.556-.699.291-1.633.461-2.644.461-1.01 0-1.945-.17-2.644-.461-.348-.145-.659-.33-.89-.556-.23-.228-.405-.526-.405-.88Z'
          />
          <path
            fill='var(--text-primary)'
            d='M11.815 7a.438.438 0 0 1 .875 0c0 .353-.174.65-.406.879-.23.227-.54.41-.889.556-.699.291-1.634.461-2.644.461a.438.438 0 0 1 0-.875c.923 0 1.74-.157 2.308-.393.285-.12.487-.25.61-.373.124-.12.146-.207.146-.256Z'
          />
          <path
            fill='var(--text-primary)'
            d='M11.815 7V4.957a.438.438 0 0 1 .875 0V7c0 .354-.174.651-.406.88-.23.226-.54.41-.889.556-.699.29-1.634.46-2.644.46a.437.437 0 1 1 0-.874c.923 0 1.739-.157 2.308-.394.285-.119.487-.249.61-.371.124-.121.146-.208.146-.257Z'
          />
          <path
            fill='var(--text-primary)'
            d='M11.815 4.958c0-.049-.022-.135-.145-.256-.124-.123-.327-.253-.612-.372-.569-.237-1.385-.394-2.307-.394-.922 0-1.738.157-2.307.394-.285.12-.487.25-.612.372-.113.111-.14.193-.144.243.01.105.058.202.138.27a.437.437 0 1 1-.57.664 1.279 1.279 0 0 1-.444-.921c0-.354.175-.652.406-.88.23-.227.541-.41.89-.556.699-.291 1.634-.461 2.643-.461 1.01 0 1.944.17 2.643.461.349.145.66.33.89.556.231.228.406.526.406.88s-.175.651-.406.88c-.23.226-.541.41-.89.555-.699.291-1.634.461-2.643.461-.096 0-.21 0-.319-.007a.438.438 0 0 1 .055-.873c.077.005.162.005.264.005.922 0 1.738-.157 2.307-.394.285-.119.488-.249.612-.371.123-.121.145-.208.145-.256Z'
          />
        </>
      );
    case 'workload-icon':
      return (
        <>
          <path fill={fill} d='M1.688 15.75V2.25a.563.563 0 0 1 1.125 0v13.5a.562.562 0 1 1-1.126 0Z' />
          <path
            fill={fill}
            d='M10.688 11.313H2.811v2.374H10.5a.188.188 0 0 0 .188-.187v-2.188Zm1.124 2.187c0 .725-.587 1.313-1.312 1.313H2.25a.562.562 0 0 1-.563-.563v-3.5c0-.31.252-.563.563-.563h9c.31 0 .563.252.563.563v2.75Z'
          />
          <path
            fill={fill}
            d='M15.188 8A.188.188 0 0 0 15 7.812H2.812v2.375H15a.188.188 0 0 0 .188-.187V8Zm1.124 2c0 .725-.587 1.313-1.312 1.313H2.25a.562.562 0 0 1-.563-.563v-3.5c0-.31.252-.563.563-.563H15c.725 0 1.313.588 1.313 1.313v2Z'
          />
          <path
            fill={fill}
            d='M12.938 4.5a.188.188 0 0 0-.188-.188H2.812v2.375h10.126V4.5Zm1.124 2.75c0 .31-.251.563-.562.563H2.25a.563.563 0 0 1-.563-.563v-3.5c0-.31.252-.563.563-.563h10.5c.725 0 1.313.588 1.313 1.313v2.75Z'
          />
        </>
      );
    case 'percentage-icon':
      return (
        <>
          <path
            fill={fill}
            d='M9.638 12.645v-.616A2.6 2.6 0 0 1 9.9 10.86c.179-.357.437-.643.776-.855.342-.217.756-.325 1.243-.325.495 0 .909.108 1.243.325.335.212.588.498.76.855.17.354.256.744.256 1.17v.615c0 .426-.088.818-.263 1.175a2.072 2.072 0 0 1-.764.856c-.335.213-.745.32-1.232.32-.494 0-.91-.107-1.249-.32a2.112 2.112 0 0 1-.77-.856 2.636 2.636 0 0 1-.262-1.175Zm1.163-.616v.616c0 .354.084.671.251.953.168.277.457.416.867.416.4 0 .68-.139.844-.416.168-.282.251-.6.251-.953v-.616c0-.353-.08-.669-.24-.946-.159-.282-.444-.422-.855-.422-.4 0-.686.14-.861.422a1.767 1.767 0 0 0-.257.946Zm-6.98-6.068v-.616a2.6 2.6 0 0 1 .262-1.17c.178-.357.437-.642.775-.855.343-.217.757-.325 1.244-.325.494 0 .908.108 1.243.325.335.213.587.498.759.856.17.353.256.743.256 1.169v.616c0 .426-.087.817-.262 1.175a2.072 2.072 0 0 1-.764.855c-.335.213-.746.32-1.232.32-.495 0-.911-.107-1.25-.32a2.112 2.112 0 0 1-.77-.855A2.636 2.636 0 0 1 3.82 5.96Zm1.163-.616v.616c0 .354.083.671.25.952.168.278.457.417.868.417.399 0 .68-.14.844-.417.167-.281.25-.598.25-.952v-.616c0-.354-.08-.67-.239-.947-.16-.281-.445-.422-.855-.422-.4 0-.687.14-.862.422a1.767 1.767 0 0 0-.256.947Zm-.73 9.49 8.03-11.68h1.3l-8.03 11.68h-1.3Z'
          />
        </>
      );
    case 'link-open-icon':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M16.105 1.816a.557.557 0 0 1 .218.446v5.257a.563.563 0 1 1-1.126 0V3.62L9.399 9.42a.563.563 0 0 1-.797-.796L14.4 2.825h-3.897a.563.563 0 1 1 0-1.127h5.257a.57.57 0 0 1 .345.118Zm0 0A.56.56 0 0 0 15.8 1.7l.304.116Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M1.678 3.764c0-1.141.924-2.066 2.065-2.066h3.004a.563.563 0 0 1 0 1.127H3.743a.938.938 0 0 0-.939.939v10.514c0 .519.42.939.94.939h10.514c.518 0 .938-.42.938-.939v-3.004a.563.563 0 0 1 1.127 0v3.004a2.065 2.065 0 0 1-2.066 2.065H3.744a2.065 2.065 0 0 1-2.065-2.065V3.764Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'wireframe-icon':
      return (
        <>
          <path
            d='m61.573 9 8-8 8 8'
            stroke={stroke}
            strokeWidth={2}
            strokeLinecap='round'
            strokeLinejoin='round'
            fill='none'
          />
          <path d='M69.6 1.672s.4 31-19.6 54-45 19-45 19' stroke={stroke} strokeWidth={2} fill='none' />
          <path
            d='M9 74a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z'
            fill={fill}
            stroke={stroke}
            strokeWidth={2}
            className='circle-fill'
          />
        </>
      );
    case 'wireframe-mobile-icon':
      return (
        <>
          <path
            stroke={stroke}
            fill='none'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={1.6}
            d='m72.803 56.8 6.4 6.4 6.4-6.4'
          />
          <path stroke={stroke} fill='none' strokeWidth={1.6} d='M79.224 62.662s0-58.4-71.853-58.4' />
          <path fill='none' stroke={stroke} strokeWidth={1.6} d='M4 7.462a3.2 3.2 0 1 0 0-6.4 3.2 3.2 0 0 0 0 6.4Z' />
        </>
      );
    default:
      return <path />;
  }
};

interface SVGIconProps {
  name?: string;
  style?: React.CSSProperties;
  fill?: string;
  viewBox?: string;
  height?: string | number;
  width?: string | number;
  className?: string;
  strokeWidth?: number;
  bgfill?: string;
  stroke?: string;
  stopColor?: string;
  iconprimary?: string;
}

const SVGIcon: React.FC<SVGIconProps> = ({
  name = '',
  style = {},
  fill = '',
  viewBox = '',
  height = '24',
  width = '24',
  className = '',
  strokeWidth = 1.5,
  bgfill = 'none',
  stroke = '',
  stopColor = '',
  iconprimary = 'var(--brand-primary)'
}: SVGIconProps) => (
  <svg
    stroke={stroke}
    width={width}
    height={height}
    className={className}
    xmlns='http://www.w3.org/2000/svg'
    viewBox={viewBox || '0 0 24 24'}
    xmlnsXlink='http://www.w3.org/1999/xlink'>
    {getPath(name, { fill, strokeWidth, bgfill, stroke, stopColor, iconprimary })}
  </svg>
);

export default SVGIcon;
